export default {
  main: {
    demoMode: "Режим демонстрации",
    selectValue: "Выбор значения",
    refresh: "Обновить",
    name: "Наименование",
    article: "Артикул",
    brand: "Бренд",
    costInRubles: "Себест, ₽",
    costMarkupInRubles: "Желаемая цена, ₽",
    minSalePriceInRubles: "Мин. цена, ₽",
    countInPieces: "Кол-во, шт",
    save: "Сохранить",
    saveAndExit: "Сохранить и выйти",
    check: "Проверить",
    saveAndCheckCorrectness: "Сохранить и проверить данные",
    uploadFilesManually: "Ручной импорт товаров",
    importProductsFromEmail: "Импорт товаров через email",
    status: "Статус",
    next: "Далее",
    finish: "Завершить",
    dontShowAgain: "Больше не показывать",
    ok: "ОК",
    cancel: "Отменить",
    continue: "Продолжить",
    saved: "Сохранено!",
    scrollToTop: "Прокрутить вверх",
    noData: "Нет данных",
    logOut: "Выйти из аккаунта",
    // При единой авторизации кука одна на домен .eplex.ru: выход закрывает сессию
    // во всех продуктах, и подпись обязана это обещать
    logOutUnified: "Выйти из Eplex",
    apply: "Применить",
    support: "Тех. поддержка",
    documentation: "Документация",
    notSelected: "Не выбрано",
    columnChooser: "Выбор колонок",
    columnSettings: "Настройки столбцов",
    wrapText: "Переносить текст",
    menu: "Меню",
    selectAll: "Выбрать всё",
    add: "Добавить",
    search: "Поиск...",
  },

  common: {
    confirm: "Подтвердить",
    cancel: "Отмена",
    error: "Ошибка",
    unexpectedError: "Произошла непредвиденная ошибка",
    requiredField: "Обязательный параметр",
    sessionReset: "Сброс сессии",
    logoutAllDevices: "Выйти на всех устройствах",
    sessionsTerminated: "Сеансы на всех устройствах завершены",
    sessionResetError: "Ошибка при сбросе сессий",
    serverConnectionError: "Ошибка соединения с сервером",
    emptyGroupValue: "(Пустое) — {column}",
    expandSubgroups: "Развернуть подгруппы",
    collapseSubgroups: "Свернуть подгруппы",
    expandAllGroups: "Развернуть все группы",
    collapseAllGroups: "Свернуть все группы",
    demoModeHidden: "Скрыто в режиме демонстрации",
    delete: "Удалить",
    edit: "Изменить",
  },

  login: {
    loginPlaceholder: "Логин",
    passwordPlaceholder: "Пароль", // NOSONAR — UI label, not a credential
    signIn: "Войти",
    authError: "Ошибка авторизации",
    cantLogin: "Не получается войти?",
    registrationLink: "Заявка на регистрацию",
    registrationStatusLabel: "Статус заявки на регистрацию",
    registrationState_pending: "На рассмотрении",
    registrationState_approved: "Одобрена",
    registrationState_rejected: "Отклонена",
  },

  authEntry: {
    title: "Вход в Eplex",
    signIn: "Войти в Eplex",
    signInPending: "Открываем страницу входа…",
    signInHint: "Откроется страница входа Eplex — {host}",
    sessionNotice: "Похоже, браузер не сохранил сессию. Разрешите cookie для eplex.ru и попробуйте войти ещё раз.",
    entryUnavailable:
      "Войти не удалось. Попробуйте ещё раз через полминуты; если не помогает — проверьте, что cookies разрешены.",
    separator: "или",
    quickTitle: "Ещё нет доступа?",
    quickLead:
      "Аккаунт создаётся сразу, без заявки: на странице входа откройте «Код из SMS» и введите номер телефона. Поставщики для первых поисков уже настроены.",
    quickAction: "Зарегистрироваться по телефону",
    companyLead: "Нужен договор и счёт на компанию?",
    companyLink: "Оставить заявку",
  },

  trialExit: {
    title: "Переход в рабочий режим",
    lead: {
      ownSupplier: "Чтобы настроить своего поставщика, нужно выйти из демо-доступа.",
      disableDemo: "Выключение демо-поставщиков означает переход в рабочий режим.",
      order: "Чтобы оформить заказ, нужно выйти из демо-доступа.",
    },
    effects: {
      suppliers: "Демо-поставщики пропадут, поиск пойдёт по вашим",
      order: "Оформление заказа станет доступно",
      tracking: "Заработает отслеживание событий по вашим заказам",
    },
    irreversible: "Вернуться в демо-доступ будет нельзя.",
    confirm: "Перейти в рабочий режим",
    cancel: "Отмена",
    pending: "Переводим…",
    failed: "Не удалось перейти. Вы остались в демо-доступе — попробуйте ещё раз.",
    disableDemoButton: "Выключить демо-поставщиков",
    readOnlyHint:
      "В демо-доступе показаны демо-поставщики. Настроить своего можно и здесь — сохранить данные получится после перехода в рабочий режим.",
  },

  trialBanner: {
    label: "Демо-доступ",
    lead: "Для вашего аккаунта настроены демо-поставщики. Подключите своих поставщиков — чтобы познакомиться с их товарами",
    action: "Подключить своих поставщиков",
    tracking: {
      title: "Отслеживание событий в демо-доступе недоступно",
      lead: "Лента показывает, что происходит с вашими заказами у ваших поставщиков. В демо-доступе заказов нет, поэтому и показывать нечего.",
    },
  },

  legalEntity: {
    tab: "Юрлицо",
    lead: "Заполните анкету, чтобы работать по договору и получать счета. Обязательны только наименование и налоговый номер — остальное подставится по нему.",
    fields: {
      country: "Страна регистрации",
      name: "Наименование организации",
      requisiteHint: "Начните вводить номер или название — подставим остальные данные",
      kpp: "КПП",
      legalAddress: "Юридический адрес",
    },
    submit: "Отправить анкету",
    sending: "Отправляем…",
    submitFailed: "Не удалось отправить анкету. Проверьте связь и попробуйте снова.",
    duplicate: {
      title: "Такая организация уже есть в системе",
      lead: "Мы можем привязать вас к ней — заново заводить организацию не нужно.",
      note: "Привязку сначала проверит сотрудник Eplex. До проверки доступа к данным организации у вас не будет, а работать вы продолжаете как раньше.",
      confirm: "Привязаться к этой организации",
      decline: "Вернуться к анкете",
    },
    done: {
      title: "Анкета отправлена",
      created: "Организация добавлена. Теперь можно оформлять договор и счёт.",
      proposed: "Заявка на привязку создана и ждёт проверки сотрудником. Пока вы работаете как раньше.",
      back: "Открыть анкету снова",
    },
  },

  trialRestricted: {
    title: "Пока недоступно в демо-доступе",
    lead: {
      order: "Оформить заказ можно после того, как вы подключите своих поставщиков.",
      pluginSettings: "Настройки поставщиков откроются после того, как вы подключите своих.",
      tracking: "Отслеживание событий заработает после того, как вы подключите своих поставщиков.",
    },
    reason:
      "Сейчас поиск идёт по демо-поставщикам — они показывают, как работает Eplex. Заказ по ним ушёл бы на чужой счёт, поэтому он закрыт.",
    connect: "Подключить своих поставщиков",
    later: "Позже",
  },

  registration: {
    title: "Заявка на регистрацию",
    companySection: "Данные организации",
    companyName: "Название организации",
    companyInn: "ИНН",
    companyInnInvalid: "ИНН должен содержать 10 или 12 цифр",
    countrySelectLabel: "Страна регистрации",
    countryRu: "Россия",
    countryBy: "Беларусь",
    countryKz: "Казахстан",
    countryUz: "Узбекистан",
    requisiteInn: "ИНН",
    requisiteUnp: "УНП",
    requisiteBin: "БИН",
    requisiteStir: "ИНН (СТИР)",
    requisiteInvalidInn: "ИНН должен содержать 10 или 12 цифр",
    requisiteChecksumInn: "Проверьте ИНН: такой комбинации цифр не существует",
    requisiteInvalidUnp: "УНП должен содержать 9 цифр",
    requisiteInvalidBin: "БИН должен содержать 12 цифр",
    requisiteInvalidStir: "ИНН (СТИР) должен содержать 9 цифр",
    fullName: "ФИО",
    companyPostAddress: "Почтовый адрес",
    companyPhone: "Телефон организации",
    companyEmail: "Email организации",
    usersSection: "Сотрудники",
    userNumber: "Сотрудник {n}",
    addUser: "Добавить сотрудника",
    removeUser: "Удалить",
    role: "Роль",
    roleOwner: "Владелец",
    roleManager: "Менеджер",
    roleMechanic: "Механик",
    firstName: "Имя",
    lastName: "Фамилия",
    patronymic: "Отчество",
    contactEmail: "Email",
    contactPhone: "Телефон",
    emailInvalid: "Некорректный email",
    comment: "Комментарий",
    submit: "Отправить заявку",
    backToLogin: "Назад к входу",
    successTitle: "Заявка отправлена",
    successMessage: "Ваша заявка принята и будет рассмотрена.",
    errorDuplicate: "Заявка с такими данными уже была отправлена",
    errorValidation: "Проверьте правильность заполнения формы",
    errorServer: "Ошибка сервера, попробуйте позже",
    existingRequestTitle: "У вас уже есть заявка",
    existingRequestPending: "Ваша заявка находится на рассмотрении. Мы свяжемся с вами после обработки.",
    existingRequestApproved: "Ваша заявка одобрена. Вы можете войти в систему.",
    existingRequestRejected: "Ваша заявка была отклонена.",
    submitNewRequest: "Отправить новую заявку",
    uploadCompanyDocuments: "Загрузить документы",
    uploadCompanyDocumentsLoading: "Распознаём…",
    uploadCompanyDocumentsSuccess: "Поля заполнены из документа",
    uploadCompanyDocumentsInvalidType: "Допустимы документы Word, PDF, Excel и изображения PNG, JPEG",
    uploadCompanyDocumentsError: "Не удалось распознать документ",
    uploadCompanyDocumentsHint:
      "Прикрепите или перетащите на кнопку карточку предприятия, визитку или реквизиты — Word, PDF, Excel, PNG или JPEG.{lineEnding}ИИ распознает документ и заполнит поля формы автоматически.",
    uploadCompanyDocumentsHintAria: "Как работает загрузка документов",
  },

  support: {
    writeToUs: "Напишите нам",
    selectRequestType: "Выберите тип обращения",
    contactUs: "Обратиться",
    technicalSupport: "Техническая поддержка",
    ceo: "Генеральный директор",
    optionWish: "Оставить пожелание",
    optionHelp: "Помощь с настройкой",
    optionAccounts: "Работа с учётными записями",
    optionBug: "Сообщить об ошибке",
    remoteAccessTitle: "Удалённый доступ",
    remoteAccessDescription:
      "Если специалист техподдержки попросил подключиться к вашему компьютеру — скачайте и запустите программу удалённого доступа. Установка не нужна: достаточно скачать и открыть файл. Если RuDesktop не запускается или не подключается, воспользуйтесь AnyDesk.",
    downloadRuDesktop: "Скачать RuDesktop",
    downloadAnyDesk: "Скачать AnyDesk",
    aboutCompany: {
      title: "О компании",
      blockText: 'Реквизиты, банковские данные и контакты ООО "ЭПЛЕКС".',
      linkLabel: "Подробнее",
      back: "Вернуться",
      subtitle: "Реквизиты и контактная информация",
      requisites: "Реквизиты организации",
      name: "Наименование",
      fullName: "Полное наименование",
      legalAddress: "Юридический адрес",
      factAddress: "Фактический адрес",
      taxData: "Налоговые данные",
      inn: "ИНН",
      ogrn: "ОГРН",
      kpp: "КПП",
      bankDetails: "Банковские реквизиты",
      bank: "Банк",
      account: "Расчётный счёт",
      corrAccount: "Корр. счёт",
      bik: "БИК",
      contacts: "Контакты",
      email: "Email",
      phone: "Телефон",
      management: "Руководство",
      director: "Генеральный директор",
    },
  },

  pwa: {
    updateReady: "Вышла новая версия кабинета",
    updateApply: "Обновить",
    updateLater: "Позже",
    install: "Установить приложение",
    installed: "Кабинет установлен",
    installHintIos: "Поделиться → «На экран «Домой»",
  },

  // Окно группировки на телефоне: панель группировки DevExtreme там недоступна
  grouping: {
    title: "Группировка",
    hint: "Отметьте столбцы, по которым сгруппировать таблицу. Порядок сверху вниз — порядок уровней: подержите строку или потяните за ручку, чтобы поменять.",
    selectedTitle: "Группировать по",
    selectedEmpty: "Пока не выбрано ни одного столбца",
    availableTitle: "Остальные столбцы",
    availableEmpty: "Все столбцы уже выбраны",
    removeLevel: "Убрать «{name}» из группировки",
    reorderHint: "Перетащить уровень",
    reset: "Сбросить",
    apply: "Применить",
  },

  mobileNav: {
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    more: "Ещё",
    moreActions: "Другие действия",
    primarySections: "Основные разделы",
    piecesShort: "шт",
  },

  sidebar: {
    modules: "Модули",
    toggleSidebar: "Переключить сайдбар",
    toggleSubsidebar: "Переключить подменю",
  },

  router: {
    defaultTitle: "Eplex Web",
    moduleBlocked: "Данный модуль заблокирован",
    loginTitle: "Вход - Eplex Web",
    registrationTitle: "Заявка на регистрацию - Eplex Web",
    journalTitle: "Журнал заказов - Eplex Web",
    singleSearchTitle: "Проценка - Eplex Web",
    retailPricingTitle: "Розничная проценка - Eplex Web",
    selectionTitle: "Подбор - Eplex Web",
    pluginsSettingsTitle: "Настройки поставщиков - Eplex Web",
    eventFeedTitle: "Лента событий - Eplex Web",
    markupSettingsTitle: "Настройки наценок - Eplex Web",
    integration1cTitle: "Интеграция 1С - Eplex Web",
    licenseTitle: "Лицензия - Eplex Web",
    personalizationTitle: "Персонализация - Eplex Web",
    billingTitle: "Биллинг - Eplex Web",
    billingReturnTitle: "Оплата - Eplex Web",
    guidanceTitle: "Обучение - Eplex Web",
    supportTitle: "Тех. поддержка - Eplex Web",
    aboutCompanyTitle: "О компании - Eplex Web",
    marketplaceSummaryTitle: "Сводка - Маркетплейс",
    marketplaceSummaryProcessesTitle: "Сводка / Процессы - Маркетплейс",
    marketplaceSummarySalesProfitTitle: "Сводка / Детализация продаж (Прибыль) - Маркетплейс",
    marketplaceSummarySalesOrdersTitle: "Сводка / Детализация продаж (Заказы) - Маркетплейс",
    marketplaceSummaryPriceListsTitle: "Сводка / Прайс-листы - Маркетплейс",
    marketplaceMyPriceTitle: "Мой прайс - Маркетплейс",
    marketplaceHypothesisTitle: "Гипотеза - Маркетплейс",
    marketplaceOrdersTitle: "Заказы - Маркетплейс",
    marketplaceReturnsTitle: "Возвраты - Маркетплейс",
    marketplaceReviewsTitle: "Отзывы - Маркетплейс",
    marketplaceEventFeedTitle: "Лента событий - Маркетплейс",
    marketplaceReportsTitle: "Отчеты - Маркетплейс",
    marketplaceMyPriceSettingsTitle: "Настройки прайсов - Маркетплейс",
    marketplaceAutomationTitle: "Настройки автоматизаций - Маркетплейс",
    marketplaceDeviationsSettingsTitle: "Настройки отклонений - Маркетплейс",
    marketplacePlatformsSettingsTitle: "Настройки площадок - Маркетплейс",
    marketplacePluginsSettingsTitle: "Настройки поставщиков - Маркетплейс",
    marketplaceEmailAccountTitle: "Настройки почтового аккаунта - Маркетплейс",
    marketplaceZakooperSettingsTitle: "Настройка закупера - Маркетплейс",
    marketplacePivotSummaryTitle: "Сводная - Маркетплейс",
  },

  fileUploader: {
    acceptableFormats: "Допустимые форматы",
    dragOr: "Перетащите файлы сюда или",
    download: "загрузите",
  },

  errorImportFile: {
    invalidExtension: "Недопустимый формат файла",
    invalidMimeType: "Недопустимый MIME-тип файла",
    invalidFileSignature: "Файл не соответствует ожидаемому формату",
  },

  sessionConflict: {
    title: "Конфликт сессий",
    rateLimitTitle: "Ограничение запросов",
    retry: "Попробовать снова",
    resetSessions: "Выйти на всех устройствах",
    resetting: "Сброс сессий...",
    logout: "Выйти из аккаунта",
    emailSent: "На вашу почту отправлено уведомление о сбросе сессий",
  },

  errors: {
    checkError: "Ошибка при проверке",
    saveError: "Ошибка при сохранении",
    sessionHasExpiredOrInvalid: "Ваша сессия истекла или недействительна. Пожалуйста, войдите снова.",
    pluginNotStarted: "Поставщик не был запущен из-за непредвиденной ошибки",
    filterApplicationFailed: "Не удалось применить фильтры",
    unknownError: "Произошла неизвестная ошибка",
    unexpectedFileError: "Произошла непридведенная ошибка. Попробуйте загрузить файл ещё раз.",
    eplexAuthError: "Ошибка авторизации Eplex",
    httpError: "Ошибка {status}",
    serverError: "Ошибка на сервере",
    supplierNotFound: "Поставщик не найден или не установлен",
    supplierParamsError: "Ошибка получения параметров поставщика",
    supplierDuplicate: "Поставщик не найден. Возможно, вы пытаетесь дублировать копию поставщика.",
    supplierSaveError: "Новый поставщик не может быть сохранён",
    supplierRequiredFields:
      "Поставщик дублирован, но не все обязательные поля заполнены. Откройте настройки и заполните",
    supplierParamsSaveError: "Ошибка при сохранении параметров нового поставщика",
    supplierDuplicateError: "Ошибка при дублировании плагина",
    copySuffix: "копия",
    profileNotFound: "Данные профиля не найдены",
  },

  basket: {
    add: "Добавить",
    addToBasket: "В корзину",
    itemsInCart: "Позиций в корзине: {n}",
    supplierComment: "Комментарий ПОСТАВЩИКУ",
    productKey: "Ключ",
    productValue: "Значение",
    productAdded: "Товар {pluginName} в количестве {quantity} добавлен в корзину",
    productAddError: "Ошибка при добавлении товара {pluginName}",
    tcostLabel: "Цена продажи",
    tcostType: "Тип цены",
    changePriceType: "Сменить тип цен",
    infoTitle: "Карточка товара",
    priceLabel: "Цена",
    schemeLabel: "Схема узла",
    schemeAlt: "Схема узла детали",
    photoLabel: "Фото детали",
    noImage: "Нет изображения",
    recommendedPrice: "Рекомендованная цена",
    specsTitle: "Характеристики",
    specCategory: "Категория",
    specCount: "Количество",
    specCity: "Город",
    specStock: "Склад",
    specDeliveryTime: "Срок поставки",
    specProbability: "Вероятность",
    specMultiplicity: "Кратность",
    specMinOrderQty: "Минимальная кратность",
    specPriceFile: "Прайс-лист",
    specSupplier: "Поставщик",
    counterparty: "Контрагент",
    counterpartyPlaceholder: "Начните вводить название",
    counterpartyLoadError: "Не удалось загрузить список контрагентов 1С",
  },

  plugin: {
    defaultName: "Поставщик",
    nameLabel: "Наименование",
    checkboxColumn: "Выбор",
    iconColumn: "Иконка",
    iconAlt: "Иконка поставщика",
    nameLabelPlugin: "Название поставщика",
    nameLabelSupplier: "Название поставщика",
    statusColumn: "Статус",
    allPlugins: "Все",
    warehousesHeader: "Склады",
    suppliersHeader: "Поставщики",
    allGroups: "Все",
    warehousesGroup: "Склады",
    suppliersGroup: "Поставщики",
    noGroup: "(Без группы)",
    positionsCount: "Количество позиций",
    minPrice: "Минимальная цена",
    positionsWithRequestedArticle: "Количество позиций для запрошенного артикула",
    positionsWithoutRequestedArticle: "Количество позиций для альтернативных артикулов",
    minPriceWithRequestedArticle: "Минимальная цена для запрошенного артикула",
    minPriceWithoutRequestedArticle: "Минимальная цена для альтернативных артикулов",
    settingsTitle: "Настройки поставщиков",
    browserImportButton: "Импорт из браузера",
    browserImportHint:
      "Импорт поставщиков, подключённых в браузере, в личный кабинет. Откроется окно для переноса поставщиков из браузера.",
    hideSupplierInfo: "Скрыть город и график работы",
    showSupplierInfo: "Показать город и график работы",
    configureSupplierHint: "Настроить поставщика",
    contextConfigure: "Настроить",
    contextDuplicate: "Дублировать",
    duplicateSuccess: "Поставщик успешно дублирован",
    duplicateError: "Ошибка при дублировании",
    noConfiguredSuppliers: "Нет настроенных поставщиков",
    connectedSupplier: "Подключенный поставщик",
    disabledSupplier: "Отключенный поставщик",
  },

  supplier: {
    scheduleAlwaysOpen: "круглосуточно",
    scheduleClosesAt: "до {time}",
    scheduleOpensAt: "с {time}",
    scheduleOpensOnDay: "с {day} {time}",
    scheduleClosed: "закрыто",
    scheduleUnknown: "График работы не указан",
    scheduleUnknownShort: "не указан",
    localTime: "местное время {time}",
    timeZoneUnknown: "часовой пояс не определён",
    weekDayShort: {
      mon: "пн",
      tue: "вт",
      wed: "ср",
      thu: "чт",
      fri: "пт",
      sat: "сб",
      sun: "вс",
    },

    cityColumn: "Город",
    scheduleColumn: "Работает",
    countryColumn: "Страна",
    distanceColumn: "От меня",
    distanceKm: "{n} км",
    distanceUnderKm: "меньше километра",
    urgentDelivery: "Срочная доставка",
    urgentDeliveryShort: "Срочная",
    urgentDeliveryYes: "Есть",
    urgentDeliveryHint: "Поставщик отгружает срочные заказы",
    siteColumn: "Сайт",
    siteOpenHint: "Открыть сайт поставщика в новой вкладке",

    viewList: "Список",
    viewMap: "Карта",
    viewListHint: "Список поставщиков",
    viewMapHint: "Поставщики на карте",

    filtersTitle: "Фильтры",
    filtersReset: "Сбросить",
    filtersToggle: "Фильтры",
    filterCity: "Город склада",
    filterCountry: "Страна",
    filterConnection: "Подключение",
    connectionAll: "Все",
    connectionConnected: "Подключённые",
    connectionDisabled: "Отключённые",
    connectionAvailable: "Не подключённые",
    filterOpenNow: "Работает сейчас",
    filterUrgent: "Срочная доставка",
    facetShowMore: "Ещё {n}",
    facetShowLess: "Свернуть",
    facetEmpty: "Нет данных",
    facetSearchPlaceholder: "Поиск",
    facetNoMatches: "Ничего не найдено",
    foundCount: "Найдено: {n}",
    regionSelected: "Регион: {name}",
    regionReset: "Показать все регионы",

    mapNoGeo: "Без координат на карте: {n}",
    mapNoData: "Показывать на карте пока нечего: у поставщиков не заполнен город",
    mapLoading: "Загружаем карту…",
    mapError: "Не удалось загрузить карту",
    mapAttribution: "GeoNames · Natural Earth",
    mapSuppliersCount: "Поставщиков: {n}",
    mapLegendScale: "В регионе: от 1 до {n}",
    metricTotal: "Все",
    metricTotalHint: "Цвет по общему числу поставщиков",
    metricConnected: "Мои",
    metricConnectedHint: "Цвет по числу подключённых поставщиков",
    metricAvailable: "Потенциал",
    metricAvailableHint: "Цвет по числу поставщиков, которых вы ещё не подключили",

    placeTotal: "всего {n}",
    placeConnected: "подключено {n}",
    placeAvailable: "не подключено {n}",
    placeEmpty: "поставщиков нет",
    placeDistance: "От «{city}» — {distance}",
    placeShowInList: "Показать в списке",
    placeSetMyCity: "Считать моим городом",
    placeDetails: "Подробнее",

    myCityTitle: "Мой город",
    myCityPlaceholder: "Выберите город",
    myCityHint: "Выберите город — покажем расстояние до поставщиков и тех, кто возит к вам",
    filterDeliversToMyCity: "Возят в мой город",
    deliveryShow: "Куда возит",
    deliveryHide: "Скрыть доставку",
    deliveryFrom: "Доставка из «{city}» — {n} городов",
    deliveryEmpty: "«{title}» не указал города доставки",
    deliveryLoading: "Загружаем зоны доставки: {loaded} из {total}",

    mapZoomIn: "Приблизить",
    mapZoomOut: "Отдалить",
    mapReset: "Вся карта",
    mapCityHint: "Показать поставщиков города",
    mapRegionHint: "Показать поставщиков региона",

    cardTitle: "Поставщик",
    cardOpenSettings: "Настроить",
    cardLoading: "Загружаем данные поставщика…",
    cardError: "Не удалось загрузить данные поставщика",
    cardEmpty: "Расширенных данных по этому поставщику нет",
    cardClose: "Закрыть",
    cardUpdatedAt: "Данные обновлены {date}",
    cardConnected: "Подключён",
    cardDisabledState: "Отключён",
    cardAvailable: "Не подключён",

    attributeSummary: "О поставщике",
    attributeCreditLimit: "Кредитный лимит",
    attributePaymentDeferral: "Отсрочка платежа",
    attributeOfficeCity: "Город офиса",
    attributeWorkingHours: "Часы работы",
    attributeWorkingDays: "Дни работы",

    dimensionBrand: "Бренды",
    dimensionCategory: "Категории товаров",
    dimensionDeliveryCity: "Города доставки",
    dimensionWarehouseCities: "Города складов",
    dimensionPhone: "Телефоны",
    dimensionEmail: "Почта",
    dimensionShowAll: "Показать все ({n})",
    dimensionCollapse: "Свернуть",

    noDataHint: "Расширенные данные о поставщиках сейчас недоступны",
  },

  warehouse: {
    settingsButton: "Настройки складов",
    popupTitle: "Выберите склады",
    columnSelected: "Выбран",
    columnLocal: "Локальный",
    columnName: "Наименование",
    saveButton: "Сохранить",
    cancelButton: "Отмена",
    loadError: "Ошибка загрузки списка складов",
    saveSuccess: "Склады успешно сохранены",
    saveError: "Ошибка сохранения складов",
    databasePrefix: "База",
    // Группа складов без имени в справочнике 1С — там она называется «Склады»
    defaultGroup: "Склады",
    loadingText: "Загрузка...",
    noWarehouses: "Нет складов для настройки",
    deletedWarehouseHint: "Склад помечен на удаление",
  },

  costTypeMapping: {
    columnTitle: "База {name}",
    selectCostType: "Выберите тип цен 1С",
    noCostTypes: "Нет типов цен",
    tooltip1CPrice: "Цена получена из базы 1С",
    mappingHint:
      "Сопоставьте тип цен ЛК с типом цен каждой базы 1С. При совпадении в проценке будет показана реальная цена из 1С вместо расчётной наценки.",
    mappingColumnHint: "Выберите тип цен 1С, который будет использоваться для подстановки цены в этот тип наценки",
    // Заголовок раздела в окне правки типа цены на телефоне
    sectionTitle: "Сопоставление с 1С",
  },

  markup: {
    title: "Настройки наценок",
    actions: "Действия",
    addPriceType: "Добавить тип цен",
    addMarkup: "Добавить наценку",
    roundingLabel: "Округление",
    roundingNone: "Нет",
    rounding001: "до сотых (734,46)",
    rounding01: "до десятых (734,5)",
    rounding1: "до целых (735)",
    rounding10: "до десятков (740)",
    rounding100: "до сотен (800)",
    rounding1000: "до тысяч (1000)",
    noData: "Нет настроенных наценок",
    columnPriceType: "Тип цены",
    columnSupplier: "Поставщик",
    columnThreshold: "Цена от",
    columnPercent: "Наценка %",
    defaultPluginTitle: "По умолчанию",
    // Подписи строки наценки на телефоне: там она умещается одной строкой
    anySupplier: "Все поставщики",
    thresholdShort: "от",
    percentShort: "%",
    // Наценки хранятся на сервере (CAB-778): человеку видно, дошла ли правка
    syncSaving: "Сохраняем…",
    syncError: "Не удалось сохранить наценки на сервере. Повторим автоматически, не закрывайте вкладку.",
    loadError:
      "Не удалось загрузить наценки с сервера. Показаны последние известные, обновите страницу, когда связь появится.",
  },

  priceTypeSelector: {
    selectedTypesCount: "Выбрано типов: {count}",
    selectPriceTypes: "Выбор типов цен",
    markupTypes: "Типы наценок",
    close: "Закрыть",
    configureMarkups: "Настроить наценки",
    allTypesDisabled: "Все типы наценок выключены",
    typesDisabledDescription:
      "У вас есть {n} типов, но они выключены | У вас есть {n} тип, но он выключен | У вас есть {n} типа, но они выключены | У вас есть {n} типов, но они выключены",
    enableTypes: "Включить типы наценок",
    noMarkupTypes: "Нет типов наценок",
    createTypesDescription: "Создайте типы цен для управления наценками",
    createMarkupType: "Создать тип наценки",
    primaryType: "Основной тип цен",
    primaryTypeHint:
      "Выбор основного типа — цена этого типа подставляется по умолчанию при добавлении в корзину, но её можно изменить",
    eyeHint: "Показать или скрыть столбец с ценой этого типа в таблице",
    showColumn: "Показать столбец",
    hideColumn: "Скрыть столбец",
    showAllColumns: "Показать все столбцы",
  },

  integration1c: {
    pageTitle: "Интеграция 1С",
    dbTabPrefix: "База",
    noOptions: "Нет доступных значений",
    saveError: "Ошибка сохранения настроек интеграции 1С",
    checkGatewayStatus: "Проверить статус шлюза",
    checkGatewayError: "Ошибка проверки статуса шлюза интеграции 1С",
    orderedMultiselect: {
      add: "Добавить значение",
      moveUp: "Выше в порядке применения",
      moveDown: "Ниже в порядке применения",
      remove: "Убрать из списка",
      empty: "Ничего не выбрано",
    },
    gatewayInstruction: {
      title: "Подключите склады 1С",
      subtitle: "Используйте собственные склады 1С наравне с поставщиками в единой проценке",
      benefit1Title: "Единая проценка",
      benefit1Desc: "Запасы ваших складов 1С и предложения поставщиков в одной таблице.",
      benefit2Title: "Актуальные остатки",
      benefit2Desc: "Синхронизация данных о наличии и ценах в реальном времени",
      benefit3Title: "Цены из 1С",
      benefit3Desc: "Автоматизированный перенос ваших типов цен 1С без ручного ввода и расчёта наценок.",
      benefit4Title: "Быстрый старт",
      benefit4Desc: "Быстрое подключение: наш менеджер поможет с настройкой шлюза.",
      ctaButton: "Подать заявку на подключение",
      ctaHint: "После подачи заявки наш менеджер свяжется с вами для настройки шлюза",
    },
  },

  pluginPopup: {
    demoNoFieldsHint:
      "Это демо-поставщик — настроек доступа у него нет. Чтобы подключить своего поставщика, найдите его в списке и нажмите карандаш в строке или воспользуйтесь ссылкой «Не получается? Настройте за меня».",
    mainSettings: "Основные настройки",
    authSearch: "Авторизация и поиск",
    order: "Заказ",
    check: "Проверить",
    loadedToggle: "Загружать в программу",
    loadedToggleHint: "Отображать поставщика в левой панели при поиске",
    loadingSettings: "Запрашиваем настройки у поставщика…",
    paramsUnavailable:
      "Поставщик не ответил — его настройки сейчас недоступны. Нажмите «Проверить», чтобы запросить их снова.",
    paramsUnavailableDisableHint:
      "Отключить поставщика можно и без ответа: снимите галочку «Загружать в программу» и сохраните.",
    paramsUnavailableEnableHint:
      "Включить поставщика пока нельзя: без его ответа не проверить доступы. Попробуйте позже.",
    supplierDisabled: "Поставщик отключён",
    supplierDisabledFieldsNotSaved:
      "Поставщик отключён. Остальные изменения не сохранены — для них нужна успешная проверка.",
    disableError: "Не удалось отключить поставщика. Повторите попытку.",
  },

  productTable: {
    article: "Артикул",
    brand: "Бренд",
    name: "Наименование",
    time: "Срок",
    quantity: "Количество",
    price: "Цена",
    sum: "Сумма",
    comment: "Комментарий",
    stock: "Склад поступления",
    supplier: "Поставщик",
    addedDate: "Дата добавления",
    chance: "Вероятность",
    supplierDisabled: "Отключен",
    supplierDisabledHint: "Поставщик отключён",
    supplierDisabledName: "{name} — поставщик отключён",
  },

  personalization: {
    title: "Персонализация",
    scaleTitle: "Масштаб интерфейса",
    scaleDescription: "Выберите удобный размер текста и элементов управления",
    scaleCompact: "Компактный",
    scaleCompactHint: "Больше данных на экране",
    scaleStandard: "Стандартный",
    scaleStandardHint: "Размер по умолчанию",
    themeTitle: "Цветовая тема",
    themeDescription: "Выберите оформление, комфортное для ваших глаз",
    themeLight: "Светлая",
    themeLightHint: "Классическое светлое оформление",
    themeDark: "Тёмная",
    themeDarkHint: "Снижает нагрузку на глаза в темноте",
    themeWarm: "Комфортная",
    themeWarmHint: "Тёплые тона для длительной работы",
  },

  license: {
    license: "Лицензия",
    login: "Логин",
    userId: "ИД пользователя",
    currentVersion: "Текущая версия",
    lastUpdate: "Последнее обновление",
    yourCurrentLimits: "Ваши текущие лимиты",
    operation: "Операция",
    hourly: "Часовой",
    daily: "Дневной",
    singleSearch: "Одиночной поиск",
    groupSearch: "Групповой поиск",
    retailSearch: "Розничный поиск",
    pricekeeper: "Прайскипер",
    notDefined: "Не определен",
  },

  resultSearchTable: {
    position: "Позиция",
    bestPrice: "лучшая цена",
    category: "Категория",
    requestedArticle: "Запрошенный артикул",
    originalReplacements: "Оригинальные замены",
    analogues: "Аналоги",
    supplierCrosses: "Кроссы поставщиков",
    article: "Артикул",
    brand: "Бренд",
    name: "Наименование",
    term: "Срок",
    availability: "Наличие",
    city: "Город",
    price: "Цена",
    deliveryProbability: "Вероятность",
    comment: "Комментарий",
    warehouse: "Склад",
    addToCart: "В корзину",
    supplierIcon: "Изображение поставщика",
    bigIcon: "Большая иконка",
    invalidQuantity: "Неверное количество",
    addedToCart: "Товар {name} добавлен в корзину: {quantity}",
    addItemError: "Ошибка при добавлении товара {name}",
    supplier: "Поставщик",
    partPhoto: "Фото детали",
    noReturn: "Возврат невозможен",
    authorizedDealer: "Авторизованный дилер",
    minMultiplicity: "Минимальная кратность",
    multiplicity: "Кратность",
    manufacturerWarranty: "Гарантия производителя",
    ownAvailability: "Собственное наличие",
    cancelEsc: "Отмена: Esc",
    addEnter: "Добавить: Enter",
    productQuantity: "Кол-во товара",
    addToCartEnter: "Добавить в корзину (Enter)",
    rate: "Проценить",
    copy: "Скопировать",
    groupMinTermHint: "Минимальный срок в группе",
    groupMinCostHint: "Минимальная цена в группе",
  },

  searchWorkspace: {
    car: "Авто",
    noCar: "Без авто",
    selectCarHint: "Поиск без привязки к авто",
    cars: "Группы проценок",
    carsListLabel: "Автомобили",
    looseProcenkas: "Отдельные проценки",
    searchCar: "Поиск по авто…",
    exitCar: "Закрыть",
    find: "Новый поиск",
    filtersTitle: "Фильтры",
    // Сворачиваемая панель фильтров Подбора (CAB-769)
    collapseFilters: "Свернуть",
    collapseFiltersHint: "Свернуть панель фильтров",
    pinFilters: "Закрепить панель развёрнутой для всех закупок",
    unpinFilters: "Открепить панель: при открытии закупки она будет свёрнута",
    filterHiddenDemo: "Фильтр скрыт в демо режиме",
    summaryHiddenDemo: "Скрыто",
    markerOwnStock: "Собственное наличие",
    markerOwnStockHint: "Только позиции в наличии на складе поставщика — с зелёным уголком в столбце срока.",
    markerReturnable: "Возврат возможен",
    markerReturnableHint: "Скрывает позиции с отметкой «возврат невозможен».",
    markerAuthDealer: "Авторизованный дилер",
    markerAuthDealerHint: "Только предложения от официальных дилеров бренда.",
    markerReliable: "Надёжный поставщик",
    markerReliableHint: "Только предложения от поставщиков, отмеченных как надёжные.",
    markerChance: "Вероятность поставки",
    markerChanceHint:
      "Только позиции с вероятностью поставки в выбранном диапазоне. Нажмите, чтобы задать границы ползунком.",
    markerChanceRange: "{from} \u2013 {to} %",
    markerChanceFrom: "Вероятность поставки: нижняя граница",
    markerChanceTo: "Вероятность поставки: верхняя граница",
    markerWarranty: "Гарантия производителя",
    markerWarrantyHint: "Только позиции с гарантией производителя.",
    resetFilters: "Сбросить фильтры",
    resetGroup: "Сбросить группу",
    showAll: "Показать все",
    collapse: "Свернуть",
    priceFrom: "от",
    priceTo: "до",
    termUpTo: "до {n} дн.",
    termAny: "Любой срок",
    brandPrice: "{price} ₽",
    brandTermDays: "{n} дн.",
    brandMinPriceHint: "Минимальная цена от {price} ₽",
    brandMinTermHint: "Минимальный срок доставки от {n} дн",
    brandMetricEmpty: "—",
    priceAdjustedMin:
      "В сохранённом фильтре цена от {saved} ₽, но в этой проценке дешевле {applied} ₽ предложений нет — применена граница {applied} ₽.",
    priceAdjustedMax:
      "В сохранённом фильтре цена до {saved} ₽, но в этой проценке дороже {applied} ₽ предложений нет — применена граница {applied} ₽.",
    vinTag: "VIN {vin}",
    deliveryTermLabel: "Срок доставки",
    applyingFilter: "Применяем фильтр к найденному",
    applyingFilterShort: "фильтр…",
    detailLimitLabel: "Одинаковых деталей",
    detailLimitInfo:
      "Не больше указанного числа одинаковых деталей от одного поставщика в выдаче — убирает повторы одной позиции.",
    detailUpTo: "до {n}",
    chanceAny: "Любая",
    noFilterData: "Нет данных для фильтрации",
    searching: "Идёт поиск…",
    filterSearch: "Поиск…",
    suppliers: "Поставщики",
    suppliersForSearch: "Поставщики для проценки",
    suppliersTriggerTitle: "Поставщики для проценки — выберите, у каких поставщиков искать предложения",
    selectSuppliers: "Выбрать поставщиков для поиска",
    selectSuppliersHint: "Выберите поставщиков для проценки",
    statusSearching: "Идёт поиск",
    statusDone: "Готово",
    statusError: "Ошибка",
    smartFiltersConfigure: "Настроить смарт-фильтры",
    smartFiltersOn: "Смарт-фильтры включены",
    smartFiltersInfo:
      "«Срок доставки» — скрывает предложения дольше выбранного срока. «Одинаковых деталей» — оставляет не больше N повторов одной позиции в выдаче. Ползунок в крайнем правом положении («Все» / «Любой срок») — правило выключено.",
    closeGroupTab: "Закрыть проценки группы",
    closeGroupTitle: "Закрыть проценки?",
    closeGroupMessage: "«{label}» — будут закрыты все вкладки ({n} шт.). Несохранённые результаты пропадут.",
    closeGroupConfirm: "Закрыть всё",
    closeAllTabs: "Закрыть все вкладки",
    allTabsLabel: "Все проценки",
  },

  quickFilter: {
    placeholder: "Быстрый отбор",
    hint: "Ищет по всему содержимому таблицы результатов и подсвечивает совпадения",
    clear: "Очистить быстрый отбор",
  },

  quickCart: {
    title: "Быстрая корзина",
    close: "Закрыть",
    loading: "Загрузка…",
    empty: "Корзина пуста",
    carFallback: "Авто",
    looseTitle: "Отдельные позиции",
    otherSuppliers: "Другие поставщики",
    noBrand: "Без бренда",
    groupBy: {
      label: "Группировка позиций",
      car: "Авто",
      supplier: "Поставщики",
      brand: "Бренды",
      hint: {
        car: "Группировать по авто",
        supplier: "Группировать по поставщикам",
        brand: "Группировать по брендам",
      },
    },
    order: "Заказать",
    orderAll: "Заказать всё",
    groupSum: "Сумма группы",
    ordering: "Заказывается: {n}",
    placing: "Оформляется",
    searchPlaceholder: "Поиск по корзине…",
    nothingFound: "Ничего не найдено",
    undo: "Отменить",
    openFull: "Открыть полную корзину",
    days: "{n} дн.",
    inStock: "в наличии: {n}",
    decQty: "Уменьшить количество",
    incQty: "Увеличить количество",
    remove: "Убрать из корзины",
    removeFailed: "Не удалось убрать позицию из корзины",
    orderFailed: "Заказ не оформлен",
    // Отказ в момент оформления: позиции никуда не ушли (CAB-782)
    orderRejected: "Заказ не оформлен: {reason}. Позиции остались в Быстрой корзине",
    // Отказ поставщика после приёма заявки: позиция уже в основной корзине как
    // «Оформлено · Ошибка», оттуда её оформляют повторно (CAB-782)
    placementFailedOne:
      "Заказ не оформлен: {details}. Позиция перенесена в основную корзину — тип «Оформлено», статус «Ошибка». Там её можно оформить повторно.",
    placementFailedMany:
      "Заказ не оформлен: {details}. Позиции перенесены в основную корзину — тип «Оформлено», статус «Ошибка». Там их можно оформить повторно.",
    goToCart: "Перейти в корзину",
    failedInJournal: "Оформлено · Ошибка",
    failedInJournalHint:
      "Позиция в основной корзине с типом «Оформлено» и статусом «Ошибка» — её можно оформить повторно",
    openInJournal: "В корзину",
  },

  singleSearch: {
    setupSheet: "Авто, поставщики и фильтры",
    title: "Проценка",
    disableGrouping: "Отключить группировку",
    enableGrouping: "Включить группировку",
    rowsHiddenByGridFilters: "Найдено предложений: {n}, но все скрыты фильтрами таблицы",
    resetGridFilters: "Сбросить фильтры таблицы",
    dragOffer: "Предложение",
    dragOffers: "Предложений: {count}",
    selectAtLeastOneSupplier: "Пожалуйста, выберите хотя бы одного поставщика.",
    selectAtLeastOneSupplierForSearch: "Пожалуйста, выберите хотя бы одного поставщика для поиска.",
    noConfiguredSuppliers: "У вас нет настроенных поставщиков. Перейдите в настройки поставщиков для добавления.",
    pleaseEnterArticle: "Пожалуйста, введите артикул, VIN, гос. номер, марку или опишите что нужно.",
    noActiveFiltersToSave: "Нет активных фильтров для сохранения",
    filterSavedSuccessfully: "Фильтр успешно сохранён",
    cannotSaveOnlyPriceTypeFilters: "Фильтры по колонкам наценок нельзя сохранить",
    placeholder: "Введите артикул, VIN, гос. номер, марку или опишите что нужно — например «VIN тормозные колодки»",
    search: "Найти",
    stop: "Стоп",
    quickFilterPlaceholder: "Быстрый отбор",
    clearFilters: "Очистить фильтры",
    searchImageOnline: "Искать фото в интернете",
    searching: "Поиск предложений",
    searchingWithDots: "Поиск...",
    stopSearching: "Остановить поиск",
    suppliers: "поставщиков",
    saveFilters: "Создать пользовательский фильтр",
    filtersList: "Список пользовательских фильтров",
    clear: "Очистить",
    allBrands: "Все бренды",
    searchCanceledBecauseLeaved: "Поиск был прерван, так как пользователь покинул или обновил страницу.",
    searchCanceledByUser: "Поиск был прерван пользователем",
    historyButton: "История поиска",
    historyEmpty: "История поиска пуста",
    closeImagePanel: "Закрыть панель изображения",
    part: "Изображение запчасти",
    imageLoadError: "Ошибка загрузки изображения",
    allImages: "Все изображения",
    allImagesTitle: "Все изображения запчасти",
    thumbnail: "Миниатюра",
    clearHistory: "Очистить",
    smartFilters: "Умная фильтрация",
    searchHistory: "История поиска",
    clearHistoryConfirm: "Очистить историю поиска?",
    clearHistoryWarning: "Все записи будут удалены безвозвратно",
    historyCleared: "История поиска очищена",
    searchInHistory: "Поиск в истории...",
    dragColumnToGroup: "Перетащите колонку сюда для группировки",
    historyDate: "Дата",
    historyTime: "Время",
    historyType: "Тип",
    historyQuery: "Запрос",
    historyVehicle: "Автомобиль",
    historyBrand: "Бренд",
    plateNumber: "Гос. номер",
    article: "Артикул",
    noResultsFound: "Ничего не найдено",
    historyVehicleNumber: "Запрос",
    historyArticle: "Артикул",
    clickToInsert: "Нажмите, чтобы подставить в поле поиска",
    clickToSearch: "Нажмите, чтобы запустить поиск",
    noDataAfterFiltering: "Нет данных после применения фильтров",
    clickToFill: "Нажмите, чтобы подставить в поле поиска",
    loadingResults: "Загрузка результатов...",
    // Срок хранения результатов на бэке истёк: не сбой, а устаревшие данные (CAB-602 п.4).
    // Вместо пустой таблицы — объяснение и кнопка повторить поиск (CAB-677).
    resultsExpiredTitle: "Информация устарела",
    resultsExpired:
      "Результаты этой проценки удалены с сервера по сроку хранения. Повторите поиск, чтобы увидеть актуальные цены и сроки.",
    resultsExpiredAction: "Повторить поиск",
    resultsExpiredStatus: "Результаты проценки удалены по сроку хранения",
    defaultTabTitle: "Поиск {n}",
    refreshingResults: "Обновление результатов...",
    catalogByVin: "Каталог по VIN",
    catalogByPlate: "Каталог по гос. номеру",
    brandCatalogs: "Каталоги брендов",
    spareParts: "Каталог запчастей",
    close: "Закрыть",
    resizeHandle: "Изменить размер",
    exampleByArticle: "{article}",
    exampleByVin: "{vin} {part}",
    exampleByPlate: "{plate} {part}",
    catalogFab: {
      close: "Закрыть каталог",
      labelVin: "Вернуться в каталог по VIN {value}",
      labelPlate: "Вернуться в каталог по гос. номеру {value}",
      labelBrand: "Вернуться в каталог {value}",
    },
    smartSearchFab: {
      label: "Вернуться к результатам ИИ-поиска: {query}",
      close: "Закрыть результаты ИИ-поиска",
    },
    decreaseQuantity: "Уменьшить количество (Стрелка вниз)",
    increaseQuantity: "Увеличить количество (Стрелка вверх)",
    plateNumberLabel: "Гос. номер: {value}",
    cartItemsCount: "Товаров в корзине: {count} шт.",
    tabContextMenu: {
      groupByVinPlate: "Сгруппировать по VIN/Гос. номеру",
      ungroup: "Разгруппировать",
      closeTab: "Закрыть вкладку",
      closeOtherTabs: "Закрыть другие вкладки",
      closeAllTabs: "Закрыть все вкладки",
    },
  },

  cartEplex: {
    makeOrder: "Оформить",
    selectAtLeastOneItemForMakeOrder: "Выберите хотя бы один товар, чтобы оформить заказ.",
    selectAtLeastOneItemForDelete: "Выберите хотя бы один товар, чтобы удалить товары.",
    deleteFromCart: "Удалить из корзины",
    alreadyOrderedError: "Нельзя заказать уже заказанный товар",
    disabledSupplierError:
      "Оформление невозможно: некоторые товары имеют отключенного поставщика. Удалите их из выбранных.",
    selectedCount: "Выбрано: <b>{count}</b> поз.",
    selectedSum: "На сумму: <b>{sum}</b>",

    multiOrderPopup: {
      title: "Оформление нескольких позиций",
      text: "Вы выбрали <b>несколько позиций</b> для оформления. Все выбранные позиции будут объединены в <b>один заказ</b>, и вы получите <b>одно письмо-подтверждение</b>.",
    },
  },

  documentModal: {
    title: "Документ 1С",
    chainTitle: "Документы позиции",
    back: "Назад",
    backTo: "К документу «{name}»",
    openHint: "Открыть документ",
    notCreated: "Документа в 1С ещё нет",
    notFound: "Документ не найден в 1С — возможно, он удалён",
    loadError: "Не удалось загрузить документ из 1С",
    retry: "Повторить",
    comment: "Комментарий",
    itemsTitle: "Товары",
    itemsEmpty: "В документе нет товаров",
    total: "Итого",
    sumWithVat: "«Сумма» — с НДС",
    sumWithoutVat: "«Сумма» — без НДС",
    state: {
      posted: "Проведён",
      unposted: "Не проведён",
      deleted: "Помечен на удаление",
    },
    requisites: {
      counterparty: "Контрагент",
      provider: "Поставщик",
      department: "Подразделение",
      warehouseSender: "Склад-отправитель",
      warehouseReceiver: "Склад-получатель",
      deliveryDate: "Дата поставки",
      author: "Ответственный",
    },
    columns: {
      number: "№",
      qty: "Кол-во",
      price: "Цена",
      cost: "Сумма",
      vat: "НДС",
      grandTotal: "Всего",
      warehouse: "Склад",
      source: "Основание",
    },
  },

  journalTable: {
    // Карточка позиции на телефоне: открывается нажатием на строку без заказа
    positionCardTitle: "Позиция",
    positionCardOrder: "Заказ",
    positionCardDelivery: "Поставка",
    positions: "Позиций:",
    sumLabel: "Сумма:",
    estimatedDeliveryDate: "Предполагаемая дата доставки:",
    orderStatus: "Статус оформления заказа",
    type: "Тип",
    createDate: "Дата создания",
    qty: "Кол-во",
    position: "Позиция",
    orderNumber: "Номер заказа",
    inOrder: "В заказе",
    supplied: "Отгружено",
    rejected: "Отказано",
    received: "Оприходовано",
    sold: "Реализовано",
    quantityHistoryAria: "{name}: {total}. Показать историю изменений",
    quantityHistoryNoDate: "Дата не указана",
    quantityHistoryTotal: "Итого",
    quantityHistoryUnits: "{count} шт.",
    quantityDocumentFailed:
      "Количество учтено в ЛК, но успешная обработка документов в 1С не подтверждена. Причина указана ниже.",
    documentOperationQuantity: "Количество операции: {count} шт.",
    documentIntegration: "База 1С: {name}",
    warehouse: "Склад",
    deliveryDate: "Дата доставки",
    guaranteedDate: "Гарант. дата",
    counterparty: "Контрагент",
    responsible: "Ответственный",
    // заголовок группы для позиций без известного ответственного
    responsibleNone: "Без ответственного",
    selection: "Подбор",
    // заголовок группы для позиций, не относящихся ни к одному подбору
    selectionNone: "Без подбора",
    document: "Документы",
    documentsEmpty: "Документы отсутствуют",
    documentTypes: {
      BuyOrder: "Заказ покупателя",
      SupOrder: "Заказ поставщику",
      ArrivalDoc: "Поступление",
      SaleDoc: "Реализация",
    },
    documentStatus: {
      sent: "Отправлено в шлюз",
      done: "Выполнено",
      timeout: "Не выполнено по таймауту",
      error: "Не выполнено из-за ошибки",
      unknown: "Статус неизвестен",
    },
    typeCart: "Корзина",
    typeOrdered: "Оформлено",
    typeOrder: "Заказано",
    tcost: "Цена*",
    tcostSum: "Сумма*",
    tcostHint: "Цена продажи — редактируется для записей со статусом «Корзина»",
    tcostNotSaved: "Цена* не сохранена: сервер не принял новое значение",
    priceSuffix: "цена",
    sumSuffix: "сумма",
    unexpectedError: "Произошла непредвиденная ошибка",
    loadMore: "Двойной клик — загрузить ещё 100 позиций",
    loadMoreHint: "Загрузить следующие 100 позиций",
    statusOutOfTokens: "Закончились токены, пополните баланс в разделе «Биллинг»",
    statusDebugError: "Обнаружена ошибка отладки — обратитесь в техподдержку",
    statusCart: "Позиция в корзине, ожидает оформления",
    statusOrdering: "Заказ отправляется поставщику",
    statusProcessing: "Заказ принят поставщиком, идёт обработка",
    statusAwaitingConfirmation: "Заказ отправлен, ожидает подтверждения от поставщика",
    statusOrderError: "Не удалось оформить заказ у поставщика",
    statusUnexpectedError: "Произошла непредвиденная ошибка при обработке заказа",
    statusInWork: "Заказ подтверждён поставщиком, ожидает отгрузки",
    statusRejected: "Поставщик отказал в выполнении заказа",
    statusShipped: "Заказ отгружен поставщиком",
    qtyExternalOrder: "Заказ оформлен через внешний сервис или сайт поставщика",
    qtyMismatch: "Количество в заказе ({orderQty}) отличается от заказанного из корзины ({qty})",
  },

  journalQuickFiltersSettings: {
    description: "Выберите, какие отборы показывать на панели",
    filterNotOrdered: "Позиции в корзине, еще не оформленные",
    filterRejected: "Позиции с отказами (отгружено меньше заказанного)",
    filterByOrders: "Оформленные заказы у поставщиков",
    settingsTitle: "Настройка отборов",
    popupTitle: "Настройка быстрых отборов",
    labelNotOrdered: "Не оформлено",
    labelRejected: "Отказы",
    labelByOrders: "По заказам",
    labelToReceive: "К поступлению",
    labelToSell: "К реализации",
    filterToReceive: "Заказы, по которым поступление ещё не проведено",
    filterToSell: "Оприходованные позиции, ещё не реализованные",
  },

  // Склад: оприходование и реализация позиций Корзины (CAB-474)
  journalInventory: {
    refreshFailed:
      "Не удалось проверить актуальные количества. Операция не отправлена. Обновите данные и повторите попытку.",
    confirmReceipt: "Провести поступление по отмеченным ({count})?",
    confirmReceiptOk: "Провести",
    confirmSale: "Сформировать документ реализации по отмеченным ({count})?",
    confirmSaleOk: "Сформировать",
    receiveTooltip: "Выберите хотя бы одну позицию",
    sellTooltip: "Выберите позиции с проведённым поступлением",
    receiveDoneTooltip: "По отмеченным позициям поступление уже проведено",
    receiveNothingTooltip: "Среди отмеченных нет позиций, по которым можно провести поступление",
    supplierOrderFailedTooltip: "Исправьте ошибку заказа поставщику в 1С перед поступлением или реализацией",
    saleDoneTooltip: "По отмеченным позициям реализация уже проведена",
    receiptNothing: "Среди отмеченных нет позиций, по которым можно провести поступление",
    receiptMissing: "Поступление не проведено: сервер не нашёл отмеченные заказы",
    receiptAlready: "Поступление по отмеченным позициям уже проведено",
    receiptPartial: "Поступление проведено по {count} из {total} поз., остальные сервер не принял",
    receiptDone: "Поступление проведено по {count} поз.",
    saleNothing: "Среди отмеченных нет позиций с проведённым поступлением",
    saleMissing: "Документ реализации не сформирован: сервер не нашёл отмеченные заказы",
    saleAlready: "Реализация по отмеченным позициям уже проведена",
    salePartial: "Реализация проведена по {count} из {total} поз., остальные сервер не принял",
    saleDone: "Документ реализации сформирован по {count} поз.",
    failed: "Не удалось выполнить операцию. Попробуйте ещё раз позже",
  },

  cartOrderAttemptsPopup: {
    attemptNumber: "№ попытки",
    error: "Ошибка",
    errorCode: "Код ошибки",
    date: "Дата",
  },

  journalTopbar: {
    delete: "Удалить",
    newSearch: "Новый поиск",
    selectedPrefix: "Выбрано:",
    positionsSuffix: "поз.",
    sumPrefix: "На сумму:",
    deleteOnlyCartTooltip: "Можно удалить только позиции корзины или оформленные с ошибкой",
    // Повторное оформление строк, упавших у поставщика (CAB-683)
    retryOrder: "Повторить заказ",
    retryOrderOnlyFailedTooltip: "Повторить можно только позиции, оформленные с ошибкой",
    // Склад: оприходование и реализация отмеченных позиций (CAB-474).
    // Короткие подписи — для узкой полосы телефона, где кнопки делят один ряд.
    receiveGoods: "Провести поступление",
    receiveGoodsShort: "Поступление",
    sellGoods: "Сформировать документ реализации",
    sellGoodsShort: "Реализация",
  },

  orderInfoModal: {
    title: "Информация о заказах",
    statusCaption: "Состояние",
    orderQtyCaption: "Количество в заказе",
    rejectedQtyCaption: "Отказанное количество",
    suppliedQtyCaption: "Отгруженное количество",
    accountedQtyCaption: "Оприходованное количество",
    expectedDeliveryCaption: "Ожидаемое время доставки",
    guaranteedDeliveryCaption: "Гарантированное время доставки",
    orderNumberFrom: "от",
    actionsCaption: "Действия",
    reorderAction: "Перепроценить",
    reorderHint: "Найти замену отказанной позиции и связать с этим заказом",
    // Группы полей в окне подробностей позиции на телефоне
    positionGroup: "Позиция",
    orderGroup: "Заказ",
    deliveryGroup: "Поставка",
  },

  journal: {
    makeOrderOnlyCartError: "Можно оформить только позиции корзины",
    somePositionsAlreadyOrdered: "Некоторые позиции уже оформлены",
    somePositionsInProgress: "Некоторые позиции уже в процессе оформления",
    makeOrderUseRetryForFailed: "Позиции с ошибкой оформляются кнопкой «Повторить заказ»",
    // Подтверждение повтора, когда прошлая попытка упала на стороне поставщика (CAB-683)
    retryConfirmTitle: "Повторить заказ?",
    retryConfirmOk: "Проверил, повторить",
    retryConfirmFallback:
      "Прошлая попытка завершилась ошибкой на стороне поставщика — заказ мог быть создан. Проверьте у поставщика, что заказа нет, и повторите оформление.",
    someSupplierDisabled:
      "Заказ не может быть оформлен у поставщиков, которые сейчас отключены. Процените артикулы заново по своим поставщикам или проверьте список в настройках поставщиков.",
    makeOrderErrorWithDetails: "Ошибка при оформлении: {errors}",
    // Оформление у поставщика асинхронное: make_order подтверждает приём заявки,
    // а итог приходит статусом строки. Поэтому сообщений два, и первое не про
    // успех — иначе клиент читает «оформлено» там, где заказа ещё нет (CAB-683).
    orderSubmitted: "Заказ отправлен поставщику — ждём ответ",
    orderPlaced: "Заказ оформлен: {details}",
    orderNumberLabel: "№ {number}",
    orderDetailsMore: "и ещё {count} поз.",
    makeOrderFailed: "Ошибка при оформлении заказа",
    orderPlacementFailed: "Заказ не оформлен: {details}",
    positionsDeleted: "Позиции успешно удалены",
    deleteError: "Ошибка при удалении",
    statusHistoryTitle: "Хронология изменений - Состояние",
  },

  // Расширенный поиск по истории заказов в ленте событий (CAB-534)
  orderHistory: {
    searchPlaceholder: "Расширенный поиск",
    searchInfo:
      "Оставляет в ленте события, где встречается набранное: артикул, бренд, наименование, номер заказа, цена, сумма, состояние, склад. Ищет и по подробностям заказа, а не только по тексту события. Можно вводить часть слова, регистр не важен. Отбор идёт по подгруженным дням — события постарше появятся после подгрузки предыдущих.",
    clear: "Очистить поиск",
    busy: "Подгружаем подробности заказов",
  },

  journalTimeline: {
    title: "Журнал заказов",
    loadMoreHint: "Двойной клик — подгрузить предыдущие дни",
    loadMoreHintMobile: "Нажмите, чтобы подгрузить предыдущие дни",
    loading: "Загрузка...",
    loadMoreSameMonth: "Загрузить с {endDay} - {startDay} {month} (двойное нажатие)",
    loadMoreDifferentMonths: "Загрузить с {endDayMonth} - {startDayMonth} (двойное нажатие)",
    loadMoreSameMonthMobile: "Загрузить с {endDay} - {startDay} {month}",
    loadMoreDifferentMonthsMobile: "Загрузить с {endDayMonth} - {startDayMonth}",
    today: "Сегодня",
    yesterday: "Вчера",
    colDate: "Дата",
    colTime: "Время",
    colOrders: "Заказы",
    colResponsible: "Ответственный",
    colEvent: "Событие",
    noData: "Событий нет",
    nothingInLoadedDays: "По запросу «{query}» среди загруженных дней событий нет — подгрузите предыдущие дни",
    searchLoading: "Ищем «{query}» в подробностях заказов…",
  },

  marketplace: {
    mainTitle: "Eplex Маркетплейс",
    segment: "Сегмент",
    market: "Рынок",
    myPrice: "Мой прайс",
    price: "Прайс",
    myPricing: "Моя цена",
    position: "Позиция",
    delta: "Дельта",
    marginPercent: "Маржа (%)",
    draftSettings: "Настройки прайса",
    draftSettingsGlobal: "Глобальные настройки прайс-листов",
    myPriceSettings: {
      backToProducts: "К товарам прайса",
      rename: "Переименовать прайс-лист",
      renameSuccess: "Прайс-лист переименован",
    },
    platformName: "Наименование площадки",
    auth: "Аутентификация",
    orders: {
      findSupply: "Найти обеспечение",
      platformIcon: "Иконка площадки",
      platform: "Площадка",
      orderDate: "Дата заказа",
      updateDate: "Дата обновления",
      number: "№",
      quantity: "Кол-во",
      sum: "Сумма",
      priceList: "Прайс",
      timeInStatus: "Время в статусе",
      deliveryDeadline: "Срок отгрузки",
      buyer: "Покупатель",
      comment: "Комментарий",
      rejectOrder: "Отклонить заказ",
      emptyPlaceholder: "—",
      findSupplyConfirm: "Поиск обеспечения заказа",
      findSupplyConfirmMessageSingle: "Вы действительно хотите найти обеспечение для этого заказа?",
      findSupplyConfirmMessage: "Вы действительно хотите найти обеспечения для выбранных заказов ({count} шт.)?",
      supplySettings: "Настройки поиска обеспечения",
      supplySettingsProfile: "Профиль",
      supplySettingsProfilePlaceholder: "Выберите профиль",
      supplySettingsPlugins: "Плагины для поиска",
      supplySettingsPluginName: "Плагин",
      supplySettingsPluginRank: "Ранг",
      supplySettingsNoProfile: "Выберите профиль для настройки плагинов",
      supplySettingsLoading: "Загрузка...",
      supplySettingsSaveSuccess: "Настройки закупера сохранены",
      supplySettingsSaveError: "Ошибка сохранения настроек",
      supplySearchStartedAll:
        "Поиск обеспечения запущен для всех заказов ({count} шт.). Результат появится после завершения поиска.",
      supplySearchStartedPartial:
        "Поиск обеспечения запущен для {success} из {total} заказов, не удалось запустить для {error}",
      supplyFoundErrorAll: "Ошибка поиска обеспечения для всех заказов ({count} шт.)",
      supplyNotFound: "Обеспечение не найдено",
      supplyNotFoundConfirm: "Обеспечение для данного заказа не найдено. Вы уверены, что хотите обеспечить заказ?",
    },
    draft: {
      dataSources: "Источники данных",
      segments: "Сегменты",
      markupMargin: "Наценки и маржинальность",
      paltforms: "Площадки",
      strategies: "Стратегии",
      segmentsAndStrategies: "Сегменты и стратегии",
      rulesFormation: "Формирование прайс-листа",
    },
    platformSettingsTabs: {
      importPrice: "Импорт прайса",
      editSetting: "Редактировать настройку: {name}",
      setupPlatform: "Настроить платформу: {name}",
      name: "Название",
      nameRequired: "Название обязательно",
      requiredField: "Обязательное поле",
      recipientEmails: "Email получателей прайс-листа",
      recipientEmailsAdd: "Добавить получателя",
      recipientEmailsEmpty: "Получатели не добавлены",
      recipientEmailsValidationError: "Проверьте адреса получателей",
      priceUpdateFrequency: "Частота выгрузки прайс-листа",
      scheduleType: "График обновлений",
      updateEvery: "Обновлять каждые",
      hours: "ч.",
      orderReception: "Приём заказов",
      mailServerSetting: "Почтовый аккаунт",
      mailServerSettingPlaceholder: "Не выбран",
      emailMatchingRules: "Правила определения писем",
      addRule: "Добавить правило",
      ruleType: "Тип",
      rulePattern: "Шаблон",
      rulePriority: "Приоритет",
      ruleValidationError: "Заполните тип и шаблон для всех правил",
      saveSuccess: "Настройки приёма заказов сохранены",
      skip: "Пропустить",
      ruleTypeSenderExact: "Отправитель — точное совпадение",
      ruleTypeSenderContains: "Отправитель — содержит",
      ruleTypeSenderDomain: "Домен отправителя",
      ruleTypeSenderRegex: "Отправитель — регулярное выражение",
      ruleTypeSubjectContains: "Тема — содержит",
      ruleTypeSubjectRegex: "Тема — регулярное выражение",
      ruleTypeContentContains: "Содержимое — содержит",
      pricekeeperRules: "Правила определения собственных позиций",
      pricekeeperRulesHint:
        "Правила объединяются по «И»: оффер считается нашим, только если совпали все правила. Без правил своя позиция не определяется — все офферы считаются конкурентами.",
      pricekeeperAddRule: "Добавить правило",
      pricekeeperCharacteristic: "Характеристика",
      pricekeeperOperator: "Правило",
      pricekeeperValue: "Значение",
      pricekeeperMatchBySellerName: "Поставщик",
      pricekeeperMatchByArticle: "Артикул",
      pricekeeperMatchByBrand: "Бренд",
      pricekeeperMatchByWarehouse: "Склад",
      pricekeeperOperatorEquals: "равно",
      pricekeeperOperatorContains: "содержит",
      pricekeeperOperatorStartsWith: "начинается с",
      pricekeeperRuleValidationError: "Заполните характеристику, правило и значение для всех правил",
      pricekeeperSaveSuccess: "Правила Прайскипера сохранены",
      pricekeeperExclusionRules: "Правила исключения позиций",
      pricekeeperExclusionRulesHint:
        "Правила объединяются по «ИЛИ»: оффер исключается из анализа, если совпало хотя бы одно правило. Характеристика обязательна — правило без неё исключило бы все офферы.",
      pricekeeperExclusionRuleValidationError:
        "Заполните характеристику, правило и значение для всех правил исключения",
    },
    importPriceList: {
      uploadAnotherFile: "Загрузить другой файл",
      import: "Импортировать",
      name: "Название файла",
      namePlaceholder: "Например: price-list.xls",
      sourceFile: "Разбираем файл: {fileName}",
      deliveryTime: "Срок поставки",
      defaultBrand: "Бренд по умолчанию",
      skipRows: "Пропустить (строк)",
      importSegments: "Импортировать сегменты",
      onlyRowsWithSkuAndBrand: "Только строки с Артикул + Бренд",
      onlyRowsWithQuantity: "Только строки с Количеством",
      onlyRowsWithCost: "Только строки с Себестоимостью",
      mapping: {
        brand: "Бренд",
        cost: "Себестоимость",
        name: "Наименование",
        count: "Количество",
        time: "Время доставки",
        segment: "Сегмент",
        minCount: "Минимальное количество",
        city: "Город",
        article: "Артикул",
        doNotUse: "Не использовать",
      },
      notifications: {
        fileUploadedSuccessfully:
          "Файл успешно загружен! Показан предпросмотр первых строк, остальные строки загружены, но не отображаются.",
        fileUploadFailed: "Не удалось загрузить файл. Попробуйте снова.",
        emptyFile: "Файл пуст. Загрузка отменена.",
        fieldsMustBeUnique: "Каждое поле можно выбрать только один раз.",
        articleMustBeSelected: "Необходимо выбрать колонку с артикулом.",
        brandMustBeSelected: "Необходимо выбрать колонку с брендом.",
        importFailed: "Не удалось подготовить данные для импорта. Попробуйте ещё раз.",
        skuMustBeSelectedOnce: "Артикул должен быть выбран ровно один раз.",
        brandMustBeSelectedOnce: "Бренд должен быть выбран ровно один раз.",
        quantityCannotBeSelectedMoreThanOnce: "Количество не может быть выбрано более одного раза.",
        costCannotBeSelectedMoreThanOnce: "Себестоимость не может быть выбрана более одного раза.",
        selectAtLeastOneRowToImport: "Выберите хотя бы одну строку для импорта.",
        dataPreparedForImport: "Данные успешно подготовлены для импорта!",
        nameMustBeFilled: "Необходимо заполнить название",
      },
      hints: {
        skipRows: "Число строк, которое необходимо пропустить",
        importSegments: "Разрешает перезаписать сегмент у импортируемых товаров",
        costIn:
          "Если в файле есть и цена, и себестоимость, сопоставьте обе колонки: «Себестоимость» всегда попадёт в цену закупки, «Цена» — в цену для площадки",
      },
    },
    summary: {
      processes: "Процессы",
      priceLists: "Прайс-листы",
      deviationsByPriceList: "Отклонения по прайс-листу",
      refreshData: "Обновить данные",
      platform: "Площадка",
      sku: "SKU",
      totalPrice: "Сумма прайса",
      margin: "Маржинальность прайса",
      updated: "Дата обновления прайса",
      freshness: "Актуальность",
      total: "Итого:",
      skuUnit: "шт.",
      currency: "₽",
      source: "Источники",
      marginFull: "Наценки и маржинальность",
      strategy: "Сегменты и стратегии",
      stage: "Стадия",
      status: "Статус",
      orders: "Заказы",
      revenue: "Выручка без комиссии",
      cost: "Себестоимость товаров",
      delivery: "Доставка",
      profit: "Прибыль",
      productSales: "Продажи товаров по количеству и прибыли",
      brand: "Бренд",
      name: "Наименование",
      quantity: "Количество",
      salesByPlatform: "Продажи товаров по площадкам",
      autopiter: "Автопитер",
      ozon: "Ozon",
      ym: "Яндекс Маркет",
      costProducts: "Себестоимость товаров",
      deviationNoOffers: "Мои предложения отсутствуют",
      deviationNotTopPosition: "Удержание на N месте",
      deviationMargin10Percent: "Разница до соседей 10%",
      deviationPriceMismatch: "Ошибка: цена не совпадает",
      deviationLackOfRivalry: "Предложений меньше 2",
      deviationMonopoly: "Нет конкурентов",
      stageNew: "Новый",
      stageSupplySelection: "Выбор обеспечения",
      stageTracking: "Отслеживание",
      stageShipment: "Отгрузка",
      stageDelivery: "Доставка",
      stagePickupPoint: "Получение ПВЗ",
      stageBuyerRefusal: "Отказ покупателя",
      ordersPeriodCount: "Количество заказов за период",
      itemsPeriodCount: "Количество товаров за период",
      activeOrdersCount: "Количество активных заказов",
      activeItemsCount: "Количество товаров по активным заказам",
      avgTimeInStatus: "Среднее время заказа в статусе за период",
      avgFormat: "Ср: {0}",
      profitTitle: "Прибыль – {value} руб.",
      tooltipValueRub: "{name}: {value} руб.",
      ordersTitle: "Заказы – {value} шт.",
      tooltipOrdersPcs: "{platform}: {value} шт. ({percent}%)",
      from: "С",
      to: "По",
      selectComparison: "Выберите сравнение",
      compare: {
        withoutComparison: "Без сравнения",
        yearOverYear: "Год к году",
        monthOverMonth: "Месяц к месяцу",
      },
      todayLabel: "Сегодня – {date}",
      notify: {
        summaryDataUpdated: "Данные сводной таблицы обновлены",
      },
    },
    emailAccount: {
      pageTitle: "Почтовые аккаунты",
      addAccount: "Добавить аккаунт",
      deleteAccount: "Удалить аккаунт",
      createTitle: "Добавить почтовый аккаунт",
      editTitle: "Редактировать почтовый аккаунт",
      name: "Название",
      fromEmail: "Email отправителя",
      smtpServer: "SMTP сервер",
      smtpUsername: "Логин SMTP",
      smtpPassword: "Пароль SMTP",
      imapServer: "IMAP сервер",
      outgoingMail: "Отправка писем",
      incomingMail: "Получение писем",
      imapFolder: "Название папки с заказами",
      imapFolderHint: "Если нужно читать входящие, введите INBOX",
      encryption: "Шифрование",
      credentialPlaceholderEdit: "Оставьте пустым, если не меняете",
      credentialRequired: "Пароль обязателен",
      createSuccess: "Почтовый аккаунт успешно создан",
      updateSuccess: "Почтовый аккаунт успешно обновлён",
      deleteSuccess: "Почтовый аккаунт успешно удалён",
      deleteConfirm: "Вы уверены, что хотите удалить выбранные аккаунты?",
      showDisabled: "Показывать удалённые",
      enableSuccess: "Почтовый аккаунт успешно включён",
      testConnection: "Проверить подключение",
      checkingConnection: "Проверяем подключение…",
      testConnectionSuccess: "Подключение успешно установлено",
      testConnectionError: "Не удалось подключиться к почтовому аккаунту. Проверьте настройки и повторите попытку",
      testConnectionPasswordHint: "Введите пароль для SMTP вашего почтового сервиса.",
      testConnectionHint: "Проверим доступность почтового сервера и корректность настроек.",
      testConnectionRepeat: "Проверить повторно",
      testConnectionRetry: "Повторить проверку",
      testConnectionErrorHint: "Проверьте адрес сервера, порт, логин, пароль и настройки шифрования.",
      statusActive: "Активен",
      statusDisabled: "Отключён",
    },
    platformSettingsImportPrice: {
      emailSectionTitle: "Импорт из письма",
      manualSectionTitle: "Ручная загрузка",
    },
    platformSettingsEmailImportProducts: {
      importInstructions:
        "Если ранее вы уже отправляли данной площадке свой прайс с помощью электронной почты, для импорта товаров через email выполните следующие шаги:",
      step1:
        "Откройте в вашей почте письмо с вложением (прайс-листом), которое вы использовали для последней загрузки на эту площадку.",
      step2Part1: "Нажмите кнопку ",
      step2Part2: "«Переслать»",
      step2Part3: " (Forward).",
      step3: "В поле получателя введите указанный ниже адрес электронной почты для импорта товаров.",
      step4: "Отправьте письмо.",
      autoImportNote: "После этого импорт товаров будет выполнен автоматически на основании пересланного прайс-листа.",
      mailWillBeUsed:
        "В будущем пересланный вами образец письма (c текстом, темой письма и почтой адресата) будет использован для обновления вашего прайса на этой площадке.",
      emailLabel: "Email для импорта:",
      copyEmail: "Скопировать адрес",
      noEmailAvailable: "Нет доступного email для импорта товаров.",
      mappingTitle: "Сопоставление колонок",
      loadingFilePreview: "Загрузка предпросмотра файла...",
      fileNotFound: "Файл прайс-листа не найден",
      mappingSuccess: "Сопоставление колонок сохранено",
    },
    import: {
      uploadPurchasePrices: "Загружаю",
      purchasePricesBold: "закупочные",
      purchasePricesSuffix: "цены",
      uploadFinalPrices: "Загружаю",
      finalPricesBold: "финальные",
      finalPricesSuffix: "цены",
      selectedCostType: "Выбран тип цен:",
      costInLabel: "Закупочные",
      costOutLabel: "Финальные для площадки",
      changeCostType: "Выбрать другой тип цен",
      defaultBrandPlaceholder: "Подставится в случае пустого бренда",
      selectCostTypeFirst: "Сначала выберите тип цены",
    },
    deviation: {
      title: "Настройка отклонений",
      statusCaption: "Статус",
      allowableDeviationTime: "Допустимое время отклонения",
      days: "дн.",
      hours: "ч.",
      minutes: "мин.",
    },
    pricekeeper: {
      title: "Настройки прайскипера",
      setDefault: "Установить по умолчанию",
      sectionMain: "Основные",
      pricingCycleDays: "Желаемая периодичность циклов проценки (в днях)",
      deliveryDaysLimit: "Введите допустимый срок доставки (в днях)",
      sectionReport: "Отчёт",
      priceDifferenceLabel: "Допустимая разница до соседней позиции (%)",
      offersLessThanLabel: "Количество предложений менее (шт.)",
      targetPositionLabel: "Целевая позиция в топе",
      baseCommissionLabel: "Базовая комиссия (%)",
      autoApplyModeLabel: "Автокоррекция цены",
      autoApplyModeOff: "Выключена",
      autoApplyModeDown: "Только понижать",
      autoApplyModeBoth: "Понижать и повышать",
      autoApplyModeHint:
        "«Только понижать» — цена идёт вниз вслед за конкурентами, но сама вверх не поднимается. Поднять её можно вручную, задав цену в карточке товара.",
      autoStartLabel: "Автозапуск анализа при изменениях",
      gridColumn: "Прайскипер",
      editRules: "Правила позиционирования",
      saveError: "Не удалось сохранить настройки прайскипера",
      defaultSettingsApplied: "Настройки прайскипера установлены по умолчанию!",
      savedSuccessfully: "Настройки прайскипера успешно сохранены!",
      maxDiffPercentLabel: "Допустимая разница с ближайшим конкурентом, %",
      maxDiffPercentHint:
        "На сколько процентов цена ближайшего конкурента может отличаться от вашей, прежде чем это считается отклонением",
      settingsSavedNotice: "Настройки сохранены. Прайскипер применит их при следующем анализе",
      settingsStaleNotice:
        "Данные от {date}; настройки изменены позже — отчёт может не соответствовать текущим настройкам",
    },
    eventFeed: {
      searchPlaceholder: "Поиск по ключевому слову",
      find: "Найти",
      export: "Экспортировать",
      columnEventType: "Тип события",
      columnTimestamp: "Временная метка",
      columnTab: "Вкладка",
      columnDescription: "Описание",
      columnObject: "Объект",
      columnSkuChanges: "Позиций SKU с изменениями",
      columnSku: "SKU",
      columnOrder: "Заказ",
      columnOrderDate: "Дата заказа",
    },
    myPrices: {
      nameCaption: "Наименование",
      itemsCountColumn: "Количество товаров",
      createdAt: "Дата создания",
      updatedAt: "Дата изменения",
    },
    platforms: {
      addPlatform: "Добавить площадку",
      deletePlatform: "Удалить площадку",
      createdAt: "Дата создания",
      updatedAt: "Дата изменения",
      editSettingHint: "Редактировать настройку",
      confirmTitle: "Подтверждение",
      no: "Нет",
      yes: "Да",
      gridNotInitialized: "Компонент таблицы ещё не инициализирован",
      selectAtLeastOne: "Пожалуйста, выберите хотя бы одну площадку для удаления",
      deleteConfirm: "Вы уверены, что хотите удалить выбранные площадки?",
      deletedSuccessfully: "Выбранные площадки успешно удалены!",
      deleteError: "Ошибка при удалении площадок. Попробуйте ещё раз.",
      selectPlatformTitle: "Выберите платформу для подключения",
      configurePlatformHint: "Настроить платформу",
    },
    ordersPage: {
      allTab: "Все",
      statusFallback: "Статус {status}",
      orderCard: "Карточка заказа №{number}",
    },
    automation: {
      title: "Настройки автоматизации процессов",
      sectionNew: "Новый",
      searchSupplyLaunch: "Запуск поиска обеспечения",
      auto: "Автоматически",
      manual: "Вручную",
      notifyEmployee: "Уведомлять ответственного сотрудника о поступлении нового заказа",
      selectMethod: "Выберите способ",
      notificationNone: "Ничего",
      enterEmail: "Введите Email",
      sectionSelectCollateral: "Выбор обеспечения",
      sectionSendOrder: "Отправка заказа",
      reserveOnStock: "Резервирование на складе при наличии остатков",
      externalSuppliers: "Размещение у внешних поставщиков",
      selectMode: "Выберите режим",
      supplierByCriteria: "Выбор поставщика по заданным критериям",
      generateShipmentDocs: "Генерация документов для отгрузки",
      sectionRejectHandling: "Обработка отказа",
      notifyOnReject: "Уведомлять при отказе поставщика или клиента",
      retryOnReject: "Повторное обеспечение при отказе",
      sectionWhatIf: "Что если?",
      noStockLabel: "Нет складских остатков и поставщиков",
      selectAction: "Выберите действие",
      autoReject: "Автоматический отказ от заказа",
      notifyForManual: "Уведомить для ручного решения",
      supplierDelay: "Поставщик задерживает сроки",
      autoReorderSupplier: "Автоматический перезаказ у другого поставщика",
      notifyWithOptions: "Уведомить с предложением вариантов",
      clientNoPickup: "Клиент не забирает из ПВЗ",
      autoTransferBuyerRefusal: 'Автоматический перевод в "Отказ покупателя"',
      notifyReverseLogistics: "Уведомить для организации обратной логистики",
      timeoutBuyerRefusal: "Таймаут до «Отказ покупателя»",
      daysPlaceholder: "Дни",
      hoursPlaceholder: "Часы",
      minutesPlaceholder: "Минуты",
      daysUnit: "дн.",
      hoursUnit: "ч.",
      minutesUnit: "мин.",
      transportNoConfirm: "Транспортная компания не подтверждает доставку",
      autoRetryRequest: "Повторная автоматическая подача заявки",
      notifyManualControl: "Уведомить для ручного контроля",
      sectionAutoUpdatePrice: "Автообновление моего прайса",
      suggestAutoStrategy: "Предлагать автовыбор стратегии:",
      approvalParams: "Параметры согласования критических условий:",
      approvalAuto: "Применить автоматически",
      approvalWaitResponsible: "Позвать ответственного и ждать согласования",
      approvalViaLink: "Согласовать через ссылку",
      notifyLabel: "Уведомлять:",
      selectNotificationMethod: "Выберите способ уведомления",
      emailLabel: "Email:",
      enterEmailPlaceholder: "Введите email",
      savedSuccessfully: "Настройки автоматизации процессов успешно сохранены!",
      sectionExportTriggers: "Выгрузка прайс-листа",
      exportOnPriceRecalculation: "Автоматическая выгрузка после пересчёта цен",
      autoApplyModeLabel: "Автокоррекция цены прайскипером",
      autoApplyModeOff: "Выключена",
      autoApplyDirectionDown: "Только понижать",
      autoApplyDirectionBoth: "Понижать и повышать",
      autoApplyDirectionHintDown:
        "Цена идёт вниз вслед за конкурентами, но сама вверх не поднимается — даже если конкуренты далеко выше. Поднять её можно вручную, задав цену в карточке товара.",
      autoApplyDirectionHintBoth:
        "Цена двигается в обе стороны вслед за расчётом: и снижается вслед за конкурентами, и поднимается, когда до ближайшего конкурента далеко вверх.",
      sectionUndercutLadder: "Подрез цены конкурента",
      undercutLadderActive: "Применять прогрессивную шкалу подреза",
      undercutLadderHint:
        "Насколько рублей вставать ниже конкурента, в зависимости от его цены. Работает так же, как прогрессивные наценки: применяется самая высокая подходящая ступень. Цена конкурента ниже первой ступени — подреза нет.",
      undercutLadderFrom: "Цена конкурента от, ₽",
      undercutLadderStep: "Подрез, ₽",
      undercutLadderFromPlaceholder: "например, 1000",
      undercutLadderStepPlaceholder: "например, 100",
      undercutLadderAddTier: "Добавить ступень",
      undercutLadderEmpty: "Ступеней нет",
      undercutLadderErrorEmpty: "Включённая шкала должна содержать хотя бы одну ступень",
      undercutLadderErrorCount: "Ступеней в шкале не может быть больше {max}",
      undercutLadderInactiveHint: "Шкала выключена — ступени сохранятся, но подрез пока не применяется.",
      undercutLadderErrorStep: "Подрез должен быть больше нуля",
      undercutLadderErrorFrom: "Цена конкурента не может быть отрицательной",
      undercutLadderErrorDuplicate: "Две ступени не могут начинаться с одной и той же цены",
      sectionPriceFormation: "Формирование цены",
      sectionMonopolyMarkup: "Наценка монополиста",
      monopolyMarkupActive: "Применять наценку, если нет конкурентов",
      monopolyMarkupValue: "Размер наценки, %",
      saveError: "Не удалось сохранить настройки",
      loadError: "Не удалось загрузить настройки автоматизации",
    },
    emailAccountPage: {
      smtpPort: "SMTP порт",
      imapPort: "IMAP порт",
      port: "Порт",
      enableHint: "Включить",
      editHint: "Редактировать",
    },
    platformSettingsLogin: {
      onChangeLabel: "После каждого обновления источников и рыночных цен",
      scheduleLabel: "График обновлений",
      criticalLabel: "Всегда при критических остатках",
      workingDays: "Рабочие дни",
      calendarDays: "Календарные дни",
      eplexCredentialsTitle: "Учётные данные площадки (Eplex)",
      eplexCredentialsSetup: "Настроить учётные данные",
      eplexCredentialsEdit: "Изменить учётные данные",
      eplexCredentialsSaved: "Учётные данные сохранены",
      eplexCredentialsBound: "Учётные данные привязаны",
      pricekeeperProfileLabel: "Профиль Прайскипера",
      pricekeeperProfilePlaceholder: "Выберите профиль",
      selectProfileFirst: "Сначала выберите профиль Прайскипера",
      credentialsChooserTitle: "Выбор учётных данных",
      credentialsChooserExisting: "Уже настроенные учётные записи",
      credentialsAddNew: "Добавить новую",
      safeModeLabel: "Безопасный режим",
      safeModeHint:
        "Опасные письма (прайс-лист поставщику, подтверждение и отмена заказа) не уходят контрагенту, а приходят копией вам.",
      cannotDeterminePlatform: "Не удалось определить площадку. Перезагрузите страницу или обратитесь в поддержку.",
      alreadyAuthorized: "Площадка уже авторизована и готова к работе.",
      authorizedSuccessfully: "Площадка успешно авторизована и сохранена.",
      authorizationFailed: "Не удалось авторизовать площадку. Проверьте введённые данные и попробуйте ещё раз.",
      saveFailed: "Не удалось сохранить настройки поставщика. Проверьте введённые данные и попробуйте ещё раз.",
      authorizationUnexpectedError: "Во время авторизации произошла непредвиденная ошибка. Попробуйте повторить позже.",
      apiImportStarted: "Мы самостоятельно запустили импорт товаров и ручной импорт не требуется.",
    },
    platformSettingsTabsPage: {
      backToList: "Вернуться к списку поставщиков",
    },
    footerTabs: {
      products: "Товары",
      aboutBuyer: "О покупателе",
      documents: "Документы",
      history: "История",
      provision: "Обеспечение",
    },
    ordersTabs: {
      platformIcon: "Иконка площадки",
      platform: "Площадка",
      orderDate: "Дата заказа",
      number: "№",
      quantityFull: "Количество",
      quantityShort: "Кол-во",
      sum: "Сумма",
      priceList: "Прайс",
      status: "Статус",
      timeInStatus: "Время в статусе",
      deliveryDeadline: "Срок отгрузки",
      buyer: "Покупатель",
      comment: "Комментарий",
      marginCostPrice: "Маржа + себест.",
      issueWarehouse: "Склад выдачи",
      recommendation: "Рекомендация",
      tracking: "Отслеживание",
      code1C: "Код в 1C",
      buyerRefusal: "Отказ покупателя",
      action: "Действие",
      collateralProvide: "Обеспечить",
      collateralRefuse: "Отказать в обспечении",
      supplySettingsHint: "Настройки поиска обеспечения",
      clearFiltersHint: "Очистить фильтры",
      columnChooserHint: "Выбор колонок",
      moveToArchive: "Перевести в «Архив»",
      receiveGoods: "Оприходовать",
      selectCompleted: "Выбрать выполненные заказы",
      cannotChangeStatusInWork: "Невозможно перевести в другой статус заказы, которые находятся в статусе «В работе».",
      moveToDelivery: "Перевести в «Доставка»",
      moveToWaitingForIssue: "Перевести в «Ожидает выдачи в ПВЗ»",
      recommendations: "Рекомендации",
      providedPercent: "Обеспечено (%)",
      collateralColumn: "Обеспечение",
      fullyProvided: "Полностью",
      partiallyProvided: "Частично",
      supplierPosition: "Позиция поставщика",
      supplier: "Поставщик",
      searchDate: "Дата поиска",
      deliveryDate: "Дата поставки",
      term: "Срок",
      findSupplyWithCorrections: "Найти обеспечение с учётом корректировок",
      restartSupplySearch: "Перезапустить поиск",
      restartSupplySearchHint: "Запустить поиск обеспечения заново. Текущая рекомендация будет сброшена.",
      restartSupplySearchConfirmTitle: "Перезапустить поиск обеспечения",
      restartSupplySearchConfirm: "Текущая рекомендация будет потеряна. Запустить новый поиск обеспечения?",
      noRecommendationsBadge:
        "По заказу не найдено ни одной рекомендации. Рекомендуем перезапустить поиск или отказаться от обеспечения.",
      noRecommendationsRowHint: "Поиск завершён без рекомендаций — рекомендуется перезапустить.",
    },
    productsTab: {
      article: "Артикул",
      brand: "Бренд",
      name: "Наименование",
      shipmentDeadline: "Срок отгрузки",
      priceList: "Прайс",
      warehouse: "Склад",
      status: "Статус",
      comment: "Комментарий",
      qty: "Кол-во",
      salePrice: "Цена реализации",
      rejectQty: "Отказать, шт",
    },
    documentsTab: {
      noDocuments: "Нет сформированных документов",
      documentsCaption: "Документы",
    },
    triggerLabels: {
      noOffers: "Нет предложений",
      notTopPosition: "Не в ТОП",
      priceMismatch: "Ошибка цены",
      marginTenPercent: "Близкая цена",
      lackOfRivalry: "Мало конкурентов",
      monopoly: "Монополия",
      belowCost: "Ниже себестоимости",
      belowCostAllowed: "Ниже себестоимости (разрешено)",
      belowMinMargin: "Ниже мин. маржи",
      priceAnomaly: "Ценовая аномалия",
      costUnknown: "Нет себестоимости",
      positionUndetermined: "Позиция не определена",
      newItems: "Новые",
    },
    priceStatuses: {
      labels: {
        manualInput: "Ручной ввод",
        needsDecision: "Нужно ваше решение",
        notOnPlatform: "Нет на площадке",
        excludedFromPrice: "Исключён из прайса",
        priceUpdated: "Цена обновлена",
      },
      hints: {
        manualInput:
          "Цена задана вручную и зафиксирована — система не будет пересчитывать её автоматически, пока фиксация не снята",
        needsDecision: "Нужно зайти и вручную задать цену. Без этого действия цена не изменится",
        notOnPlatform: "Прайскипер не нашёл этот товар на площадке — сравнивать цену не с чем, нужно задать её вручную",
        excludedFromPrice: "Товар снят с продажи на площадке. Чтобы вернуть — нужно пересмотреть минимальную цену",
        priceUpdated: "Всё в порядке, никаких действий не требуется",
      },
      reasons: {
        matchedCompetitors: "Цена подстроена под конкурентов автоматически",
        noCompetitors: "Конкурентов нет, выставлена ваша желаемая цена",
        priceFloor: "Цена выставлена по минимуму/себестоимости",
        platformEqualizes: "Площадка сама выравнивает цену — менять не нужно",
        targetPositionReached: "Вы на целевой позиции",
        targetPositionNoExportPrice: "Вы на целевой позиции, но цены выгрузки в МП нет",
      },
      reasonHints: {
        targetPositionNoExportPrice:
          "Задайте цену выгрузки — без неё МП не выгрузит товар на площадку",
      },
    },
    summarySignals: {
      price_not_match: "Цена на площадке ниже, чем в прайсе",
      top_price: "Есть более дешёвые конкуренты выше в выдаче",
      price_diff: "Цена вышла за допустимый коридор относительно конкурентов",
      min_offer_count: "Слишком мало конкурентов, чтобы уверенно сравнивать",
      empty_report: "Пустой отчёт с площадки",
      price_equalized: "Площадка сама выровняла цену",
      no_signals: "Без сигналов",
    },
    pivotSummaryPresets: {
      filtersTitle: "Фильтры",
      listHint: "Сохранённые пресеты",
      saveHint: "Сохранить текущие фильтры",
      clearHint: "Сбросить фильтры",
      activeChipHint: "Включён пресет. Нажмите, чтобы открыть список.",
      activeChipModifiedHint: "Фильтры отличаются от пресета. Откройте список, чтобы перезаписать его.",
      modifiedTag: "изменён",
      listTitle: "Пресеты фильтров",
      standardSection: "Стандартные",
      ownSection: "Мои пресеты",
      expandShow: "Показать настройки",
      expandHide: "Скрыть настройки",
      ownEmpty: "Своих пресетов пока нет.",
      ownEmptyHint: "Настройте статусы, сигналы и период, затем нажмите воронку с галочкой.",
      loadError: "Не удалось загрузить пресеты фильтров",
      switchOn: "Включить",
      switchOff: "Выключить",
      switchAria: "Включить пресет {name}",
      differs: "Фильтры на странице отличаются от пресета.",
      revert: "Вернуть как в пресете",
      saveAsOwn: "Сохранить как свой",
      overwriteCurrent: "Перезаписать текущими",
      rename: "Переименовать",
      renameAria: "Новое название",
      delete: "Удалить",
      cancel: "Отмена",
      save: "Сохранить",
      overwrite: "Перезаписать",
      nameCounter: "{count}/{max} символов",
      deleteConfirm: "Удалить пресет «{name}»? Он пропадёт у всех сотрудников компании.",
      savedToday: "Сохранён сегодня",
      savedYesterday: "Сохранён вчера",
      savedOn: "Сохранён {date}",
      saveTitle: "Сохранить пресет",
      saveLead:
        "В пресет сохраняются вместе: выбранные статусы, сигналы и период по данным о рынке. Настройки таблицы (поля и фильтры по полям) не сохраняются. Пресет увидят все сотрудники вашей компании.",
      saveModeAria: "Как сохранить",
      saveAsNew: "Сохранить как новый пресет",
      overwriteOption: "Перезаписать «{name}»",
      overwriteOptionHint: "Название останется прежним, фильтры заменятся текущими.",
      nameLabel: "Название пресета",
      namePlaceholder: "Например: Нужно решение за неделю",
      summaryTitle: "Будут сохранены фильтры:",
      groupStatuses: "Статусы",
      groupSignals: "Сигналы",
      groupPeriod: "Данные о рынке",
      allStatuses: "Все статусы",
      allSignals: "Все сигналы",
      noSignals: "Ни одного",
      customDatesWarning: "Свои даты ({range}) в пресет не сохраняются. Что сохранить вместо них?",
      periodChoiceAria: "Период в пресете",
      noPeriod: "Без периода",
      periodDays: "{days} дн.",
      chips: {
        unrestricted: "Без ограничений",
        signals: "Сигналы: {list}",
        period: "Период: {period}",
        signalsNone: "ни одного",
        signalsAllExcept: "все, кроме {list}",
        quoted: "«{name}»",
        and: " и ",
      },
      errors: {
        nameTooLong: "Не больше {max} символов.",
        nameStandard: "«{name}» — название стандартного пресета. Выберите другое.",
        nameDuplicate: "Пресет «{name}» уже есть. Выберите другое название или перезапишите существующий.",
        limitReached:
          "Сохранено уже {limit} пресетов — это максимум. Удалите ненужный или перезапишите существующий.",
        saveFailed: "Не удалось сохранить пресет",
        renameFailed: "Не удалось переименовать пресет",
        deleteFailed: "Не удалось удалить пресет",
        // Отказы сервера, которых интерфейс сам не проверяет (их текст приходит в ответе market)
        notFound: "Пресет не найден",
        standardCannotChange: "Стандартный пресет нельзя изменить",
        standardCannotDelete: "Стандартный пресет нельзя удалить",
      },
      toasts: {
        saved: "Пресет «{name}» сохранён и включён",
        overwritten: "Пресет «{name}» перезаписан",
        renamed: "Пресет переименован: «{name}»",
        deleted: "Пресет «{name}» удалён",
        reset: "Фильтры сброшены",
        gone: "Включённый пресет удалили. Сводная открыта без него.",
      },
    },
    userProducts: {
      lastUpdate: "Последнее обновление",
      noSegment: "Без сегмента",
      editSuccess: "Изменения сохранены",
      editError: "Не удалось сохранить изменения",
      editRejected: "Не удалось сохранить изменение — обновите страницу и попробуйте снова",
      editableColumnHint:
        "Значение можно изменить: клик по ячейке, затем подтвердите зелёной галочкой или Enter. Клик мимо ячейки или Esc — отмена. Правка действует до следующей загрузки прайс-листа",
      editConfirmHint: "Сохранить изменение (Enter)",
      editCancelHint: "Отменить правку (Esc)",
      segmentColumnHint: "Сегмент меняется у товара целиком — во всех прайс-листах",
      priceOnPlatforms: "Цена на площадках",
      totalLabel: "Всего",
      totalHint: "Показать все товары прайс-листа и снять выбранные фильтры",
      chipToggleHint:
        "Клик — включить фильтр, повторный клик — выключить. Можно выбрать несколько: покажем товары, попадающие хотя бы в один",
      outOfStockLabel: "Нет в наличии",
      newLabel: "Новые",
      noSegmentLabel: "Без сегмента",
      costMissingLabel: "Без себестоимости",
      chipRowHidden:
        "Товар больше не подходит под фильтр «{filter}» и скрыт из списка. Нажмите «Всего», чтобы увидеть его снова.",
      chipRowHiddenMulti:
        "Товар больше не подходит под выбранные фильтры и скрыт из списка. Нажмите «Всего», чтобы увидеть его снова.",
      costMissingShort: "нет с/с",
      costMissingHint: "Себестоимость не задана: маржа и коридор рассчитаны из цены продажи (допущение)",
      costMissingBanner: "{count} поз. без себестоимости — маржинальность ориентировочная, задайте закупочную цену",
      deviationFilterPlaceholder: "Фильтр по отклонениям",
      selectDataPlaceholder: "Выберите данные для отображения",
      updatedLabel: "Обновлено: {date}",
      pricePolicyLabel: "Ценовая политика: {title}",
      pricePolicyNotSet: "не назначена",
      pricePolicyEditHint: "Изменить ценовую политику",
      loadingLabel: "загрузка...",
      notExportedLabel: "Прайс не выгружался",
      upload: "Выгрузить",
      addProducts: "Добавить товары",
      columnMyPrice: "Отправляемая цена",
      columnPosition: "Позиция",
      columnDelta: "Дельта",
      columnMarginPercent: "Маржа (%)",
      uploadStarted: "Запущен процесс выгрузки прайса",
      exportSelectPlatform: "Выберите площадку для выгрузки",
      exportConfirm: "Выгрузить",
      exportCancel: "Отмена",
      exportSuccess: "Экспорт поставлен в очередь",
      exportError: "Ошибка запуска экспорта",
      exportHistory: "История выгрузок",
      exportHistoryEmpty: "Нет записей",
      exportLastUpload: "Последняя выгрузка",
      exportNoPlatforms: "Нет привязанных площадок",
      exportLoadMore: "Загрузить ещё",
      exportReadinessNoPlatforms: "Нет привязанных площадок для выгрузки",
      exportReadinessNoItems: "Нет товаров с рассчитанной ценой для выгрузки",
      exportReadinessError: "Ошибка проверки готовности к выгрузке",
      exportGuardTitle: "Проверка цен перед выгрузкой",
      exportGuardHint:
        "Обнаружены товары с потенциально опасными ценами. Проверьте список и решите, выгружать ли прайс-лист.",
      exportGuardCritical: "Критических: {count}",
      exportGuardWarning: "Предупреждений: {count}",
      exportGuardProceed: "Выгрузить всё равно",
      exportGuardBlockedBadge: "Выгрузка заблокирована гейтом цен",
      exportGuardWarningToast: "Внимание: {count} товаров с резким отклонением цены — проверьте перед выгрузкой",
      exportGuardColArticle: "Артикул",
      exportGuardColBrand: "Бренд",
      exportGuardColStrategy: "Стратегия",
      exportGuardColCostIn: "Себестоимость",
      exportGuardColCostMin: "Мин. цена",
      exportGuardColCostOut: "Цена выгрузки",
      exportGuardColPrevious: "Прошлая цена",
      exportGuardColReason: "Причина",
      guardReasonBelowCost: "Ниже себестоимости",
      guardReasonBelowCostAllowed: "Ниже себестоимости — разрешено вашей настройкой",
      guardReasonBelowMinMargin: "Ниже мин. маржи",
      guardReasonPriceAnomaly: "Резкое отклонение от прошлой цены",
      guardStrategy: {
        optimal: "Оптимальная",
        max_turnover: "Макс. оборот",
        max_profit: "Макс. прибыль",
        sale: "Распродажа",
        non_liquid: "Неликвид",
      },
      analysisLoadError: "Ошибка при загрузке анализа товара",
      screenLoadError: "Ошибка при загрузке скрина проценки",
      refreshConfirm: "Вы уверены, что хотите хотите запустить процесс актуализации данных для анализа рынка?",
      refreshStarted: "Запущен процесс актуализации данных для анализа рынка",
      recalculate: "Пересчитать цены",
      recalculateConfirm: "Запустить пересчёт цен для этого прайс-листа?",
      recalculateStarted: "Пересчёт цен поставлен в очередь",
      recalculateError: "Ошибка запуска пересчёта цен",
      applyRecommendedAll: "Применить рекомендации",
      applyRecommendedConfirm: "Применить рекомендованные цены ко всем позициям прайс-листа?",
      applyRecommendedConfirmAuto:
        "Авто-применение рекомендованных цен включено — цены применяются автоматически после анализа. Применить сейчас ко всем позициям и поставить выгрузку?",
      applyRecommendedSuccess: "Применено рекомендованных цен: {count}",
      applyRecommendedError: "Ошибка применения рекомендованных цен",
      manualAddTitle: "Ручное добавление товара",
      confirmTitle: "Подтверждение",
      yes: "Да",
      no: "Нет",
      screenTitle: "Скрин проценки",
      analysisTitle: "Анализ товара",
      updatedSuffix: "обновлено: {date}",
      platformsButton: "Площадки ({count})",
      managePlatforms: "Управление площадками",
      attachPlatform: "Привязать",
      detachPlatform: "Отвязать",
      noPlatformsAttached: "Нет привязанных площадок",
      selectPlatform: "Выберите площадку",
      platformAttached: "Площадка привязана",
      platformDetached: "Площадка отвязана",
      platformAttachError: "Ошибка привязки площадки",
      platformDetachError: "Ошибка отвязки площадки",
      allPlatformsAttached: "Все площадки уже привязаны",
    },
    detailedTable: {
      article: "Артикул",
      brand: "Бренд",
      costPrice: "Себестоимость",
      minPrice: "Мин. цена",
      metricColumn: "Показатель",
      platformColumn: "Платформа",
      accountColumn: "Аккаунт",
      accountPositionColumn: "{account} · {position}",
      myCostSite: "Цена на сайте",
      sentPrice: "Отправлено при проценке",
      reportCommission: "Комиссия (проценка)",
      competitorPercentiles: "Цены конкурентов (перцентили)",
      position: "Позиция",
      myPrice: "Отправляемая цена",
      recommendedPrice: "Рекомендуемая цена",
      priceJustification: "Аргументация цены",
      justificationManualPrice:
        "Цена задана вручную, поэтому рекомендация не применяется и объяснять нечего. Уберите ручную цену, чтобы система снова считала её сама.",
      justificationNotCalculated: "Рекомендация по этой площадке ещё не рассчитана — пересчёта цен не было.",
      justificationPending:
        "Цена рассчитана до появления аргументации — пояснение появится после следующего пересчёта цен.",
      delta: "Дельта",
      marginPercent: "Маржа (%)",
      priceStatus: "Статус",
      message: "Сообщение",
      noAnalysisDataMessage:
        "Проценка не вернула ни одного предложения — данных по площадке нет. Сравнивать цену не с чем.",
      sitePriceNotFromMpHint: "Цена на сайте не из МП — комиссия и рекомендация ненадёжны",
      staleReportNotice:
        "Отчёт от {date}; настройки прайскипера изменены позже — данные могут не соответствовать текущим настройкам",
      noDataText: "Нет данных. Для расчётов необходимо обновить рыночные цены или поменять стратегию",
      selectedStrategy: "Выбранная стратегия:",
      strategyFactorsToggle: "Как считаются цена и статус",
      strategyPriceFactors: "Цена:",
      strategyStatusFactors: "Статус:",
      refreshMarketPrices: "Обновить рыночные цены",
      scrollRightHint: "Площадок больше, чем помещается на экране — прокрутите таблицу вправо",
      refreshRequested: "Запрос на обновление рыночных цен отправлен",
      refreshError: "Не удалось отправить запрос на обновление рыночных цен",
      openScreenPricing: "Открыть скрин проценки",
      reportUpdatedAt: "Отчёт от",
      costOutOverride: "Ручная цена",
      resetOverride: "Сбросить",
      overrideApplied: "Ручная цена установлена",
      overrideCleared: "Ручная цена сброшена",
      overrideError: "Ошибка при установке ручной цены",
      acceptRecommended: "Принять рекомендованную цену",
      overrideConfirmHint: "Сохранить ручную цену (Enter). Пустое поле — сбросить ручную цену",
      overrideCellHint: "Клик — задать ручную цену, пустое поле — сбросить",
      acceptRecommendedReplacesOverride: "Ручная цена будет удалена, применится рекомендованная системой",
      acceptRecommendedOverrideConfirmTitle: "Заменить ручную цену?",
      acceptRecommendedOverrideConfirmMessage:
        "У позиции задана ручная цена. Она будет удалена, а вместо неё применится рекомендованная системой цена. Продолжить?",
      acceptRecommendedOverrideConfirmOk: "Удалить и применить",
      sentPriceOverriddenHint: "Значение задано ручной ценой — именно оно уйдёт на площадку",
      recommendedApplied: "Рекомендованная цена применена",
      recommendedError: "Ошибка при применении рекомендованной цены",
      hints: {
        position:
          "Наша позиция среди предложений на площадке по данным последнего отчёта прайскипера (1 — первое место).",
        myPrice:
          "Цена, которую система отправляет на площадку. Меняется импортом прайса, применением рекомендации или ручной ценой.",
        myCostSite: "Наша фактическая цена на площадке с учётом комиссии — из отчёта прайскипера.",
        sentPrice:
          "Цена, которая стояла на момент последней проценки. Отличается от отправляемой, если цену меняли после отчёта.",
        reportCommission: "Комиссия площадки по данным проценки (из отчёта прайскипера).",
        minPrice: "Минимально допустимая цена по политике ценообразования — ниже неё цена не опускается.",
        costOutOverride:
          "Ручная цена: заданная вручную, переопределяет расчётную. Пусто — используется расчётная цена.",
        recommendedPrice: "Рекомендованная прайскипером цена с учётом выбранной стратегии и цен конкурентов.",
        priceJustification:
          "Почему система рекомендует именно такую цену: какая ветка стратегии сработала и какие числа в ней участвовали. Пусто, если цена задана вручную или расчёт был до появления аргументации.",
        delta: "Разница между ценой лучшего конкурента и нашей ценой на сайте площадки (положительная — мы дешевле).",
        marginPercent: "Маржинальность при текущей цене: (цена − себестоимость) / цена × 100%.",
        competitorPercentiles:
          "Распределение цен конкурентов по перцентилям (например, p25/p50/p75) из отчёта прайскипера.",
        message: "Пояснение по сработавшему триггеру / рекомендация по цене для этого аккаунта.",
      },
    },
    screenTable: {
      collapseAll: "Свернуть всё",
      expandAll: "Развернуть всё",
      supplier: "Поставщик",
      platform: "Площадка",
      position: "Позиция",
      article: "Артикул",
      brand: "Бренд",
      name: "Наименование",
      warehouse: "Склад",
      city: "Город",
      ownAvailability: "Наличие свое",
      remainder: "Остаток",
      term: "Срок",
      availabilityChance: "Шанс наличия",
      reliableSupplier: "Надёжный поставщик",
      category: "Категория",
      price: "Цена",
      reportUpdatedAt: "Отчёт от",
      back: "Назад",
      noDataText: "Нет данных. Для расчётов необходимо обновить рыночные цены или поменять стратегию",
    },
    addingProduct: {
      articleCaption: "Артикул",
      brandCaption: "Бренд",
      nameCaption: "Наименование",
      segmentCaption: "Сегмент",
      costCaption: "Себестоимость",
      quantityCaption: "Количество",
      timeCaption: "Срок поставки",
      importSuccess: "Успешно добавлено товаров: {count}",
      updateSuccess: "Товар обновлён",
      deleteSuccess: "Товар удалён",
      importError: "Не удалось добавить товары",
      loadError: "Не удалось загрузить товары",
      batchUpdateSuccess: "Успешно обновлено товаров: {count}",
      batchDeleteSuccess: "Успешно удалено товаров: {count}",
    },
    pivotSummary: {
      title: "Сводная",
      refresh: "Обновить данные",
      refreshWithChanges: "Обновить ({count})",
      loadError: "Не удалось загрузить сводную. Попробуйте обновить",
      refreshChangesHint: "С момента загрузки сводной на сервере изменилось товаров: {count}. Нажмите, чтобы обновить",
      downloadExcel: "Скачать Excel",
      downloadExcelInProgress: "Формируется…",
      downloadExcelError: "Не удалось сформировать файл",
      downloadExcelFileName: "Сводная",
      expandAll: "Раскрыть всё",
      collapseAll: "Свернуть всё",
      deviationFilter: "Фильтр по отклонениям",
      fields: {
        article: "Артикул",
        brand: "Бренд",
        name: "Наименование",
        segment: "Сегмент",
        groupCode: "Объединяющий код",
        priceListName: "Прайс-лист",
        platformName: "Площадка",
        account: "Аккаунт",
        isEnabled: "Активен",
        isEnabledYes: "Да",
        isEnabledNo: "Нет",
        costIn: "Себестоимость",
        costTrade: "Цена с наценкой",
        costTradeOverride: "Цена (ручная)",
        costMin: "Мин. цена",
        costOut: "Цена на площадке",
        myCostSite: "Цена на сайте",
        reportCommission: "Комиссия (проценка)",
        sentPrice: "Отправленная цена",
        costOutOverride: "Цена (ручная, площадка)",
        commission: "Комиссия",
        costLastRecommend: "Рекоменд. цена",
        count: "Кол-во",
        time: "Срок, дн.",
        margin: "Маржа",
        competitorCount: "Кол-во конкурентов",
        bestCompetitorPrice: "Лучшая цена конкурента",
        ownPosition: "Позиция",
        topPosNum: "Желаемая позиция",
        positionDiff: "Откл. позиции",
        fieldChooserTitle: "Поля",
      },
      clearFilters: "Очистить фильтры",
      disabledItemHint:
        "Позиция исключена из прайса: расчётная цена оказалась ниже себестоимости. В выгрузку не попадает.",
      analysisPopupTitle: "Анализ площадок",
      segmentStrategyLabel: "Стратегия",
      segmentTopPositionLabel: "Топ",
      statusColumn: "Статус",
      excludedClickHint: "Нажмите, чтобы открыть аналитику и вернуть товар в прайс",
      itemChoiceHint: "Товаров в строке: {count} — двойной клик, чтобы выбрать",
      metricSumHint: "При группировке суммируется",
      metricAvgHint: "При группировке усредняется (по непустым значениям)",
      itemChooser: {
        title: "Выберите товар",
        lead: "В строке сводной несколько товаров. Выберите, чей анализ открыть",
        positions: "позиций: {count}",
        noName: "Без наименования",
        empty: "Товары не найдены — возможно, данные изменились. Обновите сводную",
        truncated: "Показаны первые {count} товаров",
        loadError: "Не удалось загрузить товары строки",
      },
      openPriceListHint: "Открыть прайс-лист",
      previousPriceHint: "Предыдущая цена: {price} ₽",
      staleReportHint: "Данные от {date}, настройки изменены позже",
      signalFilterPlaceholder: "Сигналы",
      signalFilterAll: "Сигналы: все",
      signalFilterSelected: "Сигналы: {selected} из {total}",
      signalFilterAllShort: "все",
      signalFilterCount: "{selected} из {total}",
      signalFilterDialogLabel: "Фильтр по сигналам",
      noSignalsSelected: "Не выбран ни один сигнал — выберите хотя бы один, чтобы увидеть данные",
      selectAllSignals: "Выбрать все",
      downloadExcelWithPeriod: "с периодом",
      shownItems: "Показано {shown} из {total}",
      reportPeriod: {
        label: "Данные о рынке",
        info: "Когда последний раз собирали цены и позиции конкурентов на площадках. Например, «За неделю» — товары, по которым рынок проверяли за последние 7 дней.",
        infoLabel: "Что такое данные о рынке",
        infoGlyph: "i",
        groupLabel: "Период по данным о рынке",
        all: "Всё время",
        days2: "Свежие",
        days3: "За 3 дня",
        days7: "За неделю",
        days30: "За месяц",
        days2Hint: "Данные за сегодня или вчера — последнее обновление ежедневного сегмента, во сколько бы оно ни было",
        days3Hint: "Данные за последние 3 дня, включая сегодня",
        days7Hint: "Данные за последние 7 дней, включая сегодня — последнее обновление недельных сегментов",
        days30Hint:
          "Данные за последние 30 дней, включая сегодня — покрывает и редкие сегменты (раз в 2 недели, раз в месяц)",
        custom: "Свои даты",
        customGlyph: "📅",
        customTitle: "Свой период",
        from: "с",
        to: "по",
        datePlaceholder: "дд.мм.гггг",
        customHint: "Границы включительно. Одну дату можно не заполнять — тогда период открыт с этой стороны.",
        reversedError: "Дата «с» позже даты «по». Поменяйте даты местами или исправьте одну из них.",
        cancel: "Отмена",
        apply: "Применить",
        removeCustom: "Убрать свои даты",
        removeCustomGlyph: "×",
        rangeText: {
          range: "{from} – {to}",
          since: "{from} – …",
          until: "… – {to}",
          day: "{from} – {to}",
        },
      },
      emptyPeriod: "Нет позиций с данными о рынке за этот период",
      emptyPeriodHint: "Попробуйте период шире или сбросьте его. Фильтры по статусам и сигналам тоже учитываются.",
      resetPeriod: "Сбросить период",
      emptyStatuses: "Нет позиций с выбранными статусами",
      resetStatuses: "Сбросить статусы",
      emptySignals: "Нет позиций с выбранными сигналами",
      resetSignals: "Сбросить сигналы",
      emptyFilters: "Нет позиций под выбранные фильтры",
    },
    priceSettingsSteps: {
      defaultSegmentsRadio: "Сегменты по умолчанию (ABC&XYZ анализ)",
      individualSegmentsRadio: "Индивидуальные сегменты",
      segment: "Сегмент",
      description: "Описание",
      strategy: "Стратегия",
      analysisRefreshFrequency: "Частота актуализации анализа",
      topPosition: "Топ-позиция",
      topPositionDash: "Топ\u2011позиция",
      enableDisable: "Вкл/Выкл",
      segmentDisabledPricekeeperStopped:
        "Анализ прайскипера по сегменту «{title}» остановлен. Для возобновления включите сегмент обратно",
      created: "Создано",
      updated: "Обновлено",
      daysCount: "Количество дней",
      marketPosition: "Позиция на рынке",
      addSegment: "+ добавить сегмент",
      dayOne: "день",
      dayFew: "дня",
      dayMany: "дней",
      notSpecified: "Не указано",
      oncePerDay: "Раз в день",
      everyNDays: "Каждые {days} {word}",
      platform: "Площадка",
      priceListUpdateFrequency: "Частота выгрузки на площадку",
      exportState: "Состояние выгрузки",
      baseCommission: "Базовая комиссия",
      addPlatform: "Добавить площадку",
      noOplMessage: "Сначала сохраните прайс-лист",
      rulesExplanation:
        "Определите правила формирования прайс-листа, настроив фильтры по сегменту, бренду, наименованию и другим параметрам.",
      quantity: "Количество",
      source: "Источник",
      deliveryTime: "Срок поставки",
      deliveryTimeGroup: "Группа срока поставки",
      inStock: "В наличии",
      upTo3Days: "<= 3 дня",
      upTo7Days: "<= 7 дней",
      noLimit: "Без ограничений",
      from: "От",
      rub: "руб.",
      selectBrand: "Выберите бренд",
      selectSegment: "Выберите сегмент",
      myPrice: "Моя цена",
      deleteRule: "Удалить правило",
      addRule: "Добавить правило",
      deleteGroup: "Удалить группу",
      baseDefault: "Базовые (по умолчанию)",
      appliedLast: "Применяется последним",
      addSegmentTitle: "Добавить сегмент",
      titleLabel: "Название",
      enterTitle: "Введите название",
      descriptionLabel: "Описание",
      enterDescription: "Введите описание",
      strategyLabel: "Стратегия",
      selectStrategy: "Выберите стратегию",
      enterTargetPosition: "Введите номер целевой позиции на рынке",
      specifyTopPosition: "Укажите топ\u2011позицию",
      rangeOneToHundredThousand: "Значение от 1 до 100 000",
      analysisRefreshFrequencyLabel: "Частота актуализации анализа",
      enterDaysCount: "Введите количество дней",
      specifyPeriod: "Укажите период",
      rangeOneToThreeSixtyFive: "Значение от 1 до 365",
      presetEvery6Hours: "Каждые 6 часов",
      presetEvery12Hours: "Каждые 12 часов",
      presetOncePerDay: "Раз в день",
      presetEvery2Days: "Каждые 2 дня",
      presetEvery3Days: "Каждые 3 дня",
      presetOncePerWeek: "Раз в неделю",
      presetEvery2Weeks: "Каждые 2 недели",
      presetOncePerMonth: "Раз в месяц",
      presetCustom: "Настраиваемый",
      customHint: "Укажите интервал обновления в днях и часах",
      customHintDays: "Укажите интервал обновления в днях, минимум 1 день",
      customHintExport: "Укажите интервал выгрузки в днях и часах, минимум {hours} часа",
      customEvery: "Каждые",
      customDaysAnd: "дней",
      customHoursSuffix: "часов",
    },
    exportPause: {
      belowMinimumHint: "Минимальная частота выгрузки — {hours} часа. Выберите период не короче.",
      paused: "Приостановлена",
      pausedHint:
        "Автоматическая выгрузка приостановлена: {reason}. Возобновится после устранения причины или успешной выгрузки вручную.",
      bannerOne: "Выгрузка на площадку «{platforms}» приостановлена: {reason}",
      bannerMany: "Выгрузка приостановлена на площадках: {platforms}",
      rowHintOne: "Выгрузка на площадку «{platforms}» приостановлена",
      rowHintMany: "Выгрузка приостановлена на площадках: {platforms}",
      reason: {
        price_guard: "выгрузку заблокировал контроль цен",
        file_template: "не задан шаблон файла прайса",
        file_generation: "не удалось сформировать файл прайса",
        recipients: "не заданы получатели прайса",
        smtp: "не настроен почтовый аккаунт для отправки",
        email_send: "не удалось отправить письмо с прайсом",
        system_mailer: "не настроена системная почта — обратитесь в поддержку",
        unknown: "непредвиденная ошибка выгрузки",
      },
    },
  },
  confirm: {
    confirm: "Подтвердить",
    cancel: "Отмена",
  },

  guidance: {
    nextButton: "Далее",
    skipStepButton: "Пропустить шаг",
    skipStepButtonTitle: "Пройти дальше без этого действия — вернуться к нему можно будет самостоятельно",
    readyToAdvanceHint: "Готово! Можете посмотреть результат — когда закончите, нажмите «Далее»",
    clickHint: "Нажмите на подсвеченную область",
    expandVideo: "Нажмите, чтобы развернуть видео",
    closeVideo: "Закрыть",
    stopButton: "Стоп",
    closeTourButton: "Закрыть обучение",
    welcomeTokensNote:
      "За первые шаги начислим токены — ими оплачивается проценка. Позже вы увидите список заданий и наград справа.",
    pageTitle: "Обучение",
    floatingTitle: "Обучение",
    stepOf: "Шаг {current} из {total}",
    progressComplete: "Обучение пройдено",
    statusCompleted: "Обучение пройдено",
    pauseButton: "Приостановить",
    skipAllButton: "Пропустить всё",
    floatingTooltip: "Прогресс прохождения обучения",
    welcomeTitle: "Добро пожаловать!",
    welcomeDescription: "Eplex Web — единый интерфейс для управления закупками автозапчастей.",
    welcomeFeature1: "Проценка товаров по поставщикам",
    welcomeFeature2: "Оформление и отслеживание заказов",
    welcomeCta: "Рекомендуем пройти короткое обучение, чтобы познакомиться с основными возможностями системы.",
    welcomeStart: "Начать обучение",
    welcomeSkip: "Пропустить",
    resumeButton: "Продолжить обучение",
    resetButton: "Сбросить прогресс",
    resetConfirmTitle: "Подтверждение",
    resetConfirmMessage: "Весь прогресс обучения будет сброшен, и обучение начнётся заново.",
    resetConfirmOk: "Сбросить",
    resetConfirmCancel: "Отмена",
    stopConfirmTitle: "Прервать обучение?",
    stopConfirmMessage: "Вы можете продолжить обучение или начать его заново, сбросив прогресс в настройках.",
    stopConfirmOk: "Прервать",
    stopConfirmCancel: "Отмена",
    step1Text: "Перейдите в настройки поставщиков.",
    step2Text: "Найдите нужного поставщика через строку поиска.",
    step3Text:
      "Откройте карточку поставщика и заполните учётные данные, обязательные поля и настройки заказа, если они предусмотрены сайтом. Нажмите <b>«Проверить»</b>. Если данные верны, нажмите <b>«Сохранить»</b>.",
    step4Text: "Теперь перейдите на страницу проценки.",
    step5Text: "Выберите поставщиков, по которым будет выполняться поиск.",
    step6Title: "Поиск по артикулу:",
    step6Text: "Введите артикул и выберите <b>бренд</b>.",
    step6Hint: "Чтобы запустить поиск без аналогов, выберите <b>«Все&nbsp;бренды»</b>.",
    step7Title: "Поиск по автомобилю:",
    step7Text:
      "Введите VIN или гос. номер, чтобы найти запчасти по автомобилю. Можно сразу добавить описание запчасти — например <b>«В639НО716 тормозные колодки»</b> — и подобрать детали с помощью ИИ.",
    step7Hint: "Нажмите на <b>«Каталог по VIN/Гос. номеру»</b>, чтобы открыть каталог.",
    step8PanelText: "Попробуйте сделать проценку и нажмите «Продолжить обучение», чтобы перейти к следующему шагу.",
    step9Text: "Перейдите в настройки наценок, чтобы создать свои типы цен.",
    step10Text:
      "Чтобы установить одну или несколько наценок, добавьте тип цен. Оставьте наценку по умолчанию или установите разные наценки на поставщиков или на цену.",
    step11PanelText: "Настройте наценку и нажмите «Продолжить обучение», когда будете готовы.",
    panelContinueButton: "Продолжить обучение",
    step12Text: "Теперь вернитесь на страницу проценки.",
    step13Text: "Выберите созданные типы цен в селекторе: в результатах проценки появятся столбцы с вашими наценками.",
    step13TextMobile:
      "Откройте меню «⋮» и выберите «Типы наценок»: отметьте созданные типы цен — в результатах проценки появятся столбцы с вашими наценками.",
    step14Text:
      "Ограничьте срок доставки и число одинаковых деталей ползунками — отбор применяется сразу. Эти настройки сохраняются между проценками.",
    step15Text: "Сохраняйте наборы фильтров и применяйте их в любой проценке.",
    step16Text:
      "Включите панель группировки, чтобы группировать результаты проценки по столбцу, перетащив его в шапку таблицы.",
    step17Text:
      "Добавьте товар в корзину: нажмите на иконку корзины справа в строке, укажите количество и подтвердите. Или откройте карточку товара двойным кликом по строке и добавьте оттуда.",
    step18Text: "Откройте историю поиска, чтобы повторить предыдущие проценки.",
    step19Text: "Для продолжения работы с заказами перейдите в корзину.",
    step20Text: "Быстрые фильтры помогают отобрать заказы по статусу.",
    step21Text:
      "Закажите одну или несколько позиций: выделите их и нажмите <b>«Оформить»</b> в верхней панели действий.",
    step22Text: "Наведите курсор на иконку в колонке статуса (значок слева), чтобы увидеть текущее состояние заказа.",
    stepTabGroupingText:
      "Проценки автоматически объединяются в группы по автомобилю — по VIN-коду или гос. номеру.<br>Кнопка переключения автомобиля в левом верхнем углу открывает <b>«Группы проценок»</b> — там можно перейти к другому автомобилю.",
    stepJournalGroupingText:
      "Для удобства работы с заказами используйте группировку по VIN-коду, гос. номеру, типу и другим параметрам.",
    step23Text: "В настройках обучения вы можете увидеть свой прогресс, сбросить его или пройти обучение заново.",
    step24Text: "Если возникнут вопросы — обращайтесь в поддержку.",
    backButton: "Назад",
    backButtonTitle: "Вернуться к предыдущему шагу обучения",
    step3PanelText: "Настройте поставщиков и нажмите «Продолжить обучение», когда будете готовы.",
    warnNoSuppliersTitle: "Внимание",
    warnNoSuppliersMessage: "Не настроен ни один поставщик. Вы уверены, что хотите продолжить обучение?",
    warnNoSuppliersContinue: "Продолжить обучение",
    warnNoSuppliersStay: "Настроить поставщиков",
    warnNoMarkupTitle: "Внимание",
    warnNoMarkupMessage: "Не создана ни одна наценка. Вы уверены, что хотите продолжить обучение?",
    warnNoMarkupContinue: "Продолжить обучение",
    warnNoMarkupStay: "Настроить наценки",
    finishTitle: "Обучение завершено!",
    finishDescription:
      'Вы познакомились с основными возможностями Eplex. В программе есть ещё многое: подбор по автомобилю, интеграция с 1С, отслеживание заказов. Токены и тарифы — в <a href="/app/eplex/billing?tab=tariffs" class="guidance-finish__link">разделе биллинга</a>.<br><br>Если что-то осталось непонятным — у нас регулярно проходят вебинары.<br>«<a href="https://max.ru/id1655487475_3_bot" target="_blank" rel="noopener" class="guidance-finish__link">Вебинары в MAX</a>», «<a href="https://t.me/eplex_webinar_bot" target="_blank" rel="noopener" class="guidance-finish__link">Вебинары в Telegram</a>»',
    tourFirstSearchText: "Нажмите любой пример — цены всех поставщиков на одну деталь появятся за пару секунд.",
    tourFirstSearchResultText: "Готово. Все предложения по одной детали — с ценой, сроком и наличием.",
    tourFirstSearchResultHint: "Добавьте подходящее в корзину — по такому значку в конце строки",
    tourSuppliersNavText: "Загляните в раздел «Поставщики» — здесь настраивается доступ к прайсам ваших поставщиков.",
    tourSaveSupplierText: "В проценке участвуют поставщики из этого списка.",
    tourSuppliersListHint:
      '<i class="dx-icon-edit"></i> Найдите своего поставщика через поиск и нажмите значок карандаша в его строке',
    tourSaveSupplierCardText:
      "Укажите логин и пароль от вашего личного кабинета у этого поставщика — Eplex покажет вам ровно те цены, по которым вы закупаете. Нет паролей под рукой? Нажмите «Настройте за меня» — поддержка подключит поставщиков за вас.",
    tourCartNavText:
      "Теперь загляните в «Корзину» — здесь собираются позиции для заказа и отслеживаются уже оформленные.",
    tourCartCheckboxText: "Чтобы оформить заказ, позиции нужно отметить — чекбокс в шапке таблицы выбирает все сразу.",
    tourCartEmptyText:
      "В корзине пока пусто. Нажмите «Назад», чтобы вернуться к проценке и добавить позицию по значку корзины в конце строки, — затем возвращайтесь сюда. Или пропустите шаг.",
    tourMakeOrderText:
      "Кнопка «Оформить» отправляет отмеченные позиции поставщику напрямую — вы сразу получаете номер заказа и отслеживаете его в этом же разделе. Баланс и тарифы — в разделе биллинга, иконка в меню слева внизу.<br><br>Если у вас выбран заказ от демо-поставщика — заказ не оформится.",
    configureForMeButton: "Настройте за меня",
    configureForMeLink: "Не получается? Настройте за меня",
    configureForMeRequestTitle: "Настройте за меня: подключение поставщиков",
    configureForMeRequestText:
      "Здравствуйте! Прошу настроить поставщиков за меня — подключить мои личные кабинеты поставщиков в Eplex Web. Готов передать данные для входа специалисту поддержки.",
    configureForMeRequestTextSupplier:
      "Здравствуйте! Прошу подключить поставщика «{supplier}» за меня — не получается ввести данные его личного кабинета в Eplex Web. Готов передать данные для входа специалисту поддержки.",
    configureForMeSupportNote: "Тех. поддержка свяжется с вами в течение 5-10 минут и поможет вам.",
    configureForMeFallback: "Ассистент сейчас недоступен — открываем форму обращения в поддержку.",
    finishRetake: "Пройти ещё раз",
    finishStartWork: "Начать работу",
  },
  clipboard: {
    unsupportedContext: "Копирование не поддерживается в небезопасном контексте или браузере",
    copied: "Информация скопирована в буфер обмена",
    copyError: "Ошибка при копировании",
  },
  onboarding: {
    buttonTooltip: "Квесты и прогресс",
    closeTooltip: "Закрыть",
    title: "Начало работы",
    progressOf: "{current} из {total}",
    rewardAmount: "+{amount} токенов",
    expiryNote: "Токены начисляются автоматически и действуют 14 дней",
    rewardToastTitle: "Задание выполнено",
    rewardModalButton: "Понятно",
    permanentNote: "Не сгорают, пока тариф активен",
  },
  validation: {
    quantityMustBePositive: "Количество должно быть больше 0",
    outOfStock: "Товара нет в остатке",
    availableOnly: "Доступно только {available} шт.",
    mustBeMultiple: "Количество должно быть кратно {multiplicity} шт. ({examples}...)",
  },
  timeFormat: {
    days: "{count} дн.",
    hours: "{count} ч.",
    minutes: "{count} мин.",
    zeroMinutes: "0 мин.",
  },
  dateFormat: {
    noData: "Нет данных",
    invalidDate: "Некорректная дата",
  },
  triggers: {
    noOffers: "Мои предложения отсутствуют. Цена ТОП: {price}",
    adjustToTop: "Удержание на {position} месте. Цена ТОП: {price}",
    margin10Percent: "Разница до соседней 10%. Соседняя цена: {price}",
    priceMismatch: "Ошибка: цена не совпадает. ТОП цена: {price}",
    lackOfRivalry: "Предложений меньше 2. Цена ТОП: {price}",
    monopoly: "Нет конкурентов. Цена: {price}",
    noDeviations: "Нет отклонений",
    belowCost: "Цена ниже себестоимости",
    belowCostAllowed:
      "Цена ниже себестоимости — так задано вашей минимальной маржинальностью. Выгрузку это не блокирует",
    belowMinMargin: "Цена ниже минимальной маржи",
    priceAnomaly: "Резкое отклонение от прошлой цены",
    costUnknown: "Нет себестоимости — контроль маржи не выполняется",
    positionUndetermined: "Позиция не определена — задайте правила определения своих позиций",
  },
  breadcrumbs: {
    summary: "Сводка",
    processes: "Процессы",
    salesDetailsProfit: "Детализация продаж (Прибыль)",
    salesDetailsOrders: "Детализация продаж (Заказы)",
    priceLists: "Прайс-листы",
  },
  tabs: {
    searchTitle: "Поиск {number}",
  },
  priceSettings: {
    groupBrand: "Бренд",
    groupPrice: "Динамическая по цене",
    groupSegment: "Сегмент",
    titleBrand: "По бренду",
    titlePrice: "Динамическая по цене",
    titleSegment: "По сегментам",
    titleBase: "Базовая",
    priorityFirst: "применяется первым",
    prioritySecond: "применяется вторым",
    priorityThird: "применяется третьим",
    priorityN: "применяется {n}-м",
    selectSourceTypePlaceholder: "Выберите тип источника",
    addSource: "Добавить источник",
    priority: "Приоритет",
    supplier: "Поставщик",
    priceName: "Наименование",
    importGroup: "Импортировать",
    productList: "Список товаров",
    quantityAndCost: "Кол-во и себестоимость",
    selectionQuantity: "Отбор (кол-во)",
    minQuantityForExportHint: "Минимальное количество позиций для выгрузки",
    selectionTermDays: "Срок отбора (дн.)",
    updateFrequencyHint: "Частота обновления отбора",
    additionalDeliveryDays: "Доп. дни доставки",
    selectedNomenclaturesCountTitle: "Количество отобранных номенклатур",
    quantityLabel: "Количество",
    suppliersInSelectionCountTitle: "Количество поставщиков, задействованных в отборе",
    suppliersLabel: "Поставщиков",
    warehousesInSelectionCountTitle: "Количество складов, задействованных в отборе",
    warehousesLabel: "Складов",
    yourPrice: "Ваш прайс",
    yourWarehouse: "Ваш склад",
    selectPricingPolicyPlaceholder: "Выберите ценовую политику",
    selectGroupTypePlaceholder: "Выберите тип группы",
    minMarginLabel: "Минимальная маржинальность",
    minMarginDescription:
      "— это значение, ниже которого не должна опускаться цена. Может быть отрицательным: тогда нижняя граница опускается ниже себестоимости и автоматике разрешено продавать в минус.",
    markupLabel: "Наценка",
    markupDescription: "— это дополнительный процент, накладываемый на базовую цену.",
    addPricingPolicy: "Добавить ценовую политику",
    backToPoliciesList: "Вернуться к списку ценовых политик",
    policyName: "Название политики",
    priorityListCaption: "Приоритетность",
    createdAt: "Создано",
    updatedAt: "Обновлено",
    editPolicyHint: "Редактировать политику",
    deletePolicyHint: "Удалить политику",
    addPricingPolicyTitle: "Добавление ценовой политики",
    newPolicyNameLabel: "Название новой ценовой политики",
    policyLoadError: "Ошибка при загрузке анализа товара",
    policyDeletedSuccess: "Политика «{name}» успешно удалена!",
    stockSourcesTitle: "Склады",
    priceSourcesTitle: "Прайс-источники",
    platformSourcesTitle: "С платформы",
    manualSourcesTitle: "Ручной ввод",
    sourceEnabled: "Активен",
    importItems: "Импортировать товары",
    costIn: "Себестоимость",
    costOut: "Цена продажи",
    saveFilters: "Сохранить фильтры",
    deleteItemsBelowCost: "Удалять позиции ниже себестоимости",
    deleteItemsBelowCostGlobalNote: "Настройка общая для всех прайс-листов",
    deleteItemsBelowCostTooltip:
      "Удаление происходит, когда рекомендованная цена после анализа конкурентов на площадке ниже указанной себестоимости товара (при условии, что мы не находимся на желаемой позиции)",
    deleteItemsBelowCostLoadError: "Не удалось загрузить настройку удаления позиций ниже себестоимости",
    deleteItemsBelowCostSaved: "Настройка сохранена",
    deleteItemsBelowCostSaveError: "Не удалось сохранить настройку",
    deleteItemsBelowCostHintOn:
      "Включено: позиция, цена которой ушла ниже нижней границы, исключается из прайса и не попадает в выгрузку. В сводной она остаётся видна и подсвечена красным. Как только цена восстановится, позиция вернётся в прайс автоматически. Если минимальная маржинальность отрицательная, товары в разрешённом минусе из прайса не выпадают.",
    deleteItemsBelowCostHintOff:
      "Выключено: позиция остаётся в прайсе, а цена поднимается до нижней границы — до минимальной цены при стратегии «Оптимальная» и до себестоимости при стратегии «Максимальная оборачиваемость». При отрицательной минимальной маржинальности нижняя граница может быть ниже себестоимости.",
    renamePolicyHint: "Переименовать политику",
    renamePolicyTitle: "Переименование ценовой политики",
    policyRenamedSuccess: "Политика «{name}» успешно переименована!",
    baseMinMarginLabel: "Начальная минимальная маржинальность",
    baseMarkupLabel: "Начальная наценка",
    deletePolicyConfirm: "Вы уверены, что хотите удалить политику «{name}»?",
    deleteGroupConfirm: "Вы уверены, что хотите удалить группу? Все правила в ней будут удалены.",
    deleteRuleConfirm: "Вы уверены, что хотите удалить это правило?",
    untitled: "Без названия",
    unsavedChangesTitle: "Несохранённые изменения",
    unsavedChangesText: "На этом шаге есть несохранённые изменения. Что вы хотите сделать?",
    switchPolicyUnsavedText:
      "В текущей ценовой политике есть несохранённые изменения. Они будут потеряны при переключении. Продолжить?",
    saveAndGo: "Сохранить и перейти",
    goWithoutSaving: "Перейти без сохранения",
  },
  headerFilter: {
    inStock: "В наличии",
    lessThanDays: "Менее {days} дней",
    moreThanDays: "Более {days} дней",
    empty: "(Пустое)",
    inStockStatus: "В наличии",
    onOrder: "Под заказ",
    priceRange: "От {from} до {to}",
    daysAbbr: "{count} дн.",
    resetAll: "Сбросить",
    resetAllHint: "Снять все фильтры этой таблицы",
  },
  auth: {
    sessionsTerminated: "Сеансы на всех устройствах завершены",
    sessionNotClosed: "Сессия не закрыта",
    loginFailed: "Не удалось авторизоваться. Попробуйте позже.",
    internalServerError: "Внутренняя ошибка сервера",
  },
  markupSettings: {
    newPriceType: "Новый тип цены",
    untitled: "Без названия",
  },
  eplexFilters: {
    savedFilters: "Сохранённые фильтры",
    noSavedFilters: "Нет сохранённых фильтров",
    setupFiltersHint: "Настройте фильтры в таблице и сохраните их для быстрого доступа",
    deleteFilter: "Удалить фильтр",
    deleteFilterTitle: "Удаление фильтра",
    deleteConfirmMessage: "Вы уверены, что хотите удалить фильтр?",
    deleteIrreversible: "Это действие нельзя будет отменить",
    delete: "Удалить",
    today: "Сегодня",
    yesterday: "Вчера",
    daysAgo: "{days} дн. назад",
    activeFilterHint: "Выбранный фильтр применяется к новым поискам, пока вы его не выключите",
    autoAppliedNotice: "Результаты показаны по вашему фильтру «{name}»",
    smartFiltersTitle: "Настройки фильтрации",
    enableSmartFiltering: "Включить режим Smart фильтрации",
    deliveryTime: "Допустимый срок доставки",
    limitDuplicateDetails: "Ограничить количество одинаковых деталей поиска",
    saveFilterTitle: "Сохранить фильтр",
    saveFilterDescription:
      "В один пользовательский фильтр сохраняются вместе: основные фильтры из панели (поставщики, бренды, цена, склады, срок доставки) и настройки расширенных фильтров из шапки столбцов таблицы. Примените сохранённый фильтр в один клик в будущем.",
    filterNameLabel: "Название фильтра",
    filterNamePlaceholder: "Например: Казань + autopiter",
    charCount: "{count}/50 символов",
    columnsWillBeSaved: "Будут сохранены фильтры:",
    regularFiltersGroup: "Основные фильтры:",
    advancedFiltersGroup: "Расширенные фильтры (по колонкам):",
    noActiveFilters: "Нет активных фильтров",
    priceTypeFiltersExcluded: "Фильтры по колонкам наценкок не сохраняются в пользовательских фильтрах.",
    zeroDays: "0 дн.",
    days: "{count} дн.",
    pieces: "{count} шт.",
    all: "Все",
  },

  timeline: {
    january: "января",
    february: "февраля",
    march: "марта",
    april: "апреля",
    may: "мая",
    june: "июня",
    july: "июля",
    august: "августа",
    september: "сентября",
    october: "октября",
    november: "ноября",
    december: "декабря",
  },

  smartSearch: {
    articleLabel: 'Артикул "{query}"',
    brandOne: "бренд",
    brandFew: "бренда",
    brandMany: "брендов",
    allBrandsFor: 'Все бренды для "{query}"',
    aiSearchLabel: "ИИ-поиск запчастей",
    aiSuggestTitle: "Найти с помощью ИИ",
    aiSuggestByVin: "по VIN {vin}",
    aiSuggestByPlate: "по госномеру {plate}",
    searching: "Ищем запчасти...",
    searchCompleted: "Поиск завершён",
    searchFailed: "Ошибка поиска",
    cancelSearch: "Отменить",
    retry: "Повторить",
    noResults: "Ничего не найдено",
    initiateError: "Не удалось начать поиск",
    errorEmptyParts: "Не удалось определить запчасти для поиска",
    errorValidation: "Ошибка валидации запроса",
    errorUnknown: "Произошла ошибка при поиске",
    errorTimeout: "Поиск слишком долго не отвечает. Попробуйте повторить",
    alternativeTo: "Альтернатива для",
    relatedPart: "Сопутствующая деталь",
    searchAll: "Проценить все",
    searchAllGlobal: "Проценить все ({count})",
    priceSelected: "Проценить выбранные",
    priceSelectedCount: "Проценить выбранные ({count})",
    selectAll: "Выбрать все",
    selectAllTitle: "Выделить или снять выделение всех найденных деталей",
    findInCatalog: "Открыть в каталоге",
    badgeAiTitle: "Рекомендация ИИ — деталь выбрана искусственным интеллектом",
    badgeConfTitle: "Уверенность ИИ в правильности подбора",
    catalogNavigating: "Открываем каталог...",
    catalogNavStep1: "Загружаем данные автомобиля",
    catalogNavStep2: "Переходим к нужному разделу",
    catalogNavStep3: "Открываем карточку детали",
    clarifyTitle: "Уточнение по автомобилю",
    clarifyAwaiting: "Нужно уточнение, чтобы продолжить поиск",
    clarifyChoose: "Уточнить",
    clarifyLater: "Позже",
    clarifyConfirm: "Продолжить поиск",
    clarifySubmitting: "Продолжаем поиск...",
    clarifyAiBadge: "ИИ рекомендует",
    clarifyAiBadgeTitle: "Вариант, который ИИ считает наиболее вероятным для этого автомобиля",
    clarifyError: "Не удалось отправить выбор. Попробуйте ещё раз",
    clarifyEngineVolume: "{value} л",
    clarifyEnginePower: "{value} л.с.",
    modParams: {
      sales_region: "Регион продажи",
      year: "Год",
      prod_period: "Годы выпуска",
      engine_code: "Двигатель",
      engine_cc: "Объём",
      engine_hp: "Мощность",
      fuel_type: "Топливо",
      trans_type: "КПП",
      wheel_drive: "Привод",
      steering: "Руль",
      body_type: "Кузов",
      door_count: "Дверей",
      abs: "ABS",
      vsa: "VSA",
      sunroof: "Люк",
      navigation: "Навигация",
      Options: "Опции",
    },
  },

  dynamicForm: {
    toList: "В список",
    partsList: "Список деталей",
    priceSelected: "Проценить выбранные",
    priceSelectedCount: "Проценить выбранные ({count})",
    selectAll: "Выбрать все",
    selectAllTitle: "Выделить или снять выделение всех позиций",
    positionOne: "позиция",
    positionFew: "позиции",
    positionMany: "позиций",
    engine: "Двигатель",
    model: "Модель",
    carName: "Название автомобиля",
    chassisCode: "Код шасси",
    productionDate: "Дата производства",
    salesRegion: "Регион продаж",
    manufacturer: "Производитель",
    chassis: "Шасси",
    loading: "Загрузка...",
    loadError: "Ошибка загрузки: {message}",
    errorCode: "Код ошибки: {code}",
    schemaNotLoaded: "Схема не загружена",
    back: "Назад",
    noPartNumber: "Артикул отсутствует",
    year: "Год",
    searchPlaceholder: "Поиск по деталям...",
    nothingFound: "Ничего не найдено",
    clearSearch: "Очистить поиск",
    zoomIn: "Приблизить",
    zoomOut: "Отдалить",
    resetZoom: "Сбросить масштаб",
  },

  gp: {
    common: {
      back: "Назад",
      cancel: "Отмена",
      save: "Сохранить",
      continue: "Продолжить",
      finish: "Завершить",
      newRun: "Новый запуск",
      newTender: "Новый тендер",
      newReport: "Новый отчёт",
      run: "Запустить",
      stop: "Остановить",
      pause: "Пауза",
      resume: "Возобновить",
      duplicate: "Дублировать",
      delete: "Удалить",
      archive: "В архив",
      unarchive: "Из архива",
      pin: "Закрепить",
      unpin: "Открепить",
      export: "Экспорт",
      share: "Поделиться",
      print: "Печать",
      view: "Открыть",
      edit: "Изменить",
      details: "Детали",
      rerun: "Перепроценить",
      moreActions: "Действия",
      search: "Поиск",
      filter: "Фильтры",
      all: "Все",
      noData: "Данных нет",
      loading: "Загрузка…",
      stepOf: "Шаг {current} из {total}",
      saveDraft: "Сохранить как черновик",
      draftSaved: "Черновик сохранён",
      saveAndRun: "Сохранить и запустить",
      requiredField: "Обязательное поле",
      addRow: "Добавить позицию",
      removeRow: "Удалить",
      uploadExcel: "Загрузить Excel",
      pasteFromBuffer: "Из буфера",
      manualInput: "Вручную",
      fromCatalog: "Из каталога",
      fromOrder: "Из заявки",
      downloadTemplate: "Шаблон",
      replaceFile: "Заменить файл",
      removeFile: "Удалить файл",
      filePosition: "Позиций: {count}",
      fileLoaded: "{name}",
      pastePlaceholder:
        "Вставьте список из Excel.\nКолонки через tab или ;:\nартикул, бренд, количество, целевая цена\n\nBP53094\tFENOX\t4\n8DB355002961\tHELLAPAGID\t2",
      pasteApply: "Распознать",
      autoBrand: "авто",
      positionsTitle: "Позиции",
      positionsHint: "Артикул обязателен. Бренд и количество — желательно",
      selectAll: "Выбрать все",
      unselectAll: "Снять все",
      selectedOf: "Выбрано {count} из {total}",
    },

    status: {
      draft: "Черновик",
      planning: "Планирование",
      pricing: "Проценка",
      negotiation: "Согласование",
      purchasing: "Закупка",
      completed: "Завершено",
      partial: "Частично",
      running: "Идёт",
      failed: "Ошибка",
      stopped: "Остановлено",
      archived: "В архиве",
    },

    mode: {
      manual: "Ручная проценка",
      tender: "Тендер",
      pricekeeper: "Мониторинг",
      retail: "Розничная",
    },

    rule: {
      title: "Правила выбора",
      analyzeMaxTime: "Срок поставки, дн.",
      analyzeMaxTimeHint: "Предложения с большим сроком не учитываем",
      costExcess: "Допустимое превышение цены, %",
      costExcessHint: "Относительно целевой цены позиции",
      orderBy: "Сортировка офферов",
      orderByCost: "По цене (от низкой)",
      orderByTime: "По сроку (от быстрого)",
      orderByRank: "По рангу поставщика",
      categories: "Категории результатов",
      catRequested: "Запрошенный артикул",
      catOriginal: "Оригинальные замены",
      catAnalog: "Аналоги",
      catCross: "Кроссы",
      brandOnly: "Только запрошенный бренд",
      brandOnlyHint: "Без аналогов других брендов",
      articleOnly: "Только запрошенный артикул",
      articleOnlyHint: "Без кроссов",
      countOnly: "Только с указанным остатком",
      countOnlyHint: "Игнорировать офферы без stock",
      trustedBrands: "Доверенные бренды",
      trustedBrandsHint: "Применяется в алгоритме «Доверенные аналоги». Указываются через /",
      trustedBrandsPlaceholder: "BOSCH / MAHLE / HELLA",
      purchaseDeadline: "Крайняя дата поставки",
      priceDiffPercent: "Допуск превышения цены, %",
      pluginFilters: "Фильтры по поставщикам",
      pluginFiltersHint: "Расширенные правила фильтрации офферов отдельных поставщиков",
      pluginFiltersAdd: "Добавить правило",
      pluginRulesField: "Поле",
      pluginRulesOp: "Оператор",
      pluginRulesValue: "Значение",
    },

    plugins: {
      title: "Поставщики и склады",
      hint: "Выберите источники, у которых ищем. Чем больше — тем точнее результат, но дольше выполнение",
      sectionWarehouses: "Свои склады",
      sectionSuppliers: "Поставщики",
      sectionGroups: "Группы поставщиков",
      searchPlaceholder: "Поиск по названию поставщика",
      ranksTitle: "Ранг поставщиков (только для тендера)",
      ranksHint:
        "Ранг 1 — высший приоритет. При равной цене система выберет поставщика с меньшим рангом. Если задано несколько с одним рангом — поставщики равноценны.",
      rankLabel: "Ранг",
      noneSelected: "Поставщики не выбраны — без них ГП не запустится",
      groupApply: "Применить группу",
      groupCountHint: "Группа «{name}» — выбрано из общего числа поставщиков: {count}",
      sectionToggleHint: "Свернуть или развернуть список",
      manageGroups: "Управление группами",
      onlyWarehouses: "Только свои склады",
      onlySuppliers: "Только поставщики",
    },

    report: {
      title: "Доставка результата",
      hint: "Куда отправить итог проценки, какие уведомления присылать",
      notifyEmail: "Email для уведомлений",
      notifyOnFinish: "Уведомить, когда проценка завершится",
      notifyOnStop: "Уведомить при остановке",
      delivery: "Способ доставки",
      deliveryEmail: "Письмо на email",
      deliveryWebhook: "Webhook (1С / своя система)",
      webhookUrl: "URL",
      webhookMethod: "Метод",
      deliveryType: "Когда отправлять",
      deliveryTypeInstant: "Сразу при изменении",
      deliveryTypeOnFinish: "По завершении",
      deliveryTypePeriod: "По расписанию",
      reportTemplate: "Шаблон письма",
      reportTemplateDefault: "Стандартный",
      reportTemplateClient: "Коммерческое предложение",
    },

    schedule: {
      title: "Расписание",
      once: "Разово",
      daily: "Каждый день",
      weekly: "Раз в неделю",
      monthly: "Раз в месяц",
      clientPeriod: "Период повтора, дн.",
      periodDistribute: "Равномерно распределить запросы во времени",
      maxPerDay: "Лимит запросов в день",
    },

    estimate: {
      title: "Оценка",
      timeEstimate: "≈ {seconds} сек",
      positions: "Позиций: {count}",
      suppliers: "Поставщиков: {count}",
      readyToRun: "Готово к запуску",
      validationFailed: "Не хватает данных для запуска",
    },
  },

  analytics: {
    pivot: {
      title: "Конструктор отчёта",
      subtitle: "Перетащите поля в строки, колонки и значения — превью обновится мгновенно",
      fieldsPanel: "Поля",
      structurePanel: "Структура",
      previewPanel: "Превью",
      reset: "Очистить",
      saveAsNew: "Сохранить как новый",
      exportCsv: "Экспорт CSV",
      viewTable: "Таблица",
      viewChart: "График",
      expandPanels: "Развернуть превью",
      collapsePanels: "Вернуть панели",
      openFullscreen: "Открыть на весь экран",
      closeFullscreen: "Закрыть полноэкранный режим",
      dimensions: "Измерения",
      facts: "Факты",
      zones: {
        rows: "Строки",
        cols: "Колонки",
        vals: "Значения",
        filters: "Фильтры",
        placeholderRows: "Перетащите измерение",
        placeholderCols: "Перетащите измерение",
        placeholderVals: "Перетащите факт",
        placeholderFilters: "Любое поле",
      },
      empty: "Перетащите измерение в строки и факт в значения, чтобы увидеть результат",
      emptyHint: "Или выберите готовый шаблон",
      meta: "{rows} × {cols} · записей: {records}",
      total: "Итого",
    },
    agg: {
      sum: "сумма",
      avg: "среднее",
      min: "мин",
      max: "макс",
      count: "кол-во",
    },
  },

  selection: {
    backToList: "Все подборы",
    pageTitle: "Подбор",
    pageSubtitle: "Подобрать запчасти под закупку, КП клиенту, сверку с рынком или мониторинг",
    comingSoon: "скоро",
    autostartLabel: "Автоматически оформлять заказы после одобрения",

    draft: {
      saveTitle: "Сохранить черновик?",
      saveMessage: "Подбор ещё не запущен. Сохранить введённые настройки как черновик, чтобы продолжить позже?",
      saveOk: "Сохранить черновик",
      saveDiscard: "Не сохранять",
      resumeTitle: "Продолжить черновик",
      resumeCta: "Открыть →",
    },

    hero: {
      emptyTitle: "Здесь появятся ваши подборы",
      emptySub:
        "Загрузите список позиций — Eplex обзвонит поставщиков, сравнит цены и соберёт готовое предложение за минуты.",
      firstCta: "Запустить первый подбор",
      pickTitle: "Выберите подбор слева",
      pickSub: "Откройте подбор в списке или создайте новый.",
      newCta: "Создать подбор",
    },

    sidebar: {
      searchPlaceholder: "Найти подбор",
      newRun: "Новый подбор",
      filterAll: "Все",
      sectionActive: "Активные",
      sectionDrafts: "Черновики",
      sectionCompleted: "Завершённые",
      sectionArchived: "Архив",
      empty: "Подборов пока нет",
      emptyHint: "Создайте первый подбор — он появится в этом списке",
      emptyAction: "Создать подбор",
      // Свёртка списка подборов в узкую полоску (CAB-769)
      collapse: "Свернуть список подборов",
      collapseShort: "Свернуть",
      expand: "Развернуть список подборов",
      collapsedLabel: "Подборы",
    },

    list: {
      docOsnLabel: "Основание",
      deadline: "Дедлайн",
      noDeadline: "Без срока",
      goalTag: "Задача",
      progressLabel: "{finished} из {total}",
    },

    goal: {
      title: "Какую задачу решаем?",
      subtitle: "Выберите цель — мы соберём правильную последовательность шагов под ваш сценарий",
      procurement: {
        label: "Закупка",
        description:
          "Найти выгодные предложения под список артикулов: оформить заказы поставщикам или подготовить клиенту КП с согласованием по ссылке",
        whoFor: "Закупщик · Менеджер по продажам",
      },
      procurementAlso: "Коммерческое предложение",
      tender: {
        label: "Коммерческое предложение",
        description: "Подготовить КП клиенту с гарантией цен и согласованием по ссылке",
        whoFor: "Менеджер по продажам",
      },
      other: {
        label: "Ручной режим",
        description:
          "Классическая групповая проценка: список позиций → площадки → таблица результатов. Без рекомендаций, наценок и согласований",
        whoFor: "Снабжение",
      },
      competitors: {
        label: "Сверка с конкурентами",
        description: "Сравнить ваши цены и наличие с площадками-конкурентами по списку позиций",
        whoFor: "Аналитик",
      },
      monitoring: {
        label: "Мониторинг цен",
        description: "Получать уведомления о смене цены, появлении/пропаже предложений у поставщиков",
        whoFor: "Аналитик",
      },
      pricing: {
        label: "Ценообразование",
        description: "Анализ цен по группам товаров против рынка — расчёт рекомендованной розницы",
        whoFor: "Категорийный менеджер",
      },
      forecast: {
        label: "Прогноз потребности",
        description: "Расчёт необходимой закупки на основе прошлых продаж и страхового запаса",
        whoFor: "Закупщик",
        soon: "скоро",
      },
    },

    wizard: {
      title: "Новый подбор",
      fileLoaded: "Распознано {n} позиций из {file}. Перенесены все колонки файла, заголовки определены автоматически.",
      fileLoadedByOrder:
        "Распознано {n} позиций из {file}. Перенесены все колонки файла. Заголовки не найдены — артикул, бренд, кол-во и цена назначены по порядку, проверьте их в шапке таблицы.",
      fileLoadedByOrderMissing:
        "Распознано {n} позиций из {file}. Перенесены все колонки файла. Заголовки не найдены, колонки назначены по порядку; не хватило колонок для: {missing} — укажите их в шапке таблицы.",
      fileLoadedMissingColumns:
        "Распознано {n} позиций из {file}. Перенесены все колонки файла. В заголовках не распознаны: {missing} — укажите их в шапке таблицы.",
      fileField: {
        article: "Артикул",
        brand: "Бренд",
        name: "Наименование",
        qty: "Кол-во",
        max_cost: "Цена",
        max_time: "Срок",
      },
      loadSampleConfirmTitle: "Загрузить пример?",
      loadSampleConfirmMessage: "Текущие позиции будут заменены примером. Это действие нельзя отменить.",
      loadSampleConfirmOk: "Заменить",
      stepGoal: "Задача",
      stepDocSource: "Источник",
      stepPositions: "Позиции",
      // Шаг перестал быть только выбором площадок: рядом задаются параметры отбора (CAB-737)
      stepSources: "Настройки",
      stepStrategy: "Стратегия",
      stepReview: "Запуск",
      stepSchedule: "Расписание",
      stepDelivery: "Доставка",
      stepStructure: "Структура",
      sourcesSubtitleProcurement:
        "Выберите поставщиков и склады. Ранг (1 — высший приоритет) влияет на алгоритмы рекомендаций",
      sourcesSubtitleAnalytics:
        "Выберите площадки, по которым проценим. Можно смешивать своих поставщиков и внешние площадки",
      sourcesTabHint:
        "Отметьте поставщиков, у которых будем запрашивать цены для подбора, и задайте предельный срок поставки. Набор площадок запомнится.",
      sources: {
        paramsTitle: "Параметры проценки",
        limitToggleLabel: "Ограничить срок поставки",
        maxTimeLabel: "Начальный срок поставки",
        maxTimeUnit: "дн.",
        maxTimeHint: "В результатах будет выбран срок до {days} дн. Его можно изменить или снять после запуска.",
        maxTimeHintNoLimit: "В результатах будет выбран любой срок. Его можно изменить после запуска.",
        maxTimeValue: "до {days} дн.",
        maxTimeValueNoLimit: "без ограничения",
      },
      validation: {
        pickGoal: "Выберите задачу",
        enterTitle: "Введите название",
        addAtLeastOnePosition: "Добавьте хотя бы одну позицию",
        pickPlatforms: "Выберите площадки",
        pickSuppliers: "Выберите поставщиков",
        pickAlgo: "Выберите хотя бы один алгоритм",
        minPositionsForMode: "Минимум {count} позиции — требование backend для этого режима",
        fillRowsAndValues: "Заполните строки и значения",
      },
      review: {
        platforms: "Площадок",
        noteAnalytics:
          "Групповая проценка будет создана и сразу запущена. Опросим выбранные площадки, агрегированные результаты появятся в детальном экране по мере готовности.",
        noteForecast: "Прогноз — пока в режиме предварительного просмотра, без отправки на сервер.",
        noteLive:
          "Закупка будет создана и сразу пойдёт в работу. Запросим цены у выбранных поставщиков — результаты будут появляться по мере готовности, целиком примерно за {estimate}.",
        noteOther:
          "Проценка запустится по выбранным площадкам (~{estimate}). В карточке появятся потребности, статусы поиска и найденные предложения — по мере готовности.",
      },
      structure: {
        title: "Структура отчёта",
        subtitle:
          "Соберите сводку drag-and-drop. Превью на демонстрационных данных — реальные цифры появятся после запуска",
        templatesLabel: "Готовые шаблоны",
      },
      schedule: {
        title: "Расписание и уведомления",
        subtitle: "Когда обновлять данные и кому присылать результат",
        scheduleLabel: "Расписание",
        deliveryLabel: "Доставка",
        emailLabel: "Email для уведомлений",
        notifyOnFinish: "Уведомить по завершении",
        once: "Разово",
        daily: "Каждый день",
        weekly: "Раз в неделю",
        monthly: "Раз в месяц",
      },
      triggers: {
        title: "Триггеры уведомлений",
        subtitle:
          "Что должно сработать — мы пришлём письмо, как только обнаружим изменение. Можно включить несколько одновременно.",
        priceDiff: "Цена изменилась",
        priceDiffHint: "Если цена прыгнула больше чем на {param}%",
        priceDiffParam: "% изменения",
        topPrice: "Мы не в топе",
        topPriceHint: "Если наша цена опустилась ниже {param}-го места",
        topPriceParam: "Допустимая позиция",
        minOfferCount: "Мало предложений",
        minOfferCountHint: "Если у позиции стало меньше {param} офферов",
        minOfferCountParam: "Минимум офферов",
        notFound: "Позиция пропала",
        notFoundHint: "Если у площадок не осталось ни одного предложения",
      },
    },

    docSource: {
      title: "Откуда берём список позиций",
      subtitle:
        "Если у вас есть документ-основание (заказ клиента из 1С) — укажите его. Если нет — начнём с пустого списка",
      nameLabel: "Название подбора",
      namePlaceholder: "Например: Закупка на неделю",
      docBasisLabel: "Документ-основание",
      hasDoc: "У меня есть документ-основание",
      noDoc: "Список будет добавлен вручную",
      docTitle: "Название документа",
      docTitlePlaceholder: "Заказ покупателя 5555",
      gatewayHint: "Выбирайте заказ клиента прямо из 1С — без ручного ввода позиций. Нужен шлюз интеграции.",
      gatewayLink: "Подключить 1С →",
      docUuid: "UUID документа",
      docUuidPlaceholder: "777456-2222-5555-abcabc",
    },

    strategy: {
      title: "Как подбирать предложения?",
      subtitle: "Какие алгоритмы рекомендаций прогонять. Чем меньше выбрано — тем быстрее работает",
      // Способы отбора: одна галочка на область поиска, подписи совпадают с
      // тем, как рекомендации названы в результатах
      scopeLede:
        "Отметьте, где искать предложения. По каждому способу система соберёт отдельную рекомендацию — потом сравните их в сводке и оставите лучшую.",
      scopeRequested: "Запрошенный",
      scopeRequestedDesc: "Только то, что заказали — ровно тот артикул, без замен",
      scopeTrusted: "Доверенные аналоги",
      scopeTrustedDesc: "Плюс аналоги брендов, которым доверяете",
      scopeAll: "Все аналоги",
      scopeAllDesc: "Плюс аналоги любых брендов — максимум вариантов",
      needsBrandsShort: "Сначала добавьте доверенные бренды",
      safetyTitle: "Подстраховка, если предложений не хватит",
      safetyHint: "Включатся только тогда, когда обычные способы нашли слишком мало позиций.",
      netCombined: "Найти любой ценой",
      netCombinedDesc: "Сам ослабляет ограничения по очереди, пока не найдёт варианты",
      netNoFilter: "Хоть что-нибудь",
      netNoFilterDesc: "Крайний случай — берёт любые варианты без ограничений",
      summaryCount: "Готовим рекомендаций: {n}",
      summaryReserve: "(+резерв)",
      summaryEmpty: "Отметьте хотя бы один сценарий или ячейку, чтобы продолжить.",
      brandsSelected: "выбрано: {n}",
      brandsNone: "не заданы",
      brandsAddLabel: "Добавить свой бренд",
      brandsAddPlaceholder: "Введите бренд и нажмите Enter",
      brandsAddMore: "Ещё бренд…",
      brandsTrustedShort: "Их приоритет — в строке «плюс доверенные аналоги»",
      brandsSuggest: "Популярные:",
      algoTitle: "Алгоритмы рекомендаций",
      orderPlacementTitle: "Оформление заказов",
      orderTypeAllHint: "Оформлять заказы у всех поставщиков сразу после запуска, не дожидаясь планировщика",
      algoSelectionTitle: "Алгоритмы рекомендаций",
      algoSelectionHint:
        "После проценки система покажет рекомендации по каждому из выбранных алгоритмов. Вы выберете лучший вариант.",
      requiresTrustedBrands: "Требует «Доверенные бренды»",
      brandsTrustedTitle: "Доверенные бренды",
      brandsTrustedHint:
        "Через / — список брендов которым доверяете. Используется в алгоритмах 3, 4, 7. Спецсимволы: «*» — все остальные, «!» — исключение",
      brandsTrustedPlaceholder: "BOSCH/MAHLE/FILTRON/!OSRAM",
      brandsTrustedExamples: "Примеры:",
      brandsTrustedAddBrand: "Добавить бренд",
      filtersTitle: "Дополнительные фильтры",
      filtersHint: "Срок поставки, допустимое превышение цены, расширенные правила фильтрации офферов",
      maxTimeLabel: "Срок поставки до, дн.",
      priceDiffPercentLabel: "Допуск превышения цены, %",
      extraDaysLabel: "Запас по сроку, дн.",
      deadlineLabel: "Крайний срок",
      orderTypeLabel: "Когда оформлять заказы",
      orderTypeAll: "Все заказы сразу",
      orderTypeNear: "Ближе к крайнему сроку",
      autoorderTitle: "Оформление заказов",
      autoorderLabel: "Сразу оформить заказы у поставщиков после запуска",
      autoorderHint:
        "Сразу после нажатия «Запустить закупку» система оформит реальные заказы у поставщиков, не дожидаясь утреннего планировщика. Удобно для срочных закупок.",

      // ── Блок «Поставщики + Бренды» (одна строка сверху) ──
      suppliersBlockTitle: "Поставщики",
      suppliersBlockHint: "У кого искать предложения и в каком приоритете",
      suppliersConfigure: "Настроить поставщиков",
      suppliersCount: "Выбрано поставщиков: {n}",
      suppliersEmpty: "Поставщики ещё не выбраны",
      suppliersRanksSummary: "рангов: {n}",
      brandsBlockTitle: "Бренды",
      brandModeTrusted: "Доверенные бренды",
      brandModeTrustedHint: "Аналоги ищем только у этих брендов (включить только их)",
      brandModeExclude: "Исключить бренды",
      brandModeExcludeHint: "Эти бренды не показываем в подборе",
      brandsEdit: "Изменить",
      brandsSave: "Сохранить бренды",
      brandsSaved: "Список брендов сохранён",
      brandsEmptyTrusted: "Бренды не заданы — аналоги ищутся у любых брендов",
      brandsEmptyExclude: "Бренды не заданы — ничего не исключаем",

      // ── Быстрые кнопки крайнего срока ──
      deadlineQuick3: "3 дня",
      deadlineQuickWeek: "Неделя",
      deadlineQuickMonth: "Месяц",

      // ── Заголовки цветных блоков ──
      blockTiming: "Сроки и цена",
      blockTimingHint: "Когда нужны позиции и какой запас закладываем",
      blockPrice: "Цена",

      // ── Тултипы «?» ──
      helpDeadline: "Дата, к которой позиции должны быть у вас. Влияет на выбор предложений по сроку поставки.",
      helpExtraDays: "Сколько дней сверх крайнего срока считать допустимыми — небольшой буфер на случай задержек.",
      helpPriceDiff: "Насколько цена аналога может превышать целевую, чтобы его всё равно предложить.",
      helpAlgos:
        "Каждая отмеченная ячейка — отдельная готовая рекомендация. Потом сравните их в сводке и оставите лучшую.",
      helpSafety: "Запасные способы. Включаются, только если обычные алгоритмы нашли слишком мало позиций.",
      helpBrands:
        "Список брендов через запятую. В режиме «доверенные» ищем только у них; в режиме «исключить» — убираем их из подбора.",
    },

    review: {
      title: "Готово к запуску",
      subtitle:
        "Проверьте параметры. После запуска ход проценки можно отслеживать в виджете «Процессы» в верхней панели",
      positions: "Позиций",
      suppliers: "Поставщиков",
      strategy: "Стратегия",
      deadline: "Крайний срок",
      autoorder: "Автозаказ",
      autoorderOn: "Включён",
      autoorderOff: "Выключен",
      algosCount: "алгоритмов: {n}",
      positionsTitle: "Позиции подбора",
      runNow: "Запустить",
    },

    reportPreview: {
      triggerLabel: "Посмотреть пример отчёта",
      otherResultsTitle: "Таблица результатов по площадкам",
      otherResultsCaption:
        "По каждой позиции — все найденные предложения площадок с ценой и сроком. Удобно сравнить и выбрать вручную, без наценок и согласований.",
      otherSummaryTitle: "Сводка проценки",
      otherSummaryCaption:
        "Сколько позиций обеспечено, по скольким площадкам прошёл поиск и где предложений не нашлось — как в одиночной проценке, только по всему списку сразу.",
      title: "Что вы получите в итоге",
      subtitle: "Пример готового результата подбора — по нему видно, какие задачи он вам закроет",
      summaryTitle: "Сводка по алгоритмам",
      summaryCaption:
        "Все потребности в одной таблице, а рядом — что предлагает каждый алгоритм подбора: сумма, срок и покрытие. Сразу видно, какой вариант выгоднее, без ручного сравнения прайсов.",
      provisionTitle: "Потребность → обеспечение",
      provisionCaption:
        "Разворачиваете позицию — и видите, каким именно товаром и у какого поставщика она обеспечена: наименование, цена, срок. Точечно заменяете любое предложение через полную проценку.",
      colName: "Наименование",
      colQty: "Кол-во",
      algoBest: "Лучшая по цене",
      algoCombo: "Комбинированная",
      pluginsChecked: "Площадок в поиске",
      gsRequested: "Запрошенный артикул",
      gsReplacements: "Оригинальные замены",
      gsAnalogs: "Аналоги",
      screen1Title: "Готовый план закупки",
      screen1Caption:
        "По каждой позиции сразу видно, у какого поставщика выгоднее купить — с ценой, сроком и экономией. Больше не нужно вручную сравнивать десятки прайсов.",
      screen2Title: "Экономия и покрытие",
      screen2Caption:
        "Итоговая экономия в рублях, процент покрытия потребности и что найти не удалось — прозрачная картина результата, которую можно показать руководителю.",
      screen3Title: "Заказы поставщикам",
      screen3Caption:
        "Позиции автоматически разложены по поставщикам с учётом рангов и минимальных партий — заказы оформляются в один клик, без ручной сортировки.",
      screen4Title: "Коммерческое предложение клиенту",
      screen4Caption:
        "Из того же подбора одним движением готовится КП с вашей наценкой и сроком действия — клиент согласует его по ссылке, без переписки и таблиц.",
      colArticle: "Позиция",
      colSupplier: "Поставщик",
      colPrice: "Цена",
      colTerm: "Срок",
      saved: "Сэкономлено",
      coverage: "Покрытие",
      notFound: "Не найдено",
      covered: "Обеспечено",
      order: "Заказать",
      markup: "Наценка",
      total: "Итого клиенту",
      ttl: "Действует 14 дней",
      sendToClient: "Отправить клиенту",
      prev: "Назад",
      next: "Далее",
      done: "Понятно",
    },

    excel: {
      loadFile: "Загрузить из файла",
      loadHistory: "Загрузить из истории",
      loadSample: "Загрузить из примера",
      loadMenu: "Загрузить",
      loadMore: "Другие источники",
      sample: "Пример",
      clear: "Очистить",
      clearAllTable: "Очистить всю таблицу",
      deleteSelectedRows: "Очистить выбранные строки",
      crop: {
        menuItem: "Обрезать до диапазона",
        title: "Обрезать таблицу до диапазона",
        hint: "Оставьте только строки и столбцы в выбранном диапазоне. Остальное очистится, а оставленные данные сдвинутся в левый верхний угол.",
        rows: "Строки",
        cols: "Столбцы",
        summary: "Останется: {rows} {rowWord} × {cols} {colWord}",
        rowOne: "строка",
        rowFew: "строки",
        rowMany: "строк",
        colOne: "столбец",
        colFew: "столбца",
        colMany: "столбцов",
        condensed: "В превью видны края диапазона: ⋮ — свёрнутые строки, ⋯ — столбцы.",
        apply: "Обрезать",
        empty: "Таблица пуста — обрезать нечего.",
        rowStartAria: "Первая строка диапазона",
        rowEndAria: "Последняя строка диапазона",
        colStartAria: "Первый столбец диапазона",
        colEndAria: "Последний столбец диапазона",
      },
      deleteMenu: "Очистить",
      deleteMore: "Варианты очистки",
      selectMenu: "Выбрать",
      selectMore: "Другие варианты выбора",
      checkAllAria: "Отметить все строки",
      checkRowAria: "Отметить строку",
      flagCycleHint: "Клик: обычная → важная → не заменять → обычная",
      apply: "ОК",
      splitColumn: "Разделить колонку",
      splitNoDelimiter: "Разделитель не найден в выбранной колонке — проверьте символ разделения",
      splitFrom: "Разбить колонку",
      splitBy: "по",
      splitInto: "и разложить с колонки",
      splitApply: "Разделить",
      splitHint:
        "Разбивает склеенные значения из одной колонки по отдельным колонкам. Пример: «BOSCH 0986424815» → «BOSCH» останется на месте, а «0986424815» встанет в соседнюю колонку справа. Выберите: какую колонку разбить, по какому символу (пробел, запятая) и с какой колонки разложить части. Если в этих колонках уже были данные — они заменятся.",
      splitDone: "Колонка разделена",
      delimSpace: "Пробел",
      delimComma: "Запятая",
      delimSemicolon: "Точка с запятой",
      delimTab: "Табуляция",
      aiDecode: "Расшифровка ИИ",
      aiProcessing: "ИИ разбирает позиции…",
      aiDone: "Позиции расшифрованы (демо-режим)",
      filterPlaceholder: "Быстрый отбор: артикул, бренд, наименование…",
      filterEmpty: "Ничего не найдено",
      filterEmptyHint: "Измените запрос быстрого отбора",
      resizeColHint: "Потяните, чтобы изменить ширину столбца",
      resizeRowHint: "Потяните, чтобы изменить высоту строк",
      expand: "Развернуть на весь экран",
      collapse: "Свернуть",
      rowLimit: "Оставить строк",
      rowLimitApplied: "Оставлено строк: {n}",
      selectedCount: "Выбрано: {n}",
      bulkImportant: "Важные",
      bulkImportantOff: "Снять «важное» с выбранных",
      bulkNoReplace: "Не заменять",
      bulkNoReplaceOff: "Снять «не заменять» с выбранных",
      bulkDelete: "Удалить",
      bulkClearSelection: "Снять выделение",
      selectAll: "Выбрать все",
      selectFiltered: "Выбрать отфильтрованные",
      selectWithoutPrice: "Выбрать без цены",
      dragHint: "Перетащите, чтобы поменять колонки местами",
      flagImportant: "Важная позиция",
      flagNoReplace: "Не заменять аналогами",
      addRow: "Добавить строку",
      pasteHint: "Скопируйте ячейки из Excel и вставьте (Ctrl+V) прямо в таблицу",
      fieldArticle: "Артикул",
      fieldBrand: "Бренд",
      fieldQty: "Кол-во",
      fieldCost: "Цена ₽",
      fieldTime: "Срок до, дн",
      fieldName: "Наименование",
      fieldNone: "— пусто —",
      addRows: "Добавить строки",
      dragHeaderHint:
        "Перетащите шапку на другую колонку, чтобы поменять назначение столбцов (или выберите тип в списке)",
      gridHint: "Выделяйте мышью, копируйте Ctrl+C и вставляйте Ctrl+V — как в Excel",
      stepTitle: "Список позиций",
      stepSubtitle:
        "Здесь вы указываете, что нужно закупить: артикул, бренд, количество. Вставляйте прямо из Excel, загрузите файл или подтяните из прошлой закупки. Бренд можно не указывать — подберём, а пустые столбцы используйте для своих заметок.",
    },

    history: {
      title: "Загрузить из истории",
      subtitle: "Выберите прошлую закупку — её позиции подставятся в таблицу",
      loading: "Загружаем список…",
      loadingPositions: "Загружаем позиции…",
      empty: "Пока нет прошлых закупок",
      pickHint: "Выберите закупку слева, чтобы увидеть позиции",
      positionsCount: "Позиций: {n}",
      andMore: "и ещё {n}…",
      loadBtn: "Загрузить {n} позиций",
    },

    suppliers: {
      title: "Поставщики для подбора",
      barLabel: "Поставщики",
      barHint: "У кого искать предложения и в каком приоритете",
      setup: "Настроить поставщиков",
      configured: "Поставщики настроены",
      selectedCount: "Выбрано: {n}",
      next: "Далее: ранги",
      done: "Готово",
    },

    ranks: {
      title: "Ранги поставщиков",
      explain:
        "Ранг — приоритет поставщика. Если предложения сопоставимы, система выберет поставщика с более высоким рангом — даже если у поставщика рангом ниже выгоднее цена или короче срок. Так вы отдаёте предпочтение доверенным поставщикам. Обычно достаточно оставить всех в первом ранге.",
      dragHint: "Перетаскивайте карточки между рангами или пользуйтесь стрелками",
      rankN: "Ранг {n}",
      topPriority: "высший приоритет",
      lowerPriority: "ниже приоритетом",
      moveUp: "Поднять ранг",
      moveDown: "Понизить ранг",
      emptyCol: "Перетащите сюда стрелками",
      dropHere: "Перетащите поставщиков сюда",
      dropToDisable: "Перетащите сюда, чтобы отключить",
      addRank: "Добавить ранг",
      deleteRank: "Удалить ранг",
      selectAll: "Выбрать все",
      clearAll: "Снять все",
      catalogBtn: "Каталог поставщиков",
      filterPlaceholder: "Фильтр по названию…",
      addSuppliers: "Добавить поставщиков",
      drawerTitle: "Каталог поставщиков",
      drawerChecked: "В подборе",
      drawerUnchecked: "Отключены",
      drawerEmpty: "Список поставщиков пуст",
      drawerHint:
        "Нажмите ранг, чтобы добавить поставщика в подбор, или перетащите карточку. Корзина — убрать из подбора.",
      rankBtn: "Ранг {n}",
      remove: "Убрать из подбора",
      disabledZone: "Отключённые",
      close: "Готово",
    },

    recView: {
      heading: "Рекомендации",
      viewList: "Списком",
      viewCards: "Плитками",
      openTreeHint: "Открыть потребность и обеспечение по этому алгоритму",
      pendingShort: "идёт проценка…",
      noOffers: "нет предложений",
      noStrategies: "Стратегий пока нет",
      openStrategyHint: "Открыть эту стратегию",
      strategyNoProvision: "Эта стратегия позицию не обеспечила",
      compare: {
        label: "Сравнить",
        activeLabel: "Сравнение · {count}",
        hint: "Сравнить стратегии между собой: суммы, покрытие и обеспечение каждой позиции",
        disabledHint: "Для сравнения нужно хотя бы две стратегии",
        title: "Стратегии для сравнения",
        start: "Сравнить",
        apply: "Применить",
        exit: "Выйти из сравнения",
        minHint: "Отметьте не меньше {n} стратегий",
        pickedCount: "Выбрано: {count}",
      },
      toggleLayout: "Сменить вид",
      sum: "Сумма",
      time: "Срок",
      coverage: "Покрытие",
      colName: "Наименование",
      colQty: "Кол-во",
      colPrice: "Цена",
      totals: "Итого",
      openTree: "Потребность / обеспечение",
      details: "Полная проценка",
      algoContent: "Состав алгоритма",
      starting: "Запускаем…",
      empty: "Рекомендаций пока нет",
      pendingHint: "Рекомендации и обеспечение формируются после завершения проценки всех позиций",
      totalAlgoHint: "Итоговая сумма алгоритма и процент покрытия потребностей",
      totalTargetHint: "Итоговая целевая сумма по всем потребностям",
      expandRow: "Показать предложения обеспечения",
      collapseRow: "Скрыть предложения обеспечения",
      provHint: "Показать это предложение в таблице результатов",
      offersFull: "Полная проценка",
      offersRecsOnly: "Только рекомендации",
      offersFullHint: "Все предложения по выбранной потребности",
      offersRecsOnlyHint: "Только предложения, выбранные алгоритмами",
      cov: {
        full: "Обеспечены",
        partial: "Частично",
        none: "Не обеспечены",
      },
      covFilterHint: "Показать только потребности с этим статусом обеспеченности",
      covFilterScope: "Статус считается по алгоритмам: {algos}",
      cellPopoverHint: "Обеспеченность потребности этим алгоритмом — клик покажет состав",
      cellPopoverEmpty: "Состав обеспечения ещё загружается",
      replacePick: "Дважды кликните предложение, которым заменить {article}",
      replacePickTouch: "Нажмите предложение, которым заменить {article}",
      replacing: "Заменяем…",
      addPick: "Отметьте предложения галочками или дважды кликните строку, чтобы добавить в подбор",
      addPickTouch: "Нажмите предложение, чтобы добавить его в подбор",
      addChecked: "Добавить отмеченные ({count})",
      addProvision: "Добавить",
      addProvisionHint: "Добавить обеспечение из результатов проценки",
      deleteProvisionHint: "Убрать это обеспечение из подбора",
      dropHere: "Отпустите на позиции «{need}» — добавим предложения в её обеспечение",
      dropBlockedNoPricing: "По этой позиции ещё нет проценки — добавить предложения пока некуда",
      dropWrongNeed: "Сюда не добавить — предложения найдены по позиции «{need}»",
      dropRejected: "Предложения найдены по позиции «{need}» — добавить их можно только к ней",
      dropAdding: "Добавляем предложения…",
    },

    hints: {
      goalChip: "Тип задачи подбора",
      stateChip: "Текущий этап работы над подбором",
      progress: "Сколько позиций уже обработано проценкой",
      sidebarProgress: "Обработано позиций / всего в проценке",
      recPickerSub: "Итог алгоритма: сумма закупки и процент закрытых потребностей",
      quickFilter: "Ищет по всему содержимому таблицы результатов и подсвечивает совпадения",
    },
    limits: {
      savedAsDraft:
        "Лимит проценок на сегодня исчерпан (не хватает на {n} поз.) — проценка сохранена черновиком. Запустите её позже с карточки.",
      stillShort: "Лимита всё ещё не хватает на {n} поз. — попробуйте позже",
      startFailed: "Не удалось запустить проценку",
      startDraft: "Запустить проценку",
      startDraftHint: "Черновик сохранён — запуск спишет лимит проценок на каждую позицию",
    },
    excelExport: {
      exportBtn: "Экспорт в Excel",
      fileName: "Подбор",
      colArticle: "Артикул",
      colBrand: "Бренд",
      colName: "Наименование",
      colPrice: "Цена",
      colPriceInput: "Цена из файла",
      colBestPrice: "Лучшая цена",
      colMinPrice: "Мин. цена (все предложения)",
      colMinPriceSource: "Источник мин. цены",
      colSavings: "Экономия за ед.",
      colSavingsTotal: "Экономия, итого",
      colOfferArticle: "Предложение · артикул",
      colOfferBrand: "Предложение · бренд",
      colOffersCount: "Предложений",
      colCount: "Наличие",
      colQty: "Кол-во",
      colSum: "Сумма",
      colTime: "Срок",
      colCity: "Город",
      colStock: "Склад",
      colSupplier: "Поставщик",
      colOrderState: "Статус заказа",
      colSearchState: "Статус поиска",
      cat: {
        requested: "Запрошенный артикул",
        original: "Оригинальные замены",
        analog: "Аналоги",
        warehouse: "Склады поставщика",
      },
      noOffers: "Нет предложений",
      offersFailed: "Предложения загрузить не удалось",
      needRow: "Потребность: {need}",
      truncated: "Лист Excel вмещает не всё: показаны первые {n} строк",
      offersSheet: "Проценка",
      summarySheet: "Сводка",
      needsSheet: "Потребности",
      selectedSheet: "Отобранные позиции",
      colNeedArticle: "Потребность · артикул",
      colNeedBrand: "Потребность · бренд",
      noSelected: "Ничего не отобрано",
      totals: "Итого",
      collectingOffers: "Собираем предложения проценки",
      collectFailed: "Предложения части позиций загрузить не удалось — в файле они без предложений и цен",
      exportFailed: "Не удалось сформировать файл выгрузки",
      confirmLargeTitle: "Собрать предложения по всем позициям?",
      confirmLargeMessage:
        "В проценке {n} позиций. Сбор предложений может занять несколько минут. Без сбора в файл попадут предложения только выбранной позиции, без цен проценки по остальным.",
      confirmLargeOk: "Собрать",
      confirmLargeSkip: "Без сбора",
      legend: {
        sheet: "Пояснения",
        colMark: "Обозначение",
        colMeaning: "Что означает",
        bestSummary: {
          mark: "Зелёная заливка — лист «Сводка»",
          text: "Сумма рекомендации с самой низкой ценой за единицу в строке потребности — той же, что указана в «Источник мин. цены». Если минимум совпадает у нескольких рекомендаций, выделены все. Рекомендации, не закрывшие потребность, не участвуют.",
        },
        bestOffer: {
          mark: "Зелёная заливка — цена предложения",
          text: "Самая низкая цена среди предложений по одной потребности (лист «Проценка» и листы рекомендаций). При совпадении выделены все такие предложения.",
        },
        worstOffer: {
          mark: "Оранжевая заливка — цена предложения",
          text: "Самая высокая цена среди предложений по той же потребности; при совпадении выделены все. Если предложение одно или все цены одинаковы, выделения нет — сравнивать не с чем.",
        },
        overpay: {
          mark: "Красная заливка — столбец «Цена»",
          text: "Запрошенная цена потребности выше минимальной найденной (столбец «Мин. цена (все предложения)») — есть переплата. Если минимальной цены нет, индикация не применяется.",
        },
        overpayQuote: {
          mark: "Красная заливка — столбец «Цена из файла»",
          text: "Цена из файла потребностей выше лучшей цены проценки (столбец «Лучшая цена») — есть переплата. Если лучшей цены нет, индикация не применяется.",
        },
        minPrice: {
          mark: "«Мин. цена (все предложения)» и «Источник мин. цены»",
          text: "Самая низкая цена за единицу среди рекомендаций сводки: сумма рекомендации по потребности, делённая на закрытое ею количество. «Источник» — рекомендация, которая эту цену даёт; при совпадении перечислены все.",
        },
        savings: {
          mark: "«Экономия за ед.» и «Экономия, итого»",
          text: "Запрошенная цена минус минимальная найденная — за единицу и на всё количество потребности. Положительное число — переплата, отрицательное — запрошенная цена уже ниже найденной. Пусто — одной из цен нет. В строке «Итого» — экономия по всей закупке.",
        },
      },
    },
    needsPanel: {
      colArticle: "Артикул",
      colBrand: "Бренд",
      colQty: "Кол-во",
      colPrice: "Цена",
      expand: "Показать товары из корзины",
      collapse: "Скрыть товары из корзины",
      state: {
        searching: "Идёт поиск предложений",
        found: "Предложения найдены",
        empty: "Ничего не найдено",
      },
      inCart: "В корзине: {n}",
      needMark: "Потребность",
      subRowHint: "Показать это предложение в таблице результатов",
      subInCart: "Товар в корзине",
      empty: "Нет позиций",
      filterEmpty: "Нет потребностей по фильтру",
      covFilterHint: "Фильтр по обеспеченности потребностей",
      cov: {
        none: "Не обеспечено",
        partial: "Частично",
        full: "Обеспечено",
      },
      searchPlaceholder: "Поиск…",
      filterArticleAria: "Фильтр по артикулу",
      filterBrandAria: "Фильтр по бренду",
      subQtyAria: "Количество отобранной позиции",
      covMarkHint: "Обеспечено {covered} из {need}",
      removeSub: "Убрать из корзины",
      removeSubHint: "Убрать эту позицию из корзины",
      removeConfirm: "Убрать из корзины: {article} {brand}?",
      order: "Заказать",
      orderSubHint: "Оформить заказ этой позиции",
      orderAll: "Заказать всё",
      orderConfirmTitle: "Оформление заказа",
      orderConfirmOne: "Оформить заказ: {article} {brand}?",
      orderConfirmAll: "Оформить заказ по всем отобранным позициям ({n})?",
      orderSuccess: "Оформлено позиций: {n}",
      orderFail: "Не удалось оформить заказ",
      ordered: "Оформлено",
      orderedHint: "Позиция оформлена в заказ — засчитана в обеспеченность потребности",
    },
    needProvision: {
      needHave: "нужно {need} / есть {have}",
      needHaveHint: "Сколько требуется по потребности и сколько уже найдено в обеспечении",
      pcs: "шт",
      days: "{n} дн",
      pending: "Обеспечение формируется после завершения проценки всех позиций",
      noneFound: "Обеспечить не удалось",
      empty: "Нет позиций",
      status: {
        full: "Обеспечено полностью",
        partial: "Обеспечено частично",
        none: "Не обеспечено",
      },
      replaceHint: "Заменить это обеспечение другим предложением из проценки",
    },

    detail: {
      quickFilterPlaceholder: "Быстрый отбор",
      header: {
        goal: "Задача",
        docOsn: "Основание",
        createdBy: "Создал",
        createdAt: "Создан",
        deadline: "Дедлайн",
        suppliersCount: "Поставщиков",
        maxDelivery: "Начальный срок",
        maxDeliveryValue: "до {days} дн.",
        maxDeliveryHint: "Начальное значение фильтра. Срок можно изменить или снять в панели результатов",
      },
      positionsTable: {
        idx: "#",
        article: "Артикул",
        brand: "Бренд",
        name: "Наименование",
        qty: "Кол-во",
        targetPrice: "Цена потребности",
        flags: "Особенности",
      },
      gsRows: {
        platforms: "Площадки",
        platformsFound: "Опрошено площадок",
        platformsError: "Ошибок",
        offersFound: "Найдено предложений",
      },
      gsResults: {
        disabledPlugin: "Отключённый поставщик {n}",
        loadingOffers: "Загрузка предложений…",
        noOffers: "Нет предложений",
        noRecommendedOffers: "По этой потребности нет рекомендованных предложений",
        noOffersFiltered: "Нет предложений по выбранным фильтрам",
        // Результаты удалены по сроку хранения (CAB-602 п.4); вместо пустого грида —
        // объяснение и кнопка повторить подбор по прежним позициям (CAB-677).
        resultsExpiredTitle: "Информация устарела",
        resultsExpiredText:
          "Срок хранения результатов на сервере истёк, и предложения по этому подбору удалены. Позиции остались — повторите подбор: он запустится заново с теми же настройками и позициями.",
        resultsExpiredTextLost:
          "Срок хранения результатов на сервере истёк, и данные этого подбора удалены вместе с позициями. Создайте новый подбор, чтобы получить актуальные цены и сроки.",
        repeatRun: "Повторить подбор",
        newRun: "Новый подбор",
        needsLabel: "Потребности",
        filtersLabel: "Фильтры",
        expandNeeds: "Развернуть панель потребностей",
        expandFilters: "Развернуть панель фильтров",
        collapseHint: "Сплитер до конца влево — свернуть панель",
      },
      settings: {
        groupStrategy: "Стратегия",
        algos: "Алгоритмы",
        trustedBrands: "Доверенные бренды",
        priceDiffPercent: "Допуск цены, %",
        extraDays: "Запас по сроку",
        orderType: "Тип заказа",
        autoorder: "Автозаказ",
        analyticsGroup: "Параметры аналитики",
        schedule: "Расписание",
        notifyEmail: "Email уведомлений",
        platforms: "Опрошено площадок",
        triggers: "Триггеры",
      },
      tabs: {
        positions: "Потребность",
        recommendations: "Рекомендации",
        orders: "Заказы поставщикам",
        negotiation: "Согласование",
        structure: "Структура",
        settings: "Настройки",
        history: "История",
      },
      state: {
        // Лейблы статусов закупки — пользовательские, не дублируют название цели.
        // 1С→state: 1 Черновик, 2 Подготовка, 3 Ожидание запуска, 4 Согласование,
        //           5 Закупка в процессе, 6 Завершено, 7 Остановлено.
        draft: "Черновик",
        pricing: "Идёт проценка",
        // Переходное состояние: стоп принят, очередь ещё гаснет (CAB-738)
        stopping: "Останавливаем…",
        planning: "Рекомендации готовы",
        negotiation: "Ждём ответ клиента",
        purchasing: "Заказы у поставщиков",
        completed: "Завершено",
        cancelled: "Остановлено",
        archived: "В архиве",
      },
      actions: {
        start: "Запустить",
        stop: "Остановить",
        archive: "В архив",
        unarchive: "Из архива",
        delete: "Удалить",
        edit: "Изменить",
        rerun: "Перепроценить",
        export: "Экспорт",
        share: "Поделиться",
        more: "Ещё",
      },
      progressLabel: "Проценка: {finished} из {total}",
      etaLabel: "≈ {time}",
      recommendation: {
        algoLabel: "Алгоритм {n}",
        sum: "Сумма",
        timeMax: "Макс. срок",
        coverage: "Покрытие",
        select: "Выбрать как основу",
        copy: "Скопировать всё в свою версию",
        copyHint: "Полная копия рекомендации в вашу личную версию — её можно править вручную",
        copyAlreadyExists: "У вас уже есть пользовательская рекомендация — нужно использовать её",
        startPurchase: "Запустить закупку",
        sendToClient: "Отправить клиенту",
        empty: "Рекомендации появятся после завершения проценки",
        requiresTrusted: "Требует доверенных брендов",
      },
      negotiationLink: {
        title: "Ссылка для клиента",
        notCreated: "Ссылка ещё не создана",
        copyLink: "Скопировать ссылку",
        viewAsClient: "Открыть как клиент",
        resend: "Отправить повторно",
        revoke: "Отозвать ссылку",
        stateSent: "Отправлено клиенту",
        stateOpened: "Клиент открыл",
        stateAccepted: "Клиент одобрил",
        stateRejected: "Клиент отказался",
      },
      ctas: {
        startProcurement: "Запустить закупку",
        startProcurementHint: "Поставит позиции выбранной рекомендации в очередь оформления заказов у поставщиков",
        startTender: "Подготовить КП клиенту",
        startTenderHint: "Откроет окно «Согласование» с предзаполненной наценкой и контактами",
        startWithoutNegotiate: "Запустить закупку",
        startWithoutNegotiateHint: "Запустить закупку сразу, без согласования — не дожидаясь ответа клиента на КП",
        startWithoutNegotiateConfirmTitle: "Запустить закупку без согласования?",
        startWithoutNegotiateConfirmMessage:
          "Закупка будет запущена сразу, без ожидания ответа клиента по КП. Заказы поставщикам можно будет оформить после запуска.",
        startWithoutNegotiateConfirmOk: "Запустить",
        starting: "Запускаем…",
        stop: "Остановить",
        stopHintActive: "Остановить активную закупку — позиции в очереди заказов не пойдут",
        stopHintInactive: "Остановить можно только активную закупку",
        stopSearchHintActive: "Остановить проценку — оставшиеся позиции обрабатываться не будут",
        stopSearchHintInactive: "Остановить можно только идущую проценку",
        stopPendingHint: "Остановка отправлена — ждём, пока проценка свернёт очередь запросов",
        stopping: "Останавливаем…",
        archive: "В архив",
        archiveHint: "Убрать закупку из списка активных — останется доступной в архиве",
        archiving: "Архивируем…",
        share: "Поделиться",
      },
      drawer: {
        bannerEditable: "Можно редактировать",
        bannerLocked: "Закупка запущена · состав зафиксирован",
        bannerNegotiation: "КП на согласовании · состав зафиксирован",
        bannerSystem: "Стандартная · не редактируется",
        useAsBaseCta: "→ Использовать как основу для своей",
        useAsBaseCtaWithCount: "→ Использовать как основу для своей ({count})",
        useAsBaseCopying: "Копируем…",
        close: "Закрыть",
        copyToOwn: "Скопировать всё в свою версию",
        copyToOwnAlreadyExists: "У вас уже есть пользовательская рекомендация — нужно использовать её",
        orderSelected: "Оформить заказы по выбранным ({count})",
        ordering: "Оформляем…",
        cancel: "Отмена",
        backToContent: "Вернуться к составу",
        emptyState: "Состав ещё не подгружен или ничего не подобралось",
        rowReplaceTitle: "Заменить позицию другим предложением из результатов поиска",
        rowDeleteTitle: "Удалить позицию из рекомендации",
        rowDeleteConfirm: "Удалить позицию «{label}»?",
        rowItemAlreadyOrdered: "Заказ уже оформлен",
        rowItemIncludeInOrder: "Включить в отправку заказа",
        selectAllAvailable: "Выбрать все доступные позиции",
        selectAllDeselect: "Снять выбор",
        rowQtyTitle: "Кол-во",
        rowQtySaving: "Сохраняем…",
        selectionHint: "Выбрано {selected} из {total} доступных · сумма по выбранным: {sum}",
        statusReady: "Готово к заказу",
        statusPinned: "Закреплено",
        statusOrdered: "Заказано",
        replaceTitle: "Выбор другого предложения",
        replaceSubtitle: "Выберите подходящее предложение",
        replaceCurrent: "Текущий: {plugin} · {price} · {days} дн",
        replaceFilterPlugin: "Поставщик",
        replaceFilterBrand: "Бренд",
        replaceFilterCity: "Город",
        replaceFilterSort: "Сортировка",
        replaceFilterReset: "Сбросить",
        replaceFilterAll: "Все",
        replaceLoading: "Загружаем варианты…",
        replaceFound: "Найдено: {count}",
        replaceFoundOf: "· всего: {total}",
        replaceNoResults: "Под текущие фильтры ничего не подошло",
        replacePick: "Выбрать",
        replacePickHint: "Двойной клик по предложению — заменить деталь",
        replacePicking: "Заменяем…",
        sortPriceAsc: "Цена ↑",
        sortPriceDesc: "Цена ↓",
        sortTimeAsc: "Срок ↑",
        replaceCurrentLine: "Текущий: {plugin} · {price} · {time}",
        emptyDrawerBody: "Состав ещё не подгружен или алгоритм не нашёл подходящих предложений",
        loadingComposition: "Загружаем состав…",
        useAsBase: "Скопировать выбранное в свою версию",
        useAsBaseWithCount: "Скопировать выбранное в свою версию ({count})",
        badgeOrdered: "Заказано",
        badgePinned: "Закреплено",
        badgeReady: "Готово к заказу",
        selectionHintFull: "Выбрано {selected} из {total} доступных · сумма по выбранным: {sum}",
      },
      orders: {
        kicker: "Заказы поставщикам",
        emptyNoPurchase: "Закупка не связана с системой оформления",
        emptyNoPurchaseHint: "Заказы поставщикам появятся после запуска",
        emptyNotStarted: "Закупка ещё не запущена",
        emptyNotStartedHint:
          "Выберите алгоритм в сводке и нажмите «Запустить закупку». Заказы появятся здесь после старта.",
        emptyNotStartedHintTender:
          "Выберите алгоритм в сводке и подготовьте КП клиенту. Заказы появятся здесь после старта закупки — после согласования с клиентом или по кнопке «Запустить закупку без согласования».",
        titleByRec: "По рекомендации",
        summary: "Всего: {total} · Заказано: {ordered} · Ошибки: {errors} · Ожидают: {queued}",
        refresh: "Обновить",
        refreshing: "Обновляем…",
        sendBtn: "Оформить заказы ({count})",
        sending: "Оформляем…",
        sendHintEmpty: "Выберите позиции, по которым нужно оформить заказ",
        sendHint: "Оформит заказы у поставщиков по выбранным позициям",
        listEmpty: "Список заказов пуст",
        moState: {
          error: "Ошибка заказа",
          ordered: "Заказано",
          processing: "Оформляется",
          received: "Поступило",
          waiting: "Ожидает оформления",
        },
        bottomHint:
          "Выберите нужные позиции и нажмите «Оформить заказы», чтобы отправить их поставщикам. Часть поставщиков требует подтверждения — для таких позиций заказ будет сделан позже, когда подтверждение получено.",
        rowAlreadySent: "Заказ уже оформлен",
        rowIncludeForOrder: "Включить в отправку",
        selectAllEmpty: "Нет позиций для оформления",
        selectAllEnable: "Выбрать все ожидающие оформления",
        selectAllDisable: "Снять выбор",
        columns: {
          article: "Артикул",
          brand: "Бренд",
          plugin: "Поставщик",
          price: "Цена",
          planned: "План",
          ordered: "Заказано",
          received: "Поступило",
          orderNum: "№ заказа",
          status: "Статус заказа",
        },
      },
      negotiate: {
        title: "Согласование с клиентом",
        subtitle:
          "Соберите ссылку: выберите рекомендации, проставьте наценку и контакты — клиент увидит предложенные позиции и сможет одобрить или отклонить.",
        groupRecs: "Включить в ссылку",
        groupClient: "Контакты клиента",
        groupManager: "Контакты менеджера",
        groupComment: "Комментарий клиенту",
        groupParams: "Параметры",
        groupNotify: "Уведомление",
        clientPhone: "Телефон",
        clientPhonePlaceholder: "+7 (___) ___-__-__",
        clientEmail: "Email",
        clientEmailPlaceholder: "Email клиента",
        contactsRequired: "Укажите телефон или email клиента — по ним отправляется ссылка согласования",
        managerName: "Имя",
        managerPhone: "Телефон",
        managerEmail: "Email",
        commentPlaceholder: "Например: «Цены актуальны до конца недели»",
        tmPercent: "Наценка для клиента, %",
        ttlDays: "Срок жизни ссылки, дн",
        prepay: "Предоплата, ₽",
        notifyEmail: "Email",
        linkLabel: "Превью ссылки для клиента",
        copyLink: "Скопировать",
        saveDraft: "Сохранить черновик",
        saving: "Сохраняем…",
        sendNow: "Создать и отправить →",
        sendingNow: "Отправляем…",
        deleteLink: "Удалить согласование",
        deletingLink: "Удаляем…",
        deleteConfirmTitle: "Удалить согласование?",
        deleteConfirm: "Удалить согласование? Клиент больше не сможет открыть ссылку.",
        deleteConfirmOk: "Удалить",
        notifyCopied: "Ссылка скопирована",
        notifyDeleted: "Согласование удалено",
        notifyDraftSaved: "Черновик согласования сохранён",
        notifySent: "Ссылка отправлена клиенту",
        errorSave: "Не удалось сохранить",
        errorSend: "Не удалось отправить",
        errorDelete: "Не удалось удалить",
      },
      buildCustomConfirm: {
        title: "Скопировать выбранные позиции в свою версию рекомендации",
        textBase: "Будет скопировано позиций: {count}.",
        textExisting: "В вашей версии рекомендации уже {n} {plural} — совпадающие заменим, новые добавим.",
        textNew: "Своя версия рекомендации создастся автоматически — она одна на закупку.",
        cancel: "Отмена",
        confirm: "Скопировать и открыть",
        copying: "Копируем…",
        offerOne: "позиция",
        offerFew: "позиции",
        offerMany: "позиций",
        notifyDone: "Скопировано {count} позиций в вашу версию рекомендации",
        errorCopy: "Не удалось создать свою версию рекомендации",
      },
      notifications: {
        rerunInBackend: "Перезапуск закупки",
        archived: "Закупка перемещена в архив",
        deleted: "Подбор удалён",
        deleteFail: "Не удалось удалить",
        exported: "Экспорт CSV (демо)",
        shareLink: "Ссылка скопирована",
        runStarted: "Подбор «{title}» запущен",
        runFailed: "Не удалось запустить подбор",
        startSuccess: "Закупка запущена",
        startFail: "Не удалось запустить рекомендацию",
        startTenderHint: "Заполните контакты клиента и нажмите «Создать и отправить» в окне «Согласование»",
        stopSuccess: "Закупка остановлена",
        stopFail: "Не удалось остановить",
        stopSearchSuccess: "Останавливаем проценку — очередь запросов сворачивается",
        stopSearchFail: "Не удалось остановить проценку",
        stopNotActive: "Останавливать нечего: подбор уже не выполняется",
        stopUnsupported: "Этот подбор нельзя остановить — он не запущен на сервере",
        // Повтор подбора копией при удалённых по сроку хранения результатах (CAB-677)
        repeatSuccess: "Подбор запущен заново с прежними настройками и позициями",
        repeatFail: "Не удалось повторить подбор",
        archiveFail: "Не удалось архивировать",
        archiveUnsupported: "У этого подбора нет закупки — архивировать нечего. Его можно удалить",
        deleteItemFail: "Не удалось удалить позицию",
        deleteItemSuccess: "Позиция удалена",
        replaceSuccess: "Позиция заменена: {article} {brand}",
        replaceFail: "Не удалось заменить позицию",
        addSuccess: "Добавлено в подбор: {article} {brand}",
        addManySuccess: "Добавлено в подбор предложений: {count}",
        addFail: "Не удалось добавить в подбор",
        deleteProvisionSuccess: "Обеспечение убрано из подбора",
        deleteProvisionFail: "Не удалось убрать обеспечение",
        loadAltsFail: "Не удалось загрузить варианты",
        qtyUpdateFail: "Не удалось обновить количество",
        orderSelectionSuccess: "Поставлено в очередь оформления: {count}",
        orderSelectionFail: "Не удалось оформить заказы",
        orderTabReloadFail: "Не удалось загрузить заказы",
        startWrongState: "Запуск доступен только до начала закупки",
        staleRecommendations:
          "Рекомендации этой закупки изменились — данные перечитаны. Проверьте выбор и повторите действие",
        purchaseNotLinked: "Закупка ещё не создана в системе оформления заказов",
        orderQueued: "Поставлено в очередь заказов: {count}",
        customCopySuccess: "Скопировано {count} в свою рекомендацию",
        copyRecCreated: "Создана копия рекомендации «{title}»",
      },
      customRecConfirm: {
        title: "Будет создана пользовательская рекомендация",
        text: "Системные алгоритмы менять нельзя — правка создаст пользовательскую рекомендацию (копию), и все дальнейшие изменения будут применяться к ней. Исходные алгоритмы останутся без изменений.",
        baseLabel: "На основе рекомендации",
        cancel: "Отмена",
        confirm: "Создать и применить",
      },
      kinds: {
        custom: "Своя",
        algoPrefix: "Алгоритм {n}",
        algoNumeric: "Алгоритм {n}",
        customDefaultTitle: "Пользовательская",
      },
      drawerSummary: "Сумма: {sum} · Макс. срок: {time} · Покрытие: {coverage}%",
      drawerArticleBrand: "{article} · {brand}",
      flagNoReplace: "Не заменять аналогами",
      flagImportant: "Важная позиция",
      deleteItemConfirm: "Удалить из рекомендации: {article} {brand}?",
      deleteSelectionConfirm: "Удалить подбор «{title}»?",
      positionsLoading: "Позиции загружаются…",
      positionsLoadingHint: "Подгружаем позиции и рекомендации…",
      loadFailed: "Не удалось загрузить данные закупки",
      loadRetry: "Повторить загрузку",
      emptyCustomRec: "Своя версия пока пуста — скопируйте сюда нужные позиции из стандартных рекомендаций",
      emptyAlgoRec: "Алгоритм не нашёл подходящих предложений",
      openContent: "Открыть состав",
      timeDays: "{n} дн",
      strategyValues: {
        orderTypeAll: "Все заказы сразу",
        orderTypeNear: "Ближе к крайнему сроку",
        autoorderOn: "Включён",
        autoorderOff: "Выключен",
      },
      loadError: "Ошибка загрузки",
      stopConfirmTitle: "Остановить закупку?",
      stopConfirm: "Остановить закупку «{title}»? Позиции в очереди оформления не будут заказаны.",
      stopSearchConfirmTitle: "Остановить проценку?",
      stopSearchConfirm:
        "Остановить проценку «{title}»? Найденные предложения останутся в подборе, оставшиеся позиции обработаны не будут. Возобновить остановленную проценку нельзя.",
      stopConfirmOk: "Остановить",
      archiveConfirmTitle: "Архивировать закупку?",
      archiveConfirm: "Архивировать закупку «{title}»?",
      archiveConfirmOk: "В архив",
      deleteItemConfirmTitle: "Удалить позицию?",
      deleteItemConfirmOk: "Удалить",
      deleteSelectionConfirmTitle: "Удалить подбор?",
      deleteSelectionConfirmOk: "Удалить",
      sidebarLockedLabel: "Закупка запущена · состав зафиксирован",
      drawerTable: {
        article: "Артикул",
        brand: "Бренд",
        name: "Наименование",
        plugin: "Поставщик",
        price: "Цена",
        time: "Срок",
        qty: "Кол-во",
        sum: "Сумма",
        status: "Статус",
        stock: "Остаток",
        chance: "Шанс",
        daysSuffix: "дн",
      },
    },
  },

  selectionWidget: {
    runningProcesses: "Запущенные процессы подбора",
    runningProcessesTitle:
      "Запущенные процессы подбора\nНажмите, чтобы посмотреть полный список запущенных процессов подбора.",
    activeCount: "Активных: {count}",
    completedCount: "Завершено: {count}",
    empty: "Сейчас нет активных подборов",
    emptyHint: "Запустите новый подбор и следите за прогрессом отсюда",
    openSelection: "Открыть подбор",
    clearCompleted: "Скрыть завершённые",
    purchasingStatus: "Закупка идёт",
    completedStatus: "Завершено",
  },

  singleSearchEmptyState: {
    heading: "С чего начать",
    subheading: "Введите артикул, VIN, госномер, марку или просто опишите что нужно — найдём предложения у поставщиков",
    openLast: "Открыть последнюю проценку",
    recentTitle: "Недавние поиски",
    recentEmpty: "Сюда попадёт ваша история поиска",
    pathsTitle: "Сценарии",
    path: {
      catalog: {
        title: "Подобрать запчасть",
        description: "Открыть каталог автомобилей по маркам",
        cta: "Открыть каталог",
      },
      selection: {
        title: "Подбор по списку",
        description: "Загрузить список артикулов и подобрать выгодные предложения",
        cta: "Открыть подбор",
      },
      cart: {
        title: "Корзина",
        description: "Оформить заказ из выбранных позиций",
        cta: "Открыть корзину",
      },
    },
  },

  stubs: {
    pricekeeper: "Прайс кипер",
    hypothesis: "Гипотеза",
    zakooper: "Закупер",
    returns: "Возвраты",
    groupPricing: "Групповая проценка",
    retailPricing: "Розничная проценка",
    reports: "Отчеты",
    reviews: "Отзывы",
    settings: "Настройки",
    supplierPotential: "Потенциал нов. поставщиков",
    salesPotential: "Потенциал в продажах",
    salesPotentialTable: "Потенциал в продажах (таблица)",
    supplierTable: "Таблица поставщиков",
    dashboard: "Дашборд",
    analytics: "Аналитика",
    overpayments: "Переплаты",
    overpaymentTable: "Таблица переплат",
  },

  multiplicityIcon: {
    label: "КРАТ",
  },

  billing: {
    title: "Биллинг",
    subtitle: "Управление токенами, лимитами и сотрудниками",
    sidebarLabel: "Биллинг",
    clientLabel: "Клиент",
    clientFallback: "Без клиента",
    relationshipBadge: {
      own: "владение",
      partner: "партнёр",
      managed: "управляемый",
      scope: "доступ",
    },
    // Справочники машинных кодов биллинга. Бэк отдаёт их латиницей (operation_type,
    // event_type, product_id, роли, статусы) — в интерфейсе показываем перевод.
    // Кода нет в списке → показываем как есть (см. billingFormat.labelFor).
    labels: {
      roles: {
        client_user: "Пользователь",
        client_admin: "Админ клиента",
        eplex_partner: "Партнёр",
        eplex_accountant: "Бухгалтер",
      },
      accountStatuses: {
        active: "Активен",
        disabled: "Отключён",
        deleted: "Удалён",
      },
      relationships: {
        own: "владение",
        partner: "партнёр",
        managed: "управляемый",
        scope: "доступ",
      },
      operationStatuses: {
        posted: "Проведено",
        pending: "В обработке",
        processing: "В обработке",
        failed: "Ошибка",
        error: "Ошибка",
        reversed: "Сторнировано",
        frozen: "Заморожено",
        released: "Возвращено",
        settled: "Закрыто",
        cancelled: "Отменено",
        canceled: "Отменено",
      },
      operations: {
        charge: "Списание",
        freeze: "Заморозка",
        settle: "Закрытие резерва",
        release: "Возврат резерва",
        accrual: "Начисление",
        correction: "Корректировка",
        refund: "Возврат",
        tariff_apply: "Тариф применён",
        tariff_extend: "Тариф продлён",
        tariff_change: "Смена тарифа",
        package_grant: "Начисление пакета",
        package_expiration: "Сгорание пакета",
      },
      // Точки списания токенов в инстансах (SER-1295).
      events: {
        search: "Одиночная проценка",
        "retail-search": "Розничная проценка",
        "group-search": "Групповая проценка",
        "make-order": "Оформление заказа",
        "cross-search": "Подбор кроссов",
        plate_number_info: "Каталог по госномеру",
        vin_info: "Каталог по VIN",
        vin_decode: "Расшифровка VIN",
      },
      // Инициатор операции (product_id). Фактически бэк присылает сюда и наши
      // сервисы (service_id: search / catalogs / crosses-lib), и фронт-источник
      // (onec / lk / sto / api-eplex) — держим оба набора (SER-1295).
      products: {
        search: "Поиск",
        catalogs: "Каталоги",
        "crosses-lib": "Кроссы",
        lk: "Личный кабинет",
        onec: "1С",
        sto: "СТО",
        "api-eplex": "API Eplex",
      },
    },
    tabs: {
      overview: "Обзор",
      history: "История",
      employees: "Сотрудники",
      tariffs: "Тарифы",
      operations: "Стоимость операций",
    },
    hero: {
      availableCaption: "Доступно",
      tokensWord: "токенов",
      tariffLabel: "Тариф",
      tariffNotSet: "Тариф не задан",
      tariffUntil: "до {date}",
      upgrade: "Улучшить тариф",
      extend: "Продлить тариф",
      breakdownTemplate: "из них {temp} временных · {permanent} постоянных · {frozen} заморожено в {count} операциях",
      breakdownNoFreezes: "из них {temp} временных · {permanent} постоянных · без активных заморозок",
      // сколько израсходовано из выданного по активным пакетам (BIL-45)
      usageLabel: "Использовано из пакетов",
      usageValue: "{used} из {total} · {percent}%",
      sparklineTitle: "Расход за 14 дней",
      // подсказка над столбиком графика: день и сколько за него списано
      sparklineNoSpend: "Без расхода",
      sparklineTokenOne: "{n} токен",
      sparklineTokenFew: "{n} токена",
      sparklineTokenMany: "{n} токенов",
    },
    overview: {
      // Компактные блоки-переходы в начале «Обзора» (CAB-636): куда идти за ценами,
      // тарифами, историей и сотрудниками — с одной фразой о том, что там.
      nav: {
        operations: "Сколько токенов списывается за проценку, заказ и каталоги",
        tariffs: "Пакеты токенов, продление и докупка",
        history: "Все списания и начисления по датам",
        employees: "Доступы сотрудников и лимиты",
        legalEntity: "Реквизиты для договора и счетов",
        go: "Перейти",
      },
      recentOps: "Последние операции",
      recentOpsEmpty: "В этом месяце операций ещё не было",
      employeesActive: "Сотрудники",
      employeesEmpty: "Сотрудников пока нет",
      seeAllHistory: "вся история →",
      seeAllEmployees: "все сотрудники →",
    },
    operationPrices: {
      title: "Стоимость операций",
      subtitle: "Сколько токенов списывается за операцию. Цены одни для всех тарифов.",
      colOperation: "Операция",
      colPrice: "Стоимость",
      tokenOne: "{n} токен",
      tokenFew: "{n} токена",
      tokenMany: "{n} токенов",
      empty: "Цены операций пока не заданы",
      emptyHint: "Как только биллинг их опубликует, они появятся здесь",
      unavailable: "Биллинг пока не отдаёт стоимость операций. Попробуйте позже.",
    },
    history: {
      colDate: "Дата",
      colOperation: "Операция",
      colProfile: "Сотрудник",
      colProduct: "Продукт",
      colEvent: "Событие",
      colAmount: "Токены",
      colStatus: "Статус",
      filterPeriod: "Период",
      filterFrom: "С",
      filterTo: "По",
      filterProduct: "Продукт",
      filterType: "Тип",
      filterStatus: "Статус",
      filterReset: "Сбросить",
      loadMore: "Загрузить ещё",
      empty: "За выбранный период ничего не найдено",
    },
    employees: {
      searchPlaceholder: "Поиск по ФИО или email",
      filterAll: "Все",
      filterActive: "Активные",
      filterDisabled: "Отключённые",
      kebabHint: "Действия",
      empty: "У этого клиента пока нет сотрудников",
    },
    profileModal: {
      title: "Сотрудник",
      sectionAccount: "Аккаунт",
      sectionBalance: "Баланс клиента",
      statusLabel: "Статус",
      rolesLabel: "Роли",
      save: "Сохранить",
      disable: "Отключить",
      disableConfirmTitle: "Отключить сотрудника?",
      disableConfirmMessage:
        "Аккаунт сотрудника {name} будет переведён в статус «Отключён». Это действие можно отменить, сохранив активный статус.",
      saveSuccess: "Аккаунт обновлён",
      disabled: "Сотрудник отключён",
      saveError: "Не удалось сохранить аккаунт",
      disableError: "Не удалось отключить сотрудника",
      idLabel: "ID {id}",
      balanceAvailable: "Доступно",
      balanceFrozen: "Заморожено",
      balanceTariff: "Тариф «{name}»",
      balanceUpdate: "обновится {date} в 00:00",
      balanceMissing: "Баланс пока недоступен",
    },
    paymentConfirm: {
      title: "Оплата",
      purchaseLabel: "Покупка",
      amountLabel: "К оплате",
      tariffName: "Тариф «{name}»",
      tokensName: "Докупка {count} токенов",
      agreementPrefix: "Я принимаю",
      agreementLink: "пользовательское соглашение",
      pay: "Оплатить",
      cancel: "Отмена",
    },
    purchase: {
      title: "Подключение тарифа",
      titleExtend: "Продление тарифа",
      durationLabel: "Длительность",
      monthsOne: "месяц",
      monthsFew: "месяца",
      monthsMany: "месяцев",
      discountBadge: "−{percent}%",
      activationLabel: "Активация",
      activationImmediate: "Сразу",
      activationImmediateHint: "Пакет активируется сразу после оплаты",
      activationDeferred: "После текущего пакета",
      activationDeferredHint: "Новый тариф включится после окончания текущего тарифа",
      activationDeferredHintDated: "Новый тариф включится {date}, после окончания текущего тарифа",
      priceLabel: "К оплате",
      confirmApply: "Оплатить и подключить",
      confirmExtend: "Оплатить и продлить",
      queuedPackageExists: "У вас уже есть пакет в очереди — дождитесь его активации, прежде чем ставить следующий",
      generateInvoice: "Сформировать счёт для юр. лиц",
      invoiceError: "Не удалось сформировать счёт",
    },
    freeTariff: {
      title: "Переход на бесплатный тариф",
      recommendation: "Рекомендуем дождаться завершения текущего платного тарифа",
      warningDated:
        "Оплаченный тариф действует до {date}. При переходе сейчас остаток пакета сгорает — вернуть его нельзя.",
      warning: "При переходе сейчас остаток оплаченного пакета сгорает — вернуть его нельзя.",
      packageNote: "На бесплатном тарифе доступен базовый пакет — {tokens} токенов.",
      cancel: "Остаться на текущем",
      confirm: "Перейти на бесплатный",
      success: "Тариф «Бесплатно» подключён",
      error: "Не удалось перейти на бесплатный тариф",
    },
    return: {
      title: "Спасибо за оплату!",
      text: "Идёт проверка платежа. Как только банк подтвердит оплату, токены будут зачислены — обычно это занимает несколько минут.",
      toBilling: "Вернуться к биллингу",
    },
    states: {
      loading: "Загрузка",
      empty: "Здесь пока пусто",
      error: "Не удалось загрузить данные",
      retry: "Повторить",
    },
    noClients: "У вас пока нет клиентов с подключённым биллингом",
    tariffs: {
      sectionTitle: "Тарифы",
      sectionSubtitle: "Чем крупнее тариф, тем выгоднее цена за токен",
      currentBadge: "Текущий",
      recommendedBadge: "Рекомендуем",
      perMonth: "в месяц",
      free: "Бесплатно",
      packageTokens: "{tokens} токенов в пакете",
      packageNone: "Базовый доступ без пакета токенов",
      perTokenNote: "≈ {price} за токен",
      connect: "Подключить",
      switchTo: "Перейти на {name}",
      switchToFree: "Перейти на бесплатный",
      extend: "Продлить тариф",
      currentUntil: "Пакет действует до {date}",
      connecting: "Открываем оплату…",
      currentPlan: "Подключён",
      buyError: "Не удалось открыть страницу оплаты",
      pricingError: "Не удалось загрузить цены по длительности — доступна оплата за 1 месяц",
      loadError: "Не удалось загрузить тарифы",
      retry: "Повторить",
    },
    calculator: {
      title: "Калькулятор расхода токенов",
      subtitle: "Укажите объём операций в месяц или пройдите квиз — подскажем тариф",
      modelTitle: "Как считаются токены",
      tokenPerOp: "{weight} токен / операция",
      groupBase: "База",
      groupBaseHint: "проценка, VIN, номер машины",
      groupSmart: "Умный запрос",
      groupSmartHint: "ИИ по каталогу",
      groupHeavy: "Тяжёлый AI",
      groupHeavyHint: "тяжёлые AI-сценарии",
      opHeader: "Операция",
      weightHeader: "Токенов",
      qtyHeader: "Кол-во / мес",
      subtotalHeader: "Итого",
      totalLabel: "Всего токенов в месяц",
      mixLabel: "База {base} · умные {smart}",
      recommendedLabel: "Рекомендуемый тариф",
      recommendedNone: "Введите объёмы или пройдите квиз",
      extraLabel: "Оценка стоимости сверх пакета",
      extraNote:
        "В тарифе «{name}» доступно {included} токенов в месяц. Для объёма сверх пакета нужно отдельно докупить {tokens} постоянных токенов — они не сгорают и тратятся после дневного лимита, {price} ₽ за токен.",
      reset: "Очистить",
      quiz: "Подобрать через квиз",
      connect: "Подключить",
      increase: "Увеличить",
      decrease: "Уменьшить",
      operations: {
        supplier_quote: "Проценка по поставщикам",
        catalog_plate: "Каталог по гос. номеру автомобиля",
        catalog_vin: "Каталог по VIN автомобиля",
        order_create: "Оформление заказа",
        ai_catalog: "ИИ-поиск по каталогу",
      },
      presets: {
        store_1m: "Магазин",
        sto_3: "СТО, 3 поста",
        fleet_50: "Автопарк, 50 авто",
      },
    },
    quiz: {
      title: "Быстрый подбор тарифа",
      next: "Далее",
      back: "Назад",
      close: "Закрыть",
      apply: "Подставить в калькулятор",
      resultTitle: "Рекомендация готова",
      resultSubtitle: "Стартовый сценарий подставим в калькулятор",
      resultTokens: "≈ {tokens} токенов в месяц",
      resultTariff: "Рекомендуемый тариф: {name}",
      step1Title: "Какой у вас бизнес?",
      step1Subtitle: "От типа зависит логика расчёта стартовой нагрузки",
      step2StoreTitle: "Объём закупок в месяц?",
      step2StoTitle: "Сколько у вас постов?",
      step2FleetTitle: "Сколько единиц техники в парке?",
      profiles: {
        store: "Магазин",
        storeHint: "Розница, опт, отдел закупок, активная проценка",
        sto: "СТО",
        stoHint: "Подбор деталей под ремонт, работа по постам",
        fleet: "Транспортная компания",
        fleetHint: "Свой парк, централизованные закупки и обслуживание",
      },
      store: {
        "500k": "0 – 500 тыс ₽",
        "1m": "500 тыс – 1 млн ₽",
        "2m": "1 – 2 млн ₽",
        "5m": "2 – 5 млн ₽",
        "5mplus": "5 млн ₽ и выше",
      },
      sto: {
        "1": "1 пост",
        "2": "2 поста",
        "3": "3 поста",
        "5": "4–5 постов",
        "8": "6+ постов",
      },
      fleet: {
        "20": "До 20 единиц",
        "50": "20–50 единиц",
        "100": "50–100 единиц",
        "300": "100+ единиц",
      },
    },
    buyTokens: {
      title: "Докупить токены",
      subtitle:
        "Постоянные токены не сгорают и тратятся после дневного лимита, но стоят дороже пакетных — большие объёмы дешевле покрывать тарифом",
      label: "Сколько токенов",
      perToken: "{price} ₽ за токен",
      total: "Итого {sum} ₽",
      cta: "Перейти к оплате",
      hint: "Стоимость рассчитается на странице оплаты",
      error: "Не удалось открыть страницу оплаты",
    },
  },
};
